//@ts-nocheck
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '@banno/jha-wc/src/jha-dialog/jha-dialog';
import '@banno/jha-wc/src/progress/jha-progress-linear/jha-progress-linear';
import '@banno/jha-wc/src/sliders/jha-slider/jha-slider';
import '@banno/jha-wc/src/sliders/jha-slider-content/jha-slider-content';
import '@banno/jha-wc/src/sliders/jha-slider-pane/jha-slider-pane';
import '@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input';
import '@banno/jha-wc/src/forms/jha-form-textarea-input/jha-form-textarea-input';
import '@banno/jha-wc/src/forms/jha-form-radio-button/jha-form-radio-button';
import '@banno/jha-wc/src/buttons/jha-button/jha-button';
import '@banno/jha-wc/src/forms/jha-form-select/jha-form-select';
import '@banno/jha-wc/src/icons/jha-icon-information';
import '@banno/jha-wc/src/icons/jha-icon-show';
import { getRequest, fixedEncodeURIComponent } from '../../utils/jha-fetch';
import { Apis } from '../../utils/api-constants';
import { getRoleData } from '../../utils/getRoleData';
import { mapStepFunctionOptions } from '../../utils/step-function-display';
import { GlobalVariables } from '../../utils/constants';
import { showToastMessage, stringComparison, getEnvApiUrl } from '../../utils/app-utils';
import { getErrorMessage } from '../../utils/getErrorMessage';
import {
    normalizeInstitution,
    InstitutionListResponse,
} from '../../types/BusinessUnits/InstitutionType';
import { readInstitutionUuidFromStep } from '../../utils/workflow-institution-step';
import { isInitialInstitutionFeatureEnabled } from '../../utils/initial-institution-feature-gate';
import formElementMixin from '@banno/jha-wc/src/js/mixins/form-element-mixin';
import '../../Components/MaskInputField';


/**
 * WORKFLOW TEMPLATES INTEGRATION
 * The following imports and features support the Workflow Templates page.
 * When useTemplateVariables=true, text fields render as template-string-input
 * components that allow users to insert template variables (e.g., {variableName}).
 * This enables workflow templates to have parameterized step definitions.
 */
import '../../Components/TemplateStringInput';
import { openJhftDialog } from '../../Components/JhftJhaDialog';
import {
    applyWorkflowStepPopupBaselineDefaults,
    captureWorkflowStepPopupBaseline,
    isWorkflowStepPopupDirty,
    type WorkflowStepPopupSnapshotInput,
} from '../../utils/workflow-step-popup-dirty';
import { WorkflowTemplateVariable } from '../../types/WorkflowTemplates/WorkflowTemplateVariable';
import {
    BUILTIN_BUSUNIT_PLACEHOLDER,
    BUILTIN_REGION_PLACEHOLDER,
    BUILTIN_REGION_VARIABLE,
    extractTemplateVariableNames,
    isBuiltinBusUnitVariableName,
    isBuiltinRegionPlaceholderString,
    isBuiltinRegionVariableName,
    isTemplatePullSmbBucketStep,
    toPersistedTemplatePullSmbBucketName,
    stripTemplateVariablePlaceholders,
    valueIsSingleTemplateVariablePlaceholder,
} from '../../utils/workflowTemplatePlaceholderSyntax';
import {
    normalizeSftpAuthType,
    SFTP_AUTH_TYPE,
    SFTP_AUTH_TYPE_FORM_OPTIONS,
    isSftpSshKeyAuthType,
} from '../../constants/sftp-auth-type';
import {
    looksLikeSshPrivateKeyPem,
    validateSftpSshPrivateKeyMaterial,
} from '../../utils/sftp-ssh-private-key-validation';
import {
    AZURE_CONNECTION_STRING_REQUIRED_WARNING,
    azureConnectionStringWarning,
    isMaskedAzureConnectionString,
} from '../../utils/azure-storage-connection-string';
import {
    AWS_IAM_ROLE_ARN_REQUIRED_WARNING,
    awsIamRoleArnWarning,
    isMaskedAwsIamRoleArn,
} from '../../utils/aws-iam-role-arn';
import { getSftpPrivateKeyFileTooLargeMessage } from '../../utils/sftp-ssh-private-key-upload';
import {
    editModeUsesMaskedSftpPrivateKeyTextarea,
    isSftpPrivateKeyMaskedSummaryUi,
} from '../../utils/sftp-ssh-key-ui-state';
import { isSftpSshKeyAuthFeatureEnabled } from '../../utils/sftp-ssh-key-feature-gate';
import { isWorkflowStepTestConnectionUiEnabled } from '../../utils/workflow-step-test-connection-feature-gate';
import {
    buildSftpStepSnapshotForConnectivityTest,
    canRunWorkflowStepSftpConnectivityTest,
    inferSftpTestLeg,
    parseWorkflowStepTestConnectionResponse,
    postWorkflowStepTestConnection,
    resolveWorkflowStepIndexForTestConnection,
} from '../../utils/workflow-step-test-connection';
import { resolveWorkflowPathSegment } from '../../utils/workflow-source-location-path';
import {
    coerceFileRenameMap,
    readBucketRenameFromLocation,
    readBucketRenameFromStep,
    readFileMovePatternFromStep,
    readFileRenameFromLocation,
    readFileRenameFromStep,
} from '../../utils/workflow-file-info-leg';
import {
    computeViewOnlyAuthModeSummary,
} from '../../utils/sftp-auth-mode-display';
import {
    BUCKET_ROLE_CACHE,
    BUCKET_ROLE_FILE_PICKUP,
    BUCKET_ROLE_HOME,
    BUCKET_ROLE_SMB,
    PULL_FILECOPY_DEST_ROLE_FORM_OPTIONS,
    isPullSmbDestinationBucket,
    isValidBucketRoleToken,
    resolveLegacyBucketRoleToken,
} from '../../utils/bucket-roles';

/**
 * Bucket / container name shapes, kept in step with the workflow-service validators
 * (`AppConstants.S3BucketRegex`, `GcsBucketRegex`, `AzureContainerRegex`). S3 and GCS
 * bound the middle at 1-61 characters, which is what forces the 3-63 overall length.
 */
const S3_BUCKET_NAME_REGEX = /^[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/;
const GCS_BUCKET_NAME_REGEX = /^[a-z0-9][a-z0-9._-]{1,61}[a-z0-9]$/;
const AZURE_CONTAINER_NAME_REGEX = /^[a-z0-9]([a-z0-9]|-(?!-))*[a-z0-9]$|^[a-z0-9]$/;
/** S3 rejects names that parse as an IPv4 address (e.g. `10.0.0.1`). */
const IPV4_SHAPED_BUCKET_REGEX =
    /^((2(5[0-5]|[0-4][0-9])|[01]?[0-9]{1,2})\.){3}(2(5[0-5]|[0-4][0-9])|[01]?[0-9]{1,2})$/;

const S3_BUCKET_NAME_MESSAGE =
    'Bucket name must be 3-63 characters using lowercase letters, numbers, dots or hyphens, and must start and end with a letter or number.';
const GCS_BUCKET_NAME_MESSAGE =
    'Bucket name must be 3-63 characters using lowercase letters, numbers, dots, underscores or hyphens, and must start and end with a letter or number.';
const AZURE_CONTAINER_NAME_MESSAGE =
    'Container name must use lowercase letters, numbers and single hyphens, and must start and end with a letter or number.';
const BUCKET_NAME_IP_MESSAGE = 'Bucket name cannot be formatted as an IP address.';

@customElement('add-workflow-step-popup')
export class AddWorkflowStepPopup extends formElementMixin(LitElement) {
    /**
     * Constructor
     *
     * WORKFLOW TEMPLATES INTEGRATION:
     * The last two parameters (useTemplateVariables, variables) were added to support
     * the Workflow Templates page. When useTemplateVariables=true, text input fields
     * are rendered as template-string-input components that allow variable insertion.
     *
     * @param item - Transfer type or step data for editing
     * @param isEdit - Whether this is an edit operation
     * @param lastDelete - Whether a previous step has deleteSourceFile enabled
     * @param workflowTranferType - The workflow's transfer type (push/pull)
     * @param isClone - Whether this is a clone operation
     * @param workflowName - Name of the workflow
     * @param buName - Business unit name
     * @param isViewOnly - Whether to render in view-only mode
     * @param useTemplateVariables - [Workflow Templates] Enable template variable support
     * @param variables - [Workflow Templates] Array of available template variables
     */
    constructor(
        item,
        isEdit,
        lastDelete,
        workflowTranferType,
        isClone,
        workflowName,
        buName,
        isViewOnly,
        useTemplateVariables = false,
        variables = []
    ) {
        super();
        this.transferType = item;
        this.workflowTransferType = workflowTranferType;
        // Deep clone the edit data to prevent mutations from affecting the original object.
        // This fixes the bug where unsaved changes persist after exiting the wizard.
        // Also preserves original values for credential fields like RoleARN/Region.
        // Keep a non-Lit copy — @property editData can be reset to {} during lookups.
        this.editStepSnapshot = isEdit == true ? JSON.parse(JSON.stringify(item)) : null;
        this.editData = this.editStepSnapshot ?? this.formData;
        if (this.editStepSnapshot) {
            this.seedRetainedFromStep(this.editStepSnapshot);
        }
        this.isEdit = isEdit;
        this.lastDelete = lastDelete;
        this.isClone = isClone;
        this.workflowName = workflowName ?? '';
        this.buName = buName;
        this.isViewOnly = isViewOnly;
        this.useTemplateVariables = useTemplateVariables;
        this.variables = variables;
    }

    // ============================================
    // WORKFLOW TEMPLATES INTEGRATION PROPERTIES
    // These properties enable template variable support for the Workflow Templates page.
    // When useTemplateVariables=true, text fields render as template-string-input
    // components that allow users to insert template variables like {businessUnit} or {fileName}.
    // ============================================

    /**
     * [Workflow Templates] Enable template-string-input support for text fields.
     * When true, text fields will use template-string-input instead of jha-form-input,
     * allowing users to insert template variables.
     */
    @property({ type: Boolean })
    useTemplateVariables = false;

    /**
     * [Workflow Templates] Array of template variables available for selection.
     * These are displayed in the variable dropdown when the user clicks the
     * variable icon or types '{' in a template-string-input field.
     */
    @property({ type: Array })
    variables: WorkflowTemplateVariable[] = [];

    /**
     * Prevents dialog from closing on backdrop click (for dialog-util)
     * When true, backdrop clicks are ignored by dialog-util's handleBackgroundClick
     */
    @property({ type: Boolean })
    hideCancel = true;

    /**
     * [Workflow Templates] Get variable options formatted for template-string-input (sorted alphabetically).
     * Transforms WorkflowTemplateVariable[] to the format expected by template-string-input.
     */
    get variableOptions() {
        return this.variables
            .map((v) => ({
                name: v.name,
                value: v.name,
                description: v.description,
            }))
            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }

    /**
     * True when Storage Type is SFTP — uses setStorage() flag and form values so the UI stays correct
     * if flags desync (e.g. mixed-case API) or before setStorage runs.
     */
    private isSftpStorageEndpointSelected(): boolean {
        const st = this.formData.storageType ?? this.formData.StorageType;
        return (
            this.SFTP ||
            String(st ?? '')
                .trim()
                .toLowerCase() === 'sftp'
        );
    }

    /** True when the step targets SFTP and SSH key auth is selected. */
    private isSftpSshKeyAuth(): boolean {
        return this.isSftpStorageEndpointSelected() && isSftpSshKeyAuthType(this.formData.AuthType);
    }

    /** Story 2.3: show stored-key summary + Replace instead of PEM textarea. */
    private get sftpPrivateKeyMaskedSummary(): boolean {
        return isSftpPrivateKeyMaskedSummaryUi({
            isSftpSshKeyAuth: this.isSftpSshKeyAuth(),
            isEdit: !!this.isEdit,
            isClone: !!this.isClone,
            secretValue: this.formData.secretValue as Record<string, unknown> | undefined,
            replaceMode: this.sftpSshKeyReplaceMode,
            useTemplateVariables: this.useTemplateVariables,
            privateKey: (this.formData.privateKey ?? '') as string,
        });
    }

    private get editModeUsesMaskedPrivateKeyTextarea(): boolean {
        return editModeUsesMaskedSftpPrivateKeyTextarea({
            isEdit: !!this.isEdit,
            isClone: !!this.isClone,
            secretValue: this.formData.secretValue as Record<string, unknown> | undefined,
            replaceMode: this.sftpSshKeyReplaceMode,
            privateKey: this.formData.privateKey as string | undefined,
        });
    }

    private onSftpReplaceKeyClick() {
        if (this.isViewOnly) {
            return;
        }
        this.sftpSshKeyReplaceMode = true;
        this.formData.privateKey = '';
        this.sftpPrivateKeyFormatMessage = '';
        this.secondPageSshKeyRefWarning = false;
        if (this.formData.secretValue && typeof this.formData.secretValue === 'object') {
            const sv = { ...(this.formData.secretValue as Record<string, unknown>) };
            delete sv.privateKey;
            delete sv.SshPrivateKeyReference;
            delete sv.sshPrivateKeyReference;
            this.formData.secretValue = sv;
        }
        this.requestUpdate();
    }

    private get sftpPrivateKeyCloneMissingRef(): boolean {
        return !!(
            this.isClone &&
            this.formData.secretValue &&
            !('privateKey' in this.formData.secretValue) &&
            !('SshPrivateKeyReference' in this.formData.secretValue) &&
            !('sshPrivateKeyReference' in this.formData.secretValue) &&
            !this.formData.privateKey
        );
    }

    /**
     * New step / clone-without-key: textarea is required unless the user uploads a file (same field).
     * Edit with stored key: optional — avoids "(optional)" + required asterisk contradiction.
     */
    private get isSftpPrivateKeyTextareaRequired(): boolean {
        if (this.sftpSshKeyReplaceMode) {
            return true;
        }
        return (
            !this.isEdit ||
            (this.isClone &&
                (!this.formData.secretValue ||
                    (!('privateKey' in this.formData.secretValue) &&
                        !('SshPrivateKeyReference' in this.formData.secretValue) &&
                        !('sshPrivateKeyReference' in this.formData.secretValue))))
        );
    }

    get sftpPrivateKeyTextareaLabel(): string {
        return this.isSftpPrivateKeyTextareaRequired
            ? 'SSH Private Key'
            : 'SSH Private Key (optional)';
    }

    get sftpPrivateKeyFieldShowWarning(): boolean {
        return (
            this.secondPageSshKeyRefWarning ||
            this.sftpPrivateKeyCloneMissingRef ||
            !!this.sftpPrivateKeyFormatMessage
        );
    }

    get sftpPrivateKeyFieldWarningText(): string {
        if (this.sftpPrivateKeyFormatMessage) {
            return this.sftpPrivateKeyFormatMessage;
        }
        if (this.sftpPrivateKeyMaskedSummary) {
            return 'A private key is stored for this step. It is not shown. Use Replace key to rotate.';
        }
        return 'Enter an SSH private key — paste below or use Upload key file.';
    }

    /**
     * When the field looks like a PEM private key, returns a user-facing error if MVP rules fail.
     * Secrets Manager references and non-PEM text return null (no client PEM error).
     */
    private getSftpPrivateKeyPemFormatError(): string | null {
        if (!this.SFTP || !this.isSftpSshKeyAuth()) {
            return null;
        }
        const pk = (this.formData.privateKey ?? '').trim();
        if (!pk || pk === '*****') {
            return null;
        }
        if (this.useTemplateVariables) {
            if (looksLikeSshPrivateKeyPem(pk)) {
                return 'Workflow templates cannot store raw private key PEM. Use a template variable for a Secrets Manager secret name or ARN; paste or upload the key when you generate a workflow from this template.';
            }
            return null;
        }
        if (!looksLikeSshPrivateKeyPem(pk)) {
            return null;
        }
        const r = validateSftpSshPrivateKeyMaterial(pk);
        return r.valid ? null : r.userMessage;
    }

    private refreshSftpPrivateKeyClientValidation() {
        if (!this.isSftpSshKeyAuth() || !this.SFTP) {
            this.sftpPrivateKeyFormatMessage = '';
            return;
        }
        this.sftpPrivateKeyFormatMessage = this.getSftpPrivateKeyPemFormatError() ?? '';
    }

    /** Specific save/next message when PEM-shaped key fails MVP rules (FR28). */
    private getSftpPrivateKeyBlockingMessage(): string | null {
        return this.getSftpPrivateKeyPemFormatError();
    }

    /**
     * SSH key textarea: do not use formElementMixin.inputValueChange for change/focusout.
     * That mixin reads evt.detail as the value (correct for JHA CustomEvent "change"), but
     * native focusout is a FocusEvent whose detail is often 0 — which incorrectly wrote
     * privateKey as the number 0 (serialized as "0" on save).
     */
    onSftpPrivateKeyNonTemplateInput(e: Event) {
        const host = e.currentTarget as unknown as { value?: string };
        this.updateProperty('privateKey', host.value ?? '');
        this.refreshSftpPrivateKeyClientValidation();
    }

    onSftpPrivateKeyNonTemplateFocusOut(e: Event) {
        const host = e.currentTarget as unknown as { value?: string };
        this.updateProperty('privateKey', host.value ?? '');
        this.refreshSftpPrivateKeyClientValidation();
    }

    onSftpPrivateKeyUploadButtonClick() {
        const input = this.shadowRoot?.querySelector(
            '[data-auto-id="sftpPrivateKeyFileInput"]'
        ) as HTMLInputElement | null;
        input?.click();
    }

    onSftpPrivateKeyFileSelected(e: Event) {
        const input = e.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) {
            return;
        }
        const tooLarge = getSftpPrivateKeyFileTooLargeMessage(file.size);
        if (tooLarge) {
            showToastMessage(tooLarge, 'danger');
            input.value = '';
            return;
        }
        const reader = new FileReader();
        reader.onerror = () => {
            showToastMessage('Could not read the selected key file. Try again or paste the key instead.', 'danger');
            input.value = '';
        };
        reader.onload = () => {
            const text = typeof reader.result === 'string' ? reader.result : '';
            // Same as paste: updateProperty syncs formElementMixin formValid (direct formData assignment does not).
            this.updateProperty('privateKey', text);
            input.value = '';
            this.refreshSftpPrivateKeyClientValidation();
            this.requestUpdate();
        };
        reader.readAsText(file, 'UTF-8');
    }

    /** Add / clone-missing-credentials: plain Port field uses digits-only pattern (not template variables). */
    private requiresPlainSftpPortFormat(): boolean {
        return !this.isEdit || (this.isClone && this.formData.secretValue?.Port === undefined);
    }

    /**
     * Regular (non-template) Azure Connection String: required+format on create, clone-missing,
     * or edit after the user replaces the masked secret.
     */
    private requiresPlainAzureConnectionString(): boolean {
        if (this.useTemplateVariables) return false;
        if (!this.isEdit || (this.isClone && this.formData.secretValue?.ConnectionString === undefined)) {
            return true;
        }
        return this.azureConnectionStringUserEdited === true;
    }

    private getAzureConnectionStringInput(): string {
        const displayed = String(this.formData.ConnectionString ?? '');
        if (isMaskedAzureConnectionString(displayed) && this.retainConnectionString) {
            return String(this.retainConnectionString).replace(/\s+/g, '');
        }
        return displayed.replace(/\s+/g, '');
    }

    private isAzureConnectionStringFieldValid(): boolean {
        if (!this.AZURE) return true;
        if (this.useTemplateVariables) {
            if (!this.isEdit && !this.hasValueOrVariable(this.formData.ConnectionString)) return false;
            return true;
        }
        if (!this.requiresPlainAzureConnectionString()) return true;
        const v = this.getAzureConnectionStringInput();
        if (isMaskedAzureConnectionString(v)) return true;
        return azureConnectionStringWarning(v, { required: true }) === null;
    }

    get connectionStringFieldWarningMessage(): string {
        if (!this.requiresPlainAzureConnectionString()) {
            return AZURE_CONNECTION_STRING_REQUIRED_WARNING;
        }
        const v = this.getAzureConnectionStringInput();
        return azureConnectionStringWarning(v, { required: true }) ?? AZURE_CONNECTION_STRING_REQUIRED_WARNING;
    }

    get shouldShowAzureConnectionStringWarning(): boolean {
        if (!this.AZURE || this.useTemplateVariables) return false;
        if (!this.requiresPlainAzureConnectionString()) return false;
        const v = this.getAzureConnectionStringInput();
        const msg = azureConnectionStringWarning(v, { required: true });
        if (!msg) return false;
        if (msg === AZURE_CONNECTION_STRING_REQUIRED_WARNING) {
            return (
                this.secondPageConnectionStringWarning ||
                (this.isClone &&
                    this.formData.secretValue?.ConnectionString === undefined &&
                    !v)
            );
        }
        return true;
    }

    /**
     * Regular (non-template) Role ARN: required+format on create, clone-missing,
     * or edit after the user replaces the masked secret.
     */
    private requiresPlainAwsIamRoleArn(): boolean {
        if (this.useTemplateVariables) return false;
        if (!this.isEdit || (this.isClone && this.formData.secretValue?.RoleARN === undefined)) {
            return true;
        }
        return this.roleArnUserEdited === true;
    }

    private isAwsIamRoleArnFieldValid(): boolean {
        if (!this.AMAZONS3REMOTE) return true;
        if (this.useTemplateVariables) {
            if (!this.isEdit && !this.hasValueOrVariable(this.formData.RoleARN)) return false;
            return true;
        }
        if (!this.requiresPlainAwsIamRoleArn()) return true;
        const v = String(this.formData.RoleARN ?? '').trim();
        if (isMaskedAwsIamRoleArn(v)) return true;
        return awsIamRoleArnWarning(v, { required: true }) === null;
    }

    /**
     * Edit displays Region as ***** (not in the region list), which can clear formData.
     * Treat that as an unchanged secret — same skip as Role ARN format on edit.
     */
    private hasAwsS3RemoteRegionValue(): boolean {
        if (this.hasValueOrVariable(this.formData.Region)) return true;
        if (isMaskedAwsIamRoleArn(this.formData.Region)) return true;
        if (this.useTemplateVariables) return false;
        if (!this.isEdit || (this.isClone && this.formData.secretValue?.Region === undefined)) {
            return false;
        }
        return true;
    }

    get roleArnFieldWarningMessage(): string {
        if (!this.requiresPlainAwsIamRoleArn()) {
            return AWS_IAM_ROLE_ARN_REQUIRED_WARNING;
        }
        const v = String(this.formData.RoleARN ?? '').trim();
        return awsIamRoleArnWarning(v, { required: true }) ?? AWS_IAM_ROLE_ARN_REQUIRED_WARNING;
    }

    get shouldShowAwsIamRoleArnWarning(): boolean {
        if (!this.AMAZONS3REMOTE || this.useTemplateVariables) return false;
        if (!this.requiresPlainAwsIamRoleArn()) return false;
        const v = String(this.formData.RoleARN ?? '').trim();
        const msg = awsIamRoleArnWarning(v, { required: true });
        if (!msg) return false;
        if (msg === AWS_IAM_ROLE_ARN_REQUIRED_WARNING) {
            return (
                this.secondPageRoleARNWarning ||
                (this.isClone &&
                    this.formData.secretValue?.RoleARN === undefined &&
                    !v)
            );
        }
        return true;
    }

    private isPlainSftpPortValid(port: string | undefined | null): boolean {
        if (!this.requiresPlainSftpPortFormat()) return true;
        const t = (port ?? '').trim();
        if (!t) return false;
        if (!/^\d+$/.test(t)) return false;
        const n = parseInt(t, 10);
        return n >= 1 && n <= 65535;
    }

    /**
     * Shown when jha-form-input Port fails native pattern/required checks after blur.
     * Avoid labeling non-numeric input as "required".
     */
    get portFieldWarningMessage(): string {
        if (!this.requiresPlainSftpPortFormat()) {
            return 'Port is required';
        }
        const port = (this.formData.Port ?? '').trim();
        if (!port) return 'Port is required';
        if (!/^\d+$/.test(port)) {
            return 'Port must be a number (e.g. 22)';
        }
        const n = parseInt(port, 10);
        if (n < 1 || n > 65535) {
            return 'Port must be between 1 and 65535';
        }
        return 'Port is required';
    }

    /**
     * Port passes native ^[0-9]+$ but may still be invalid (e.g. 0, 65536). Drive showWarning so the message appears.
     */
    get shouldShowPortOutOfRangeWarning(): boolean {
        if (!(this.SFTP || this.FTPS) || this.useTemplateVariables) return false;
        if (!this.requiresPlainSftpPortFormat()) return false;
        const port = (this.formData.Port ?? '').trim();
        if (!port || !/^\d+$/.test(port)) return false;
        const n = parseInt(port, 10);
        return n < 1 || n > 65535;
    }

    /**
     * [Workflow Templates] Handle variable-added event from template-string-input.
     * When a user creates a new variable inline, this propagates the event up
     * to the parent component so it can be added to the settings tab.
     * Also adds the variable to the local array so other dropdowns in this popup see it.
     */
    onVariableAdded(e: CustomEvent) {
        e.stopPropagation();

        // Add the new variable to the local variables array so other dropdowns see it immediately
        // TemplateStringInput now dispatches camelCase (name, description, etc.)
        const newVar = {
            name: e.detail.name,
            description: e.detail.description || '',
            regexRule: e.detail.regexRule || '',
            ruleDescription: e.detail.ruleDescription || '',
        };
        this.variables = [...this.variables, newVar];

        // Propagate the event up to the parent component
        this.dispatchEvent(
            new CustomEvent('variable-added', {
                detail: e.detail,
                bubbles: true,
                composed: true,
            })
        );
    }

    /**
     * [Workflow Templates] Handle change from template-string-input for a specific field.
     * Updates formData with the new value from the template-string-input component.
     * Also clears any variable validation warnings while the user is typing.
     */
    onTemplateInputChange(field: string, e: CustomEvent) {
        // Locked Pull SMB bucket name is set by setStorage(); ignore spurious template-string-input
        // change events that can overwrite the built-in placeholder with a truncated prefix.
        if (
            field === 'name' &&
            this.useTemplateVariables &&
            this.isFolderBucketNameDisable &&
            isTemplatePullSmbBucketStep(
                this.workflowTransferType,
                this.formData.functionName,
                this.formData.storageType
            )
        ) {
            return;
        }
        this.formData[field] = e.detail.value;

        const path = e.composedPath();
        const templateInput = this.useTemplateVariables
            ? (path.find(
                (el) => (el as HTMLElement).tagName?.toLowerCase() === 'template-string-input'
            ) as any)
            : undefined;

        // Clear variable validation warning while user is typing
        // Warning will reappear on blur if undefined variables still exist
        if (this.useTemplateVariables && templateInput) {
            if (
                templateInput.errorText?.includes('not been defined') ||
                (this.isCredentialField(field) &&
                    (templateInput.errorText?.includes('Only variables allowed') ||
                        templateInput.errorText?.includes('must use a variable') ||
                        templateInput.errorText?.includes('Workflow templates cannot')))
            ) {
                templateInput.errorText = '';
                templateInput.forceShowWarning = false;
            }
        }

        if (field === 'privateKey' && this.SFTP && this.isSftpSshKeyAuth()) {
            this.refreshSftpPrivateKeyClientValidation();
            if (this.useTemplateVariables && templateInput) {
                if (this.sftpPrivateKeyFormatMessage) {
                    templateInput.errorText = this.sftpPrivateKeyFormatMessage;
                    templateInput.forceShowWarning = true;
                } else if (templateInput.errorText?.includes('Workflow templates cannot')) {
                    templateInput.errorText = '';
                    templateInput.forceShowWarning = false;
                }
            }
        }

        // [ACME-1503] Path/name shape validation for template literals and mixed {var} frames
        if (field === 'path' || field === 'name') {
            this.refreshTemplatePathOrNameShapeValidity(
                field,
                e.detail.value,
                templateInput
            );
        }

        // Trigger update to reflect validation state changes
        this.requestUpdate();
    }

    /**
     * [Workflow Templates] Handle blur from template-string-input for a specific field.
     *
     * WORKFLOW TEMPLATES ONLY:
     * This method is only active when useTemplateVariables is TRUE. It performs
     * two types of validation on template-string-input fields:
     *
     * 1. CREDENTIAL FIELD VALIDATION:
     *    For fields like HostName, Password, PGPKey, etc., validates that the
     *    value contains ONLY variable placeholders (no literal text). This
     *    prevents storing actual secrets in templates.
     *
     * 2. UNDEFINED VARIABLE VALIDATION:
     *    Checks if any variable placeholders (e.g., {myVar}) reference variables
     *    that haven't been defined in the template's Settings tab.
     *
     * For REGULAR WORKFLOWS (useTemplateVariables = false):
     *    This method returns immediately without any validation. Regular workflows
     *    use standard HTML inputs and allow literal values for all fields.
     */
    onTemplateInputBlur(field: string, e: CustomEvent) {
        // CRITICAL: Only process blur events in template mode.
        // Regular workflows don't use template-string-input components.
        if (!this.useTemplateVariables) return;

        const value = e.detail.value;
        const path = e.composedPath();
        const templateInput = path.find(
            (el) => (el as HTMLElement).tagName?.toLowerCase() === 'template-string-input'
        ) as any;

        if (!templateInput) return;

        // STEP 1: Credential field validation (template mode only)
        // Credential fields must contain only variable placeholders, no literal values.
        // This prevents storing actual passwords, hostnames, etc. in templates.
        const credentialError = this.validateCredentialField(field, value);
        if (credentialError) {
            this.credentialFieldErrors.set(field, credentialError);
            templateInput.errorText = credentialError;
            templateInput.forceShowWarning = true;
            this.requestUpdate();
            return; // Don't check for undefined vars if format is wrong
        } else {
            this.credentialFieldErrors.delete(field);
            // Clear credential-field UI errors before re-running undefined-variable checks
            if (this.isCredentialField(field)) {
                templateInput.errorText = '';
                templateInput.forceShowWarning = false;
            }
        }

        if (field === 'privateKey' && this.SFTP && this.isSftpSshKeyAuth()) {
            this.refreshSftpPrivateKeyClientValidation();
        }

        // STEP 2: Undefined variable validation
        // Check if any {variableName} placeholders reference variables that
        // haven't been defined in the template's Settings tab.
        const placeholders = this.extractVariablePlaceholders(value);
        const undefinedVars = placeholders.filter(
            (p) =>
                !this.definedVarNames.has(p) &&
                !isBuiltinRegionVariableName(p) &&
                !isBuiltinBusUnitVariableName(p)
        );

        if (undefinedVars.length > 0) {
            const varList = undefinedVars.map((v) => `{${v}}`).join(', ');
            const plural = undefinedVars.length > 1 ? 's' : '';
            templateInput.errorText = `Variable${plural} ${varList} ${undefinedVars.length > 1 ? 'have' : 'has'} not been defined`;
            templateInput.forceShowWarning = true;
        } else if (
            field === 'privateKey' &&
            this.SFTP &&
            this.isSftpSshKeyAuth() &&
            this.sftpPrivateKeyFormatMessage
        ) {
            templateInput.errorText = this.sftpPrivateKeyFormatMessage;
            templateInput.forceShowWarning = true;
        } else if (field === 'path' || field === 'name') {
            // [ACME-1503] Shape validation after credential / undefined-variable checks
            this.refreshTemplatePathOrNameShapeValidity(field, value, templateInput);
        }

        this.requestUpdate();
    }

    /**
     * Handle template input changes for file rename fields and trigger UI updates
     * so reminders appear immediately.
     */
    onTemplateRenameChange(field: string, e: CustomEvent) {
        this.formData[field] = e.detail.value;
        this.requestUpdate();
    }

    /**
     * [Workflow Templates] Get form validity when using template variables.
     * The native formValid from formElementMixin doesn't work with template-string-input
     * because it's a custom element, not a native form input.
     * This getter checks formData values directly instead of relying on native form validation.
     */
    get templateFormValid(): boolean {
        // Check all required fields have non-empty values
        const hasLocationType = this.hasValueOrVariable(this.formData.locationType);
        const hasName = this.hasValueOrVariable(this.formData.name);
        const hasPath = this.hasValueOrVariable(this.formData.path);

        // Basic required fields
        if (!hasLocationType) return false;

        // For SFTP/FTPS, check name; otherwise check path
        if (this.SFTP || this.FTPS) {
            if (!hasName) return false;
            if (!this.bucketNameValid) return false;
        } else {
            if (!hasPath) return false;
            if (!this.bucketPathValid) return false;
            if (!this.isBucketRename && hasName && !this.bucketNameValid) return false;
        }

        // For encryption, check PGP key (unless editing)
        if (this.FileEncrypt && !this.isEdit) {
            if (!this.hasValueOrVariable(this.formData.PGPKey)) return false;
        }

        // Azure Connection String: template = presence; regular = required+format (skip unchanged edit mask)
        if (this.AZURE && !this.isAzureConnectionStringFieldValid()) return false;

        // Amazon S3 Remote: template = presence; regular = required+format (skip unchanged edit mask)
        if (this.AMAZONS3REMOTE) {
            if (!this.isAwsIamRoleArnFieldValid()) return false;
            if (!this.hasAwsS3RemoteRegionValue()) return false;
        }

        // For SFTP/FTPS, check host, port, user, and password OR SSH key reference (SFTP only)
        if (this.SFTP || this.FTPS) {
            if (!this.hasValueOrVariable(this.formData.HostName)) return false;
            if (!this.hasValueOrVariable(this.formData.Port)) return false;
            if (!this.useTemplateVariables && !this.isPlainSftpPortValid(this.formData.Port)) return false;
            if (!this.hasValueOrVariable(this.formData.UserName)) return false;
            if (this.isSftpSshKeyAuth()) {
                if (!this.isEdit && !this.hasValueOrVariable(this.formData.privateKey)) return false;
                if (
                    this.sftpSshKeyReplaceMode &&
                    !this.hasValueOrVariable(this.formData.privateKey)
                ) {
                    return false;
                }
                if (this.getSftpPrivateKeyBlockingMessage()) return false;
            } else {
                if (!this.isEdit && !this.hasValueOrVariable(this.formData.Password)) return false;
            }
        }

        // Check for any credential field validation errors (must be variable-only)
        if (this.credentialFieldErrors.size > 0) return false;

        // Validate all credential fields are variable-only (proactive check)
        if (!this.validateAllCredentialFields()) return false;

        if (!this.passesInternalS3ManagedRoleValidation()) {
            return false;
        }

        return true;
    }

    /**
     * Validate all credential fields have variable-only values.
     * Returns false if any field contains a literal value.
     */
    private validateAllCredentialFields(): boolean {
        // Map field names to formData properties
        const fieldsToCheck: Array<{ field: string; value: string | undefined }> = [];

        if (this.SFTP || this.FTPS) {
            fieldsToCheck.push(
                { field: 'HostName', value: this.formData.HostName },
                { field: 'Port', value: this.formData.Port },
                { field: 'UserName', value: this.formData.UserName }
            );
            if (this.isSftpSshKeyAuth()) {
                fieldsToCheck.push({ field: 'privateKey', value: this.formData.privateKey });
            } else {
                fieldsToCheck.push({ field: 'Password', value: this.formData.Password });
            }
        }

        if (this.FileEncrypt) {
            fieldsToCheck.push({ field: 'PGPKey', value: this.formData.PGPKey });
        }

        if (this.AZURE) {
            fieldsToCheck.push({ field: 'ConnectionString', value: this.formData.ConnectionString });
        }

        if (this.AMAZONS3REMOTE) {
            fieldsToCheck.push({ field: 'RoleARN', value: this.formData.RoleARN });
        }

        for (const { field, value } of fieldsToCheck) {
            if (value && value.trim().length > 0) {
                if (!this.isVariableOnly(value)) {
                    return false;
                }
            }
        }

        // Template S3 Remote: Region must be built-in `{BUILTIN_REGION_VARIABLE}` only (not arbitrary `{var}`).
        if (this.AMAZONS3REMOTE && this.useTemplateVariables) {
            const rv = this.formData.Region;
            if (rv && String(rv).trim() && !this.isValidTemplateS3RegionOrBuiltin(String(rv))) {
                return false;
            }
        }

        return true;
    }

    /**
     * Get list of credential fields that have invalid (literal) values.
     * Used to show which fields need to be corrected.
     */
    private getInvalidCredentialFields(): string[] {
        const invalidFields: string[] = [];
        const fieldsToCheck: Array<{ field: string; value: string | undefined }> = [];

        if (this.SFTP || this.FTPS) {
            fieldsToCheck.push(
                { field: 'Host Name', value: this.formData.HostName },
                { field: 'Port', value: this.formData.Port },
                { field: 'User Name', value: this.formData.UserName }
            );
            if (this.isSftpSshKeyAuth()) {
                fieldsToCheck.push({ field: 'SSH key reference', value: this.formData.privateKey });
            } else {
                fieldsToCheck.push({ field: 'Password', value: this.formData.Password });
            }
        }

        if (this.FileEncrypt) {
            fieldsToCheck.push({ field: 'PGP Key', value: this.formData.PGPKey });
        }

        if (this.AZURE) {
            fieldsToCheck.push({ field: 'Connection String', value: this.formData.ConnectionString });
        }

        if (this.AMAZONS3REMOTE) {
            fieldsToCheck.push({ field: 'Role ARN', value: this.formData.RoleARN });
        }

        for (const { field, value } of fieldsToCheck) {
            if (value && value.trim().length > 0) {
                if (!this.isVariableOnly(value)) {
                    invalidFields.push(field);
                }
            }
        }

        if (this.AMAZONS3REMOTE && this.useTemplateVariables) {
            const rv = this.formData.Region;
            if (rv && String(rv).trim() && !this.isValidTemplateS3RegionOrBuiltin(String(rv))) {
                invalidFields.push('Region');
            }
        }

        return invalidFields;
    }

    /**
     * [Workflow Templates] Get appropriate form validity based on mode.
     * Uses templateFormValid for template mode, otherwise uses native formValid.
     */
    get effectiveFormValid(): boolean {
        if (this.useTemplateVariables) {
            return this.templateFormValid;
        }
        return this.formValid;
    }

    /**
     * Check if there's a pending file pattern value that hasn't been added to the list.
     * Returns true if dataFileName has a value (user needs to click '+' to add it or clear it).
     */
    get hasPendingFilePattern(): boolean {
        return this.dataFileName != null && this.dataFileName.trim() !== '';
    }

    /**
     * Check if there's pending file rename data that hasn't been added to the list.
     * Returns true if either key or value has content (both must be filled and added or both cleared).
     */
    get hasPendingFileRename(): boolean {
        const hasKey = this.hasValueOrVariable(
            this.normalizeFileRenameFieldValue(this.formData.fileRenameKey)
        );
        const hasValue = this.hasValueOrVariable(
            this.normalizeFileRenameFieldValue(this.formData.fileRenameValue)
        );
        // Return true if only one is filled (incomplete) or both are filled (needs to be added)
        return hasKey || hasValue;
    }

    /**
     * Extract template variable placeholders from a string (e.g., "{testing}" -> ["testing"])
     */
    private extractVariablePlaceholders(value: string): string[] {
        return extractTemplateVariableNames(value).map((n) => n.toLowerCase());
    }

    /**
     * Get set of defined variable names (lowercase for case-insensitive comparison)
     */
    private get definedVarNames(): Set<string> {
        return new Set(this.variables.map((v) => (v.name || '').toLowerCase()));
    }

    /**
     * Check if a field value contains any undefined variables
     */
    private fieldHasUndefinedVariables(value: string): boolean {
        if (!this.useTemplateVariables) return false;
        const placeholders = this.extractVariablePlaceholders(value);
        return placeholders.some(
            (p) =>
                !this.definedVarNames.has(p) &&
                !isBuiltinRegionVariableName(p) &&
                !isBuiltinBusUnitVariableName(p)
        );
    }

    /**
     * Check if Page 1 has any undefined variables or template input warnings
     */
    private hasUndefinedVariablesPage1(): boolean {
        if (!this.useTemplateVariables) return false;

        // Only page-1 inputs — page-2 warnings must not block page-1 Next
        if (this.hasTemplateInputWarningsInPane('page1')) {
            return true;
        }

        return this.fieldHasUndefinedVariables(this.formData.stepName);
    }

    /**
     * Check if Page 1 (General Information) has all required fields filled
     * AND no undefined variables
     */
    get isPage1Valid(): boolean {
        const requiredFieldsFilled =
            this.hasValueOrVariable(this.formData.stepName) &&
            this.hasValueOrVariable(this.formData.functionName);

        // Also check for undefined variables when using template variables
        if (this.useTemplateVariables && this.hasUndefinedVariablesPage1()) {
            return false;
        }

        return requiredFieldsFilled;
    }

    /**
     * Check if Page 2 (File Information) has all required fields filled based on storage type
     */

    get isPage2Valid(): boolean {
        // Optional File Rename is still pending until both Key and Value are added via '+'
        // or the typed values are cleared. Either case blocks Next.
        if (this.hasPendingFileRename) {
            return false;
        }

        // Basic required fields
        if (!this.hasValueOrVariable(this.formData.storageType)) {
            return false;
        }
        if (!this.hasValueOrVariable(this.formData.locationType)) {
            return false;
        }

        // SFTP/FTPS require name (Bucket Name/Folder Path) and credentials
        if (this.SFTP || this.FTPS) {
            if (!this.hasValueOrVariable(this.formData.name)) return false;
            if (!this.bucketNameValid) return false;
            if (!this.hasValueOrVariable(this.formData.HostName)) return false;
            if (!this.hasValueOrVariable(this.formData.Port)) return false;
            if (!this.useTemplateVariables && !this.isPlainSftpPortValid(this.formData.Port)) return false;
            if (!this.hasValueOrVariable(this.formData.UserName)) return false;
            if (this.isSftpSshKeyAuth()) {
                if (!this.isEdit && !this.hasValueOrVariable(this.formData.privateKey)) return false;
                if (
                    this.sftpSshKeyReplaceMode &&
                    !this.hasValueOrVariable(this.formData.privateKey)
                ) {
                    return false;
                }
                if (this.getSftpPrivateKeyBlockingMessage()) {
                    return false;
                }
            } else {
                if (!this.isEdit && !this.hasValueOrVariable(this.formData.Password)) return false;
            }
        } else {
            // Other storage types require path (Bucket Path) - but may also show name (Bucket Name)
            // Only validate path if it's actually shown (not for SFTP/FTPS)
            if (!this.hasValueOrVariable(this.formData.path)) return false;
            if (!this.bucketPathValid) return false;

            // Bucket Name may be required or optional depending on isBucketRename flag
            // If isBucketRename is false, Bucket Name is required
            if (!this.isBucketRename && !this.hasValueOrVariable(this.formData.name)) return false;
            if (!this.isBucketRename && !this.bucketNameValid) return false;
        }

        // File Encrypt requires PGP Key (unless editing)
        if (this.FileEncrypt && !this.isEdit) {
            if (!this.hasValueOrVariable(this.formData.PGPKey)) return false;
        }

        // Azure Connection String: template = presence; regular = required+format (skip unchanged edit mask)
        if (this.AZURE && !this.isAzureConnectionStringFieldValid()) return false;

        // Amazon S3 Remote: template = presence; regular = required+format (skip unchanged edit mask)
        if (this.AMAZONS3REMOTE) {
            if (!this.isAwsIamRoleArnFieldValid()) return false;
            if (!this.hasAwsS3RemoteRegionValue()) return false;
        }

        // Check for undefined variables when using template variables
        if (this.useTemplateVariables && this.hasUndefinedVariablesPage2()) {
            return false;
        }

        if (!this.passesInternalS3ManagedRoleValidation()) {
            return false;
        }

        return true;
    }

    /**
     * Check if Page 2 has any undefined variables in its fields.
     * Dynamically queries all template-string-input components to check for warnings.
     */
    private hasUndefinedVariablesPage2(): boolean {
        if (!this.useTemplateVariables) return false;

        // Dynamic approach: check all template-string-input components for warnings
        // This works for ANY field that uses template-string-input, not just a hardcoded list
        if (this.hasTemplateInputWarningsInPane('page2')) {
            return true;
        }

        // Also check formData values for undefined variables (catches cases where
        // the component hasn't been blurred yet but the data contains undefined vars)
        const fieldsToCheck = [
            this.formData.name,
            this.formData.path,
            this.formData.HostName,
            this.formData.Port,
            this.formData.UserName,
            this.formData.Password,
            this.formData.privateKey,
            this.formData.PGPKey,
            this.formData.ConnectionString,
            this.formData.RoleARN,
            this.formData.Region,
            this.formData.locationType,
        ];

        return fieldsToCheck.some((field) => this.fieldHasUndefinedVariables(field));
    }

    /**
     * Check if any template-string-input in a wizard pane has forceShowWarning set.
     * ponytail: scope by pane-id — hidden page-2 fields stay in the DOM and must not
     * block page-1 Next after Back navigation.
     */
    private hasTemplateInputWarningsInPane(paneId: 'page1' | 'page2'): boolean {
        if (!this.shadowRoot) return false;

        const pane = this.shadowRoot.querySelector(`jha-slider-pane[pane-id="${paneId}"]`);
        if (!pane) return false;

        for (const input of pane.querySelectorAll('template-string-input')) {
            if ((input as any).forceShowWarning === true) {
                return true;
            }
        }
        return false;
    }

    /**
     * [Workflow Templates] Handle modal-opened event from template-string-input.
     * Hides the progress bar to prevent z-index conflicts with the modal.
     */
    private handleModalOpened = () => {
        this.classList.add('variable-modal-active');
    };

    /**
     * [Workflow Templates] Handle modal-closed event from template-string-input.
     * Restores the progress bar visibility.
     */
    private handleModalClosed = () => {
        this.classList.remove('variable-modal-active');
    };
    static readonly styles = css`
    /* Do not style .add-reminder-style here — it must not inherit forced display,
     * which can prevent the [hidden] attribute from hiding the file-rename reminder. */
    span:not(.add-reminder-style) {
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 10em;
      display: block;
      overflow: hidden;
    }
    jha-progress-linear {
      flex: 1;
      position: relative;
      z-index: 1;
    }
    #popupConDiv {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    article[slot='dialog-content'] {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    #paneDiv {
      display: flex;
      flex-direction: column;
    }
    /* [ACME-1422] minmax(0, 1fr) lets columns shrink so long validation text wraps instead of widening the modal */
    #inputsDiv {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 48px;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    /* SFTP full-width blocks (test connection, auth summary, etc.) */
    .folder-path-sftp-auth-row {
      grid-column: 1 / -1;
    }
    /* SFTP: Folder Path | SFTP Authentication on one aligned two-column row */
    .sftp-path-auth-row {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 48px;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
      align-items: start;
    }
    .sftp-path-auth-row > jha-tooltip {
      display: block;
      width: 100%;
      min-width: 0;
      max-width: 100%;
      box-sizing: border-box;
    }
    /*
     * [ACME-1881] Keep the page-2 two-column grid:
     * - No Bucket Pattern (e.g. GCS): [File Rename Key/Value/+] | [Name]
     * - Azure: [Connection String] | [File Rename] (Name on next row)
     * - Bucket Pattern (e.g. Amazon S3): [Bucket Pattern] | [File Rename]
     * Override global template-string-input min-width: 390px inside these cells,
     * but keep a floor so Key/Value do not crush (see ACME-1881 screenshots).
     */
    .file-rename-name-row {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 48px;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
      align-items: start;
    }
    .file-rename-section,
    .file-rename-name-slot,
    .file-rename-pattern-slot {
      min-width: 0;
      max-width: 100%;
      width: 100%;
      box-sizing: border-box;
    }
    .file-rename-name-slot > jha-tooltip,
    .file-rename-pattern-slot > jha-tooltip {
      display: block;
      width: 100%;
      min-width: 0;
      max-width: 100%;
      box-sizing: border-box;
    }
    .file-rename-row {
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      gap: 8px;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    /*
     * Key/Value only — must NOT match the + tooltip (.file-rename-add-btn).
     * That tooltip used to inherit min-width: 150px and steal the column,
     * crushing Key/Value (truncated "Enter Valu" placeholders).
     */
    .file-rename-row > jha-tooltip:not(.file-rename-add-btn) {
      flex: 1 1 0;
      min-width: 150px;
      max-width: 100%;
      box-sizing: border-box;
    }
    .file-rename-row template-string-input,
    .file-rename-row jha-form-input,
    .file-rename-name-slot template-string-input,
    .file-rename-name-slot jha-form-input,
    .file-rename-pattern-slot template-string-input,
    .file-rename-pattern-slot jha-form-input {
      display: block;
      width: 100%;
      /* Kill global 390px; parent tooltip min-width keeps a usable floor */
      min-width: 0 !important;
      max-width: 100%;
      box-sizing: border-box;
    }
    /*
     * Layout only: offset + past the field label. Do NOT size or restyle focus —
     * jha-button[icon] already draws a circular focus ring (matches main/dev).
     */
    .file-rename-row > .file-rename-add-btn {
      flex: 0 0 auto;
      align-self: flex-start;
      min-width: 0;
      max-width: none;
      /* Label (~22px) + half (input − icon) so + midline matches Key/Value inputs */
      margin-top: 34px;
    }
    .file-rename-section > ul {
      margin: 8px 0 0;
      padding-left: 1.25em;
    }
    .file-rename-section > ul:empty {
      display: none;
      margin: 0;
    }
    @media (prefers-color-scheme: dark) {
      h3 {
        color: #a3d4ff;
      }
    }
    @media (prefers-color-scheme: light) {
      h3 {
        color: #06185f;
      }
    }
    jha-form-input {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    jha-form-select {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    /*
     * [ACME-1422] Dialog used to use width: max-content, which grew with long validation messages.
     * Use the supported CSS variable so width caps (~920 fits two grid columns + gap); content wraps.
     * Page 3 (Pattern) is sparse — shrink to ~70% so the layout is not left-heavy empty space.
     */
    jha-dialog {
      --jha-dialog-width: min(920px, calc(100vw - 48px));
      box-sizing: border-box;
    }
    :host([data-page3]) jha-dialog {
      --jha-dialog-width: min(640px, calc(100vw - 48px));
    }
    /*
     * Pattern row: restore ~400px field (removed with the old inline style), keep icons
     * from flex-shrinking, and let the input use the remaining row width.
     */
    :host([data-page3]) #triggerPatternDiv {
      column-gap: 0;
      width: 100%;
    }
    :host([data-page3]) #triggerFileDiv,
    :host([data-page3]) #triggerFileInput {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
    :host([data-page3]) #triggerFileInput > jha-tooltip:not([data-icon-wrapper]) {
      flex: 1 1 auto;
      min-width: 400px;
      max-width: 100%;
      box-sizing: border-box;
    }
    :host([data-page3]) #triggerFileInput template-string-input,
    :host([data-page3]) #triggerFileInput jh-input {
      display: block;
      width: 100%;
      min-width: 400px !important;
      max-width: 100%;
      box-sizing: border-box;
    }
    :host([data-page3]) #triggerFileInput .iconInfo,
    :host([data-page3]) #triggerFileInput jha-tooltip[data-icon-wrapper] {
      flex: 0 0 auto;
    }
    :host([data-page3]) #btnDiv {
      width: 100%;
      box-sizing: border-box;
      justify-content: center;
    }
    jha-slider {
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    jha-slider form {
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }
    #btnDiv {
      display: flex;
      gap: 20px;
      margin-top: 5vh;
      justify-content: center;
      width: 100%;
      box-sizing: border-box;
      padding-right: 15px;
      padding-left: 15px;
    }
    #triggerPatternDiv {
      display: flex;
      flex-direction: row;
      column-gap: 200px;
    }
    #triggerFileDiv {
      display: flex;
      flex-direction: column;
    }
    #triggerFileInput {
      display: flex;
      flex-direction: row;
      column-gap: 30px;
      align-items: flex-start;
    }
    #triggerFileInput .iconInfo {
      margin-top: 32px;
      flex: 0 0 auto;
    }
    #triggerFileInput jha-tooltip[data-icon-wrapper] {
      margin-top: 32px;
      flex: 0 0 auto;
    }
    #filePattern {
      position: fixed;
      border-radius: 4px;
      padding: 8px;
      width: 770px;
      height: 150px;
      background: black;
      color: white;
      box-sizing: border-box;
      z-index: 1061;
      display: none;
    }
    .progress-style-full-width {
      --jha-progress-linear-width: 100%;
      z-index: 1500;
    }
    .sftp-test-connection-msg {
      margin-top: 8px;
      font-size: 14px;
    }
    .sftp-test-connection-msg--success {
      color: var(--jh-color-content-positive-enabled, #228848);
    }
    .sftp-test-connection-msg--error {
      color: var(--jh-color-content-negative-enabled, #c9252d);
    }
    /* Match TemplateStringInput .validation-message (file-rename + file-pattern reminders). */
    .add-reminder-style {
      display: block;
      box-sizing: border-box;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 12px;
      font-weight: 400;
      color: var(--jh-color-content-negative-enabled, #c9252d);
      margin-top: 4px;
      padding: 0;
      white-space: normal;
      text-overflow: clip;
      overflow: visible;
      width: auto;
      max-width: 100%;
    }
    .iconInfo:hover + #filePattern {
      display: block;
      transform: translateX(-50%);
      left: 50%;
      top: 28%;
    }
    .password-container {
      position: relative;
    }
    .password-toggle {
      position: absolute;
      right: 12px;
      top: 34px;
      cursor: pointer;
      z-index: 10;
      color: #666;
      padding: 4px;
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .password-toggle:hover {
      color: #4157ad;
    }
    .password-toggle jha-icon-show {
      width: 20px;
      height: 20px;
    }

    /* WORKFLOW TEMPLATES INTEGRATION
     * Styles for template-string-input components used when useTemplateVariables=true.
     * These allow text fields to support template variable insertion.
     */
    template-string-input {
      display: block;
      min-width: 390px;
    }

    /* Ensure tooltips appear above the progress bar */
    jha-tooltip {
      --jha-tooltip-z-index: 9999;
    }

    /* Ensure the pane content has higher stacking context than progress bar */
    #paneDiv {
      position: relative;
      z-index: 10;
    }

    /* When a variable modal is open, hide the progress bar to prevent z-index conflicts */
    :host(.variable-modal-active) .progress-style-full-width {
      visibility: hidden;
    }

    /* Hide progress bar when hovering over file pattern info icon to prevent tooltip overlap */
    #popupConDiv:has(.iconInfo:hover) .progress-style-full-width {
      visibility: hidden;
    }

    .institution-guidance {
      margin: 0.5rem 0 0;
      font-size: 0.875rem;
      line-height: 1.45;
      color: var(--jha-text-neutral, #5c6771);
    }
  `;

    @property({ type: String })
    transferType = '';
    @property({ type: String })
    buName = '';
    /**
     * [ACME-1422] Friendly Business Unit display name used to render the auto-filled
     * SMB bucket preview for amazons3 + pull steps. The API stamps the persisted
     * bucket as `{appenv}smb-{BuNameLower}`; this property lets the UI preview match
     * that shape regardless of whether `buName` is a human slug (PROD) or a GUID
     * (non-PROD catalog rows). Falls back to `buName` when not supplied.
     */
    @property({ type: String })
    buDisplayName = '';
    @property({ type: String })
    workflowTransferType = '';
    @property({ type: String })
    workflowName = '';
    @property({ type: String })
    workflowId = '';
    /** Parent workflow source location path (edit/clone) — used for connectivity test API when persisted. */
    @property({ type: String })
    workflowSourceLocationPath = '';
    @property({ type: Boolean })
    editDataPattern = false;
    @property({ type: Boolean })
    editFilePattern = false;
    @property()
    editFileIndex = '';
    @property()
    activePage = 'page1';

    /**
     * ACME-1050: baseline after hydrate — see `workflow-step-popup-dirty.ts`.
     * Do not latch dirty from non-empty fields alone (breaks Edit close).
     */
    private _cancelBaseline: string | null = null;
    /** Constructor clone of the step being edited — not a Lit property. */
    private editStepSnapshot: Record<string, any> | null = null;
    /** Survives Lit resetting @property arrays when leaving page 2. */
    private committedFileRenameList: string[] = [];
    private committedDataFileList: string[] = [];
    /** Plain bag — not a Lit property. Persist/edit read this first. */
    private retainedStepFileInfo = {
        fileRename: {} as Record<string, string>,
        fileRenameList: [] as string[],
        dataFileList: [] as string[],
        FileMovePattern: [] as string[],
        bucketRename: '',
    };

    /** Prevents re-entrancy while openJhftDialog is stacked over this wizard. */
    private _closePromptOpen = false;

    /**
     * When true, allow jha-dialog `cancel` (X) to reach DialogUtil without another prompt.
     * Set only after the user confirms Leave (or clean close re-dispatch).
     */
    private _forceClose = false;

    /**
     * Track credential field validation errors.
     *
     * WORKFLOW TEMPLATES ONLY:
     * This map tracks which credential fields (HostName, Password, PGPKey, etc.)
     * have invalid values (literal text instead of variable placeholders).
     *
     * In regular workflows, this map remains empty because credential field
     * validation is skipped (useTemplateVariables = false).
     *
     * In workflow templates, credential fields MUST contain only variables
     * like {Password} or {HostName}. Literal values are rejected because
     * templates cannot store actual secrets.
     */
    @state()
    credentialFieldErrors: Map<string, string> = new Map();

    /** Inline validation for pasted PEM / OpenSSH key material (non-template SFTP SSH key mode). */
    @state()
    sftpPrivateKeyFormatMessage = '';

    /** Story 3.3b — SFTP Test connection control */
    @state()
    private sftpTestConnectionPhase: 'idle' | 'loading' | 'done' = 'idle';
    @state()
    private sftpTestConnectionOutcome: 'neutral' | 'success' | 'error' = 'neutral';
    @state()
    private sftpTestConnectionMessage = '';

    /** After Replace key: cleared refs — user must supply new material before save (Story 2.3). */
    @state()
    sftpSshKeyReplaceMode = false;

    /** Institution dropdown (workflow steps only; ACME-1406). */
    @state()
    institutionsOptions: Array<{ value: string; name: string }> = [];
    @state()
    institutionsLoaded = false;
    @state()
    institutionsLoadFailed = false;
    @state()
    institutionNotInList = false;

    /** Gate the workflow-step institution dropdown behind the institution rollout flag. */
    get showInstitutionField(): boolean {
        return isInitialInstitutionFeatureEnabled();
    }

    @property({ type: Boolean })
    firstPageStepWarning = false;
    @property({ type: Boolean })
    firstPageFunctionWarning = false;
    @property({ type: Boolean })
    secondPageLocationWarning = false;
    @property({ type: Boolean })
    secondPagStorageWarning = false;
    @property({ type: Boolean })
    secondPageNameWarning = false;
    @property({ type: Boolean })
    secondPagePathWarning = false;
    @property({ type: Boolean })
    secondPageEncryptWarning = false;
    @property({ type: Boolean })
    secondPageHostWarning = false;
    @property({ type: Boolean })
    secondPagePortWarning = false;
    @property({ type: Boolean })
    secondPageUserWarning = false;
    @property({ type: Boolean })
    secondPagePswdWarning = false;
    @property({ type: Boolean })
    secondPageSshKeyRefWarning = false;
    @property({ type: Boolean })
    secondPageConnectionStringWarning = false;
    @property({ type: Boolean })
    secondPageRoleARNWarning = false;
    @property({ type: Boolean })
    secondPageRegionWarning = false;
    @property({ type: Boolean })
    secondPagePullDestRoleWarning = false;
    @property()
    toUpdate: string = 'update';
    @property({ type: Boolean })
    isEdit: false;
    @property({ type: Boolean })
    isClone: false;
    @property({ type: Boolean })
    lastDelete: false;
    @property()
    percentage = '30';
    @property()
    DialogTitle = 'Add Workflow Step';
    @property({ type: Array })
    fileRenameList: [] = [];
    @property({ type: Array })
    selectFuncOptions = [];
    @property({ type: Array })
    allOptions = [];
    @property({ type: Array })
    selectSourceOptions = [];
    @property({ type: Boolean })
    FileCopy = true;
    @property({ type: Boolean })
    isBucketRename = false;
    @property({ type: Boolean })
    FileDownload = false;
    @property({ type: Boolean })
    FileZip = false;
    @property({ type: Boolean })
    FileEncrypt = false;
    @property({ type: Boolean })
    FileDelete = false;
    @property({ type: Boolean })
    UnprocessedFileArchive = false;
    pullInternalS3DestRole: 'home' | 'filepickup' | 'smb' | '' = '';
    @property({ type: Boolean })
    FTPS = false;
    @property({ type: Boolean })
    SFTP = false;
    @property({ type: Boolean })
    AMAZONS3 = false;
    @property({ type: Boolean })
    AMAZONS3REMOTE = false;
    @property({ type: Boolean })
    GCS = false;
    @property({ type: Boolean })
    AZURE = false;
    @property({ type: Boolean })
    showPassword = false;
    @property()
    originalPassword = '';
    @property({ type: Object })
    editData = {};
    @property({ attribute: false })
    FileRename: Map<string, string> = new Map();
    @property({ attribute: false })
    SecretValue: Map<string, string> = new Map();
    @property({ type: Array })
    dataFileList = [];
    @property()
    dataFileName = '';
    @property({ type: Boolean })
    isStorageDisabled = false;
    @property({ type: Boolean })
    isFolderBucketNameDisable = false;
    @property({ type: Boolean })
    bucketPathValid = false;
    @property({ type: Boolean })
    bucketNameValid = false;
    @property({ type: Array })
    regionList = [];
    @property({ type: Object })
    formData = {
        functionName: '',
        stepName: '',
        deleteSourceFile: false,
        locationType: '',
        storageType: '',
        path: '',
        name: '',
        fileRename: {},
        bucketRename: '',
        secretName: '',
        secretValue: {},
        sourceFileInfo: this.sourceFileInfo,
        stepIndex: 0,
        HostName: '',
        Port: '0',
        UserName: '',
        Password: '',
        AuthType: SFTP_AUTH_TYPE.Password,
        sourceAuthType: SFTP_AUTH_TYPE.Password,
        destinationAuthType: SFTP_AUTH_TYPE.Password,
        privateKey: '',
        fileRenameKey: '',
        fileRenameValue: '',
        PGPKey: '',
        FileMovePattern: [],
        ConnectionString: '',
        RoleARN: '',
        Region: '',
        institutionUuid: '',
    };
    @property()
    editFileNameKeyBackup = '';
    @property()
    retainPGP = '';
    @property()
    retainConnectionString = '';
    azureConnectionStringUserEdited = false;
    roleArnUserEdited = false;
    @property()
    hiddenPGP = '';
    @property()
    editDataFilePatternName = '';
    @property()
    initialStepName = '';
    @property()
    pgpkeyPlaceholder = 'Enter valid PGP Public Key';
    @property()
    connectionStringPlaceholder = 'Enter valid Connection String';
    @property()
    initialStorageType = '';
    @property()
    hostPlaceholder = 'Enter valid Host Name';
    @property()
    sshKeyRefPlaceholder = 'SSH private key';
    @property()
    portPlaceholder = 'Enter valid port';
    @property()
    userPlaceholder = 'Enter valid username';
    @property()
    passPlaceholder = 'Enter valid password';
    @property()
    roleARNPlaceholder = 'Enter valid Role ARN';
    @property()
    regionPlaceholder = 'Enter valid Region';

    private toastPage2ValidationFailure() {
        const sshMsg = this.getSftpPrivateKeyBlockingMessage();
        if (sshMsg) {
            showToastMessage(sshMsg, 'danger');
            this.sftpPrivateKeyFormatMessage = sshMsg;
            return;
        }
        showToastMessage('Please enter all required fields', 'danger');
    }

    onNextClick() {
        if (stringComparison(this.activePage, 'page1')) {
            if (
                !this.hasValueOrVariable(this.formData.functionName) ||
                !this.hasValueOrVariable(this.formData.stepName)
            ) {
                showToastMessage('Please enter all required fields', 'danger');
                this.firstPageFunctionWarning = !this.hasValueOrVariable(this.formData.functionName);
                this.firstPageStepWarning = !this.hasValueOrVariable(this.formData.stepName);
                return;
            } else {
                this.activePage = 'page2';
                this.percentage = '65';
                this.firstPageFunctionWarning = false;
                this.firstPageStepWarning = false;
                return;
            }
        }
        if (stringComparison(this.activePage, 'page2')) {
            if (this.hasPendingFileRename) {
                showToastMessage(
                    'Please add or clear the File Rename Key and Value before proceeding.',
                    'danger'
                );
                return;
            }

            this.syncFileRenameBeforePersist();

            if (this.SFTP || this.FTPS) {
                this.onFolderBucketNameChange(this.formData.name);
            } else {
                this.onFolderBucketPathChange(this.formData.path);
            }
            if (this.FileEncrypt && !this.isEdit) {
                if (
                    this.effectiveFormValid &&
                    this.hasValueOrVariable(this.formData.PGPKey) &&
                    (((this.SFTP || this.FTPS) && this.bucketNameValid) ||
                        (!(this.SFTP || this.FTPS) && this.bucketPathValid))
                ) {
                    this.activePage = 'page3';
                    this.percentage = '100';
                    this.secondPageLocationWarning = false;
                    this.secondPagStorageWarning = false;
                    this.secondPageNameWarning = false;
                    this.secondPagePathWarning = false;
                    this.secondPageEncryptWarning = false;
                    this.secondPageHostWarning = false;
                    this.secondPagePortWarning = false;
                    this.secondPageUserWarning = false;
                    this.secondPagePswdWarning = false;
                    this.secondPageSshKeyRefWarning = false;
                    this.secondPagePullDestRoleWarning = false;
                    return;
                } else {
                    this.toastPage2ValidationFailure();
                    this.secondPageLocationWarning = !this.hasValueOrVariable(this.formData.locationType);
                    this.secondPagStorageWarning = this.formData.storageType == undefined ? true : false;
                    this.secondPageNameWarning = !this.hasValueOrVariable(this.formData.name);
                    this.secondPagePathWarning = !this.hasValueOrVariable(this.formData.path);
                    this.secondPageEncryptWarning = !this.hasValueOrVariable(this.formData.PGPKey);
                    this.secondPageHostWarning = !this.hasValueOrVariable(this.formData.HostName);
                    this.secondPagePortWarning = !this.hasValueOrVariable(this.formData.Port);
                    this.secondPageUserWarning = !this.hasValueOrVariable(this.formData.UserName);
                    this.secondPagePswdWarning =
                        !(this.SFTP || this.FTPS) || this.isSftpSshKeyAuth()
                            ? false
                            : !this.hasValueOrVariable(this.formData.Password);
                    this.secondPageSshKeyRefWarning =
                        this.SFTP &&
                        this.isSftpSshKeyAuth() &&
                        !this.hasValueOrVariable(this.formData.privateKey) &&
                        (!this.isEdit || this.sftpSshKeyReplaceMode);
                    this.secondPageConnectionStringWarning = !this.isAzureConnectionStringFieldValid();
                    this.secondPageRoleARNWarning = !this.isAwsIamRoleArnFieldValid();
                    this.secondPageRegionWarning = !this.hasValueOrVariable(this.formData.Region);
                    this.secondPagePullDestRoleWarning =
                        this.isPullFileCopyDestRoleSelectVisible() &&
                        !this.hasValidPullInternalS3DestRole();
                    return;
                }
            } else {
                if (
                    this.effectiveFormValid &&
                    (((this.SFTP || this.FTPS) && this.bucketNameValid) ||
                        (!(this.SFTP || this.FTPS) && this.bucketPathValid)) &&
                    this.isAzureConnectionStringFieldValid() &&
                    this.isAwsIamRoleArnFieldValid()
                ) {
                    this.activePage = 'page3';
                    this.percentage = '100';
                    this.secondPageLocationWarning = false;
                    this.secondPagStorageWarning = false;
                    this.secondPageNameWarning = false;
                    this.secondPagePathWarning = false;
                    this.secondPageEncryptWarning = false;
                    this.secondPageHostWarning = false;
                    this.secondPagePortWarning = false;
                    this.secondPageUserWarning = false;
                    this.secondPagePswdWarning = false;
                    this.secondPageSshKeyRefWarning = false;
                    this.secondPagePullDestRoleWarning = false;
                    return;
                } else {
                    this.toastPage2ValidationFailure();
                    this.secondPageLocationWarning = !this.hasValueOrVariable(this.formData.locationType);
                    this.secondPagStorageWarning = this.formData.storageType == undefined ? true : false;
                    this.secondPageNameWarning = !this.hasValueOrVariable(this.formData.name);
                    this.secondPagePathWarning = !this.hasValueOrVariable(this.formData.path);
                    this.secondPageEncryptWarning = !this.hasValueOrVariable(this.formData.PGPKey);
                    this.secondPageHostWarning = !this.hasValueOrVariable(this.formData.HostName);
                    this.secondPagePortWarning = !this.hasValueOrVariable(this.formData.Port);
                    this.secondPageUserWarning = !this.hasValueOrVariable(this.formData.UserName);
                    this.secondPagePswdWarning =
                        !(this.SFTP || this.FTPS) || this.isSftpSshKeyAuth()
                            ? false
                            : !this.isEdit && !this.hasValueOrVariable(this.formData.Password);
                    this.secondPageSshKeyRefWarning =
                        this.SFTP &&
                        this.isSftpSshKeyAuth() &&
                        !this.hasValueOrVariable(this.formData.privateKey) &&
                        (!this.isEdit || this.sftpSshKeyReplaceMode);
                    this.secondPageConnectionStringWarning = !this.isAzureConnectionStringFieldValid();
                    this.secondPageRoleARNWarning = !this.isAwsIamRoleArnFieldValid();
                    this.secondPageRegionWarning = !this.hasValueOrVariable(this.formData.Region);
                    this.secondPagePullDestRoleWarning =
                        this.isPullFileCopyDestRoleSelectVisible() &&
                        !this.hasValidPullInternalS3DestRole();
                    return;
                }
            }
        }
    }

    onBackClick() {
        if (stringComparison(this.activePage, 'page2')) {
            this.activePage = 'page1';
            this.percentage = '30';
            return;
        }
        if (stringComparison(this.activePage, 'page3')) {
            this.activePage = 'page2';
            this.percentage = '65';
            return;
        }
    }

    checkDeleteFlag(e: { target: { value: string } }) {
        this.formData.deleteSourceFile = e.target.value;
    }

    onStorageTypeChange(e: Event) {
        const target = e.target as HTMLSelectElement;
        const previousStorageType = this.formData.storageType;
        const newStorageType = target?.value ?? "";
        const prevNorm = String(previousStorageType ?? '').trim().toLowerCase();
        const nextNorm = String(newStorageType).trim().toLowerCase();
        // ACME-1940: block switching *to* FTPS; keep existing ftps steps editable.
        if (nextNorm === 'ftps' && prevNorm !== 'ftps') {
            return;
        }

        if (previousStorageType && newStorageType && previousStorageType !== newStorageType) {
            this.resetStorageTypeFields();
        }

        // Update formData.storageType first
        this.inputValueChange(e);
        // Use setTimeout to ensure formData.storageType is updated before calling setStorage
        setTimeout(() => {
            if (this.formData.storageType) {
                this.setStorage(this.formData.storageType);
            }
        }, 0);
    }

    shouldApplyRoleDefaults(persistedName?: string) {
        if (!this.isEdit && !this.isClone) {
            return true;
        }
        const name = (persistedName ?? this.formData.name ?? '').trim();
        if (!name) {
            return true;
        }
        if (resolveLegacyBucketRoleToken(name)) {
            return false;
        }
        return !isValidBucketRoleToken(name);
    }

    applyPullSmbBucketPreviewToForm() {
        if (this.useTemplateVariables) {
            this.formData.name =
                `${GlobalVariables.SMB_BUCKET_NAME}-${BUILTIN_BUSUNIT_PLACEHOLDER}`;
            this.isFolderBucketNameDisable = true;
            return;
        }

        const buSuffix = (this.buName || '')
            .toString()
            .trim()
            .toLowerCase()
            .replace(/-/g, '')
            .replace(/[^0-9a-z#_]/g, '');
        if (buSuffix) {
            this.formData.name = GlobalVariables.SMB_BUCKET_NAME + '-' + buSuffix;
            this.isFolderBucketNameDisable = true;
        }
    }

    syncPullInternalS3DestRoleFromName(name?: string) {
        const bucketName = (name ?? this.formData.name ?? '').trim();
        if (isPullSmbDestinationBucket(bucketName)) {
            this.pullInternalS3DestRole = 'smb';
            return;
        }
        const resolved = resolveLegacyBucketRoleToken(bucketName);
        if (
            resolved === BUCKET_ROLE_FILE_PICKUP ||
            bucketName.toLowerCase() === BUCKET_ROLE_FILE_PICKUP
        ) {
            this.pullInternalS3DestRole = 'filepickup';
            return;
        }
        this.pullInternalS3DestRole = 'home';
    }

    hasValidPullInternalS3DestRole() {
        return (
            this.pullInternalS3DestRole === 'home' ||
            this.pullInternalS3DestRole === 'filepickup' ||
            this.pullInternalS3DestRole === 'smb'
        );
    }

    /** Hide bucket-role textbox when role is driven by select or auto-default (ACME-1817). */
    shouldHideLockedInternalS3BucketRoleInput() {
        if (!this.AMAZONS3) {
            return false;
        }
        if (this.isPullFileCopyDestRoleSelectVisible()) {
            return true;
        }
        if (!this.isFolderBucketNameDisable) {
            return false;
        }
        return this.FileCopy || this.FileDownload;
    }

    private hasValidInternalS3ManagedBucketName(name?: string) {
        const trimmed = (name ?? this.formData.name ?? '').trim();
        if (!trimmed) {
            return false;
        }
        return isValidBucketRoleToken(trimmed) || isPullSmbDestinationBucket(trimmed);
    }

    private passesInternalS3ManagedRoleValidation() {
        if (this.isPullFileCopyDestRoleSelectVisible() && !this.hasValidPullInternalS3DestRole()) {
            return false;
        }
        if (this.shouldHideLockedInternalS3BucketRoleInput()) {
            return this.hasValidInternalS3ManagedBucketName();
        }
        return true;
    }

    isPullFileCopyDestRoleSelectVisible() {
        return (
            (this.workflowTransferType ?? '').toLowerCase() === 'pull' &&
            this.FileCopy &&
            this.AMAZONS3 &&
            !this.useTemplateVariables &&
            !this.UnprocessedFileArchive
        );
    }

    onPullInternalS3DestRoleChange(e: CustomEvent) {
        const raw = (e.detail?.value ?? (e.target as HTMLSelectElement)?.value ?? '') as string;
        if (raw !== 'home' && raw !== 'filepickup' && raw !== 'smb') {
            this.pullInternalS3DestRole = '';
            this.formData.name = '';
            this.bucketNameValid = false;
            this.recomputeBucketShapeValidityFromFormData();
            this.requestUpdate();
            return;
        }
        const value = raw as 'home' | 'filepickup' | 'smb';
        this.pullInternalS3DestRole = value;
        if (value === 'smb') {
            this.applyPullSmbBucketPreviewToForm();
        } else if (value === 'filepickup') {
            this.formData.name = BUCKET_ROLE_FILE_PICKUP;
            this.isFolderBucketNameDisable = true;
        } else {
            this.formData.name = BUCKET_ROLE_HOME;
            this.isFolderBucketNameDisable = true;
        }
        this.recomputeBucketShapeValidityFromFormData();
        this.requestUpdate();
    }

    applyInternalS3RoleDefault(persistedName?: string) {
        if (!this.AMAZONS3) {
            return;
        }

        const pathSegment = resolveWorkflowPathSegment(this.workflowId, this.workflowName);

        const name = (persistedName ?? this.formData.name ?? '').trim();
        const resolvedLegacy = resolveLegacyBucketRoleToken(name);
        if (resolvedLegacy && (this.isEdit || this.isClone) && !this.shouldApplyRoleDefaults(persistedName)) {
            this.formData.name = resolvedLegacy;
            this.isFolderBucketNameDisable = true;
            if (this.FileCopy && (this.workflowTransferType ?? '').toLowerCase() === 'pull') {
                this.syncPullInternalS3DestRoleFromName(resolvedLegacy);
            }
            return;
        }

        if (!this.shouldApplyRoleDefaults(persistedName)) {
            return;
        }

        const isPull = (this.workflowTransferType ?? '').toLowerCase() === 'pull';

        if (this.UnprocessedFileArchive) {
            this.formData.name = BUCKET_ROLE_HOME;
            if (!this.formData.path) {
                this.formData.path = pathSegment
                    ? '/' + pathSegment + '/UnprocessArchive/'
                    : '/UnprocessArchive/';
            }
            this.isFolderBucketNameDisable = true;
            return;
        }

        if (isPull && this.FileCopy) {
            if (isPullSmbDestinationBucket(name)) {
                this.syncPullInternalS3DestRoleFromName(name);
                this.applyPullSmbBucketPreviewToForm();
                return;
            }

            if (isValidBucketRoleToken(name) && name.trim().toLowerCase() === BUCKET_ROLE_FILE_PICKUP) {
                this.pullInternalS3DestRole = 'filepickup';
                this.formData.name = BUCKET_ROLE_FILE_PICKUP;
                this.isFolderBucketNameDisable = true;
                return;
            }

            if (isValidBucketRoleToken(name) && name.trim().toLowerCase() === BUCKET_ROLE_HOME) {
                this.pullInternalS3DestRole = 'home';
                this.formData.name = BUCKET_ROLE_HOME;
                this.isFolderBucketNameDisable = true;
                return;
            }

            // Default Home for new PULL delivery steps (workflow select + template hidden select).
            this.pullInternalS3DestRole = 'home';
            this.formData.name = BUCKET_ROLE_HOME;
            this.isFolderBucketNameDisable = true;
            return;
        }

        if (isPull && (this.FileZip || this.FileEncrypt)) {
            this.formData.name = BUCKET_ROLE_CACHE;
            this.isFolderBucketNameDisable = true;
            return;
        }

        this.formData.name = BUCKET_ROLE_HOME;
        this.isFolderBucketNameDisable = true;
    }

    resetStorageTypeFields() {
        this.formData.locationType = '';
        this.formData.name = '';
        this.formData.path = this.FileEncrypt || this.FileZip ? this.formData.path : '';
        this.formData.PGPKey = '';
        this.formData.HostName = '';
        this.formData.Port = '';
        this.formData.UserName = '';
        this.formData.Password = '';
        this.formData.AuthType = SFTP_AUTH_TYPE.Password;
        this.formData.privateKey = '';
        this.formData.ConnectionString = '';
        this.retainConnectionString = '';
        this.azureConnectionStringUserEdited = false;
        this.roleArnUserEdited = false;
        this.formData.bucketRename = '';
        this.formData.fileRenameKey = '';
        this.formData.fileRenameValue = '';
        this.formData.RoleARN = '';
        this.formData.Region = '';
        this.originalPassword = '';
        this.sftpSshKeyReplaceMode = false;
        // Reset validation flags
        this.bucketNameValid = false;
        this.bucketPathValid = false;
        // Trigger update to reflect validation state changes
        this.requestUpdate();
    }

    setStorage(key: string) {
        this.isFolderBucketNameDisable = false;
        // API / legacy data may use mixed case (e.g. "SFTP"); switch is lowercase-only.
        const k = key == null || key === '' ? '' : String(key).trim().toLowerCase();
        switch (k) {
            case 'ftps':
                this.FTPS = true;
                this.SFTP = false;
                this.AZURE = false;
                this.AMAZONS3 = false;
                this.AMAZONS3REMOTE = false;
                this.GCS = false;
                this.setPortValue(k);
                break;
            case 'sftp':
                this.FTPS = false;
                this.SFTP = true;
                this.AZURE = false;
                this.AMAZONS3 = false;
                this.AMAZONS3REMOTE = false;
                this.GCS = false;
                this.setPortValue(k);
                break;
            case 'azure':
                this.FTPS = false;
                this.SFTP = false;
                this.AZURE = true;
                this.AMAZONS3 = false;
                this.AMAZONS3REMOTE = false;
                this.GCS = false;
                this.setPortValue(k);
                break;
            case 'amazons3': {
                this.FTPS = false;
                this.SFTP = false;
                this.AZURE = false;
                this.AMAZONS3 = true;
                this.AMAZONS3REMOTE = false;
                this.GCS = false;
                let smbPreviewApplied = false;
                const isPull = this.workflowTransferType.toLowerCase() == 'pull';
                if (GlobalVariables.SMB_BUCKET_NAME != 'undefined' && isPull) {
                    const pullSmbSource = this.FileDownload || this.FileDelete;
                    const pullSmbDest =
                        this.FileCopy && isPullSmbDestinationBucket(this.formData.name ?? '');
                    if (pullSmbSource || pullSmbDest) {
                        if (this.useTemplateVariables) {
                            // [ACME-1422] Visual-only preview in the step editor. Persisted/API value is
                            // `{env}-smb-` (see toPersistedTemplatePullSmbBucketName); BU suffix is
                            // stamped by the API on template save or at Generate Workflow time.
                            this.formData.name =
                                `${GlobalVariables.SMB_BUCKET_NAME}-${BUILTIN_BUSUNIT_PLACEHOLDER}`;
                            this.isFolderBucketNameDisable = true;
                        } else {
                            this.applyPullSmbBucketPreviewToForm();
                        }
                        if (pullSmbDest) {
                            this.syncPullInternalS3DestRoleFromName();
                        }
                        if (this.useTemplateVariables || this.formData.name) {
                            smbPreviewApplied = true;
                        }
                    }
                }
                if (!smbPreviewApplied) {
                    this.applyInternalS3RoleDefault();
                }
                break;
            }
            case 'gcs':
                this.FTPS = false;
                this.SFTP = false;
                this.AZURE = false;
                this.AMAZONS3 = false;
                this.AMAZONS3REMOTE = false;
                this.GCS = true;
                break;
            case 'amazons3remote':
                this.FTPS = false;
                this.SFTP = false;
                this.AZURE = false;
                this.AMAZONS3 = false;
                this.AMAZONS3REMOTE = true;
                this.GCS = false;
                this.setPortValue(k);
                break;
            default:
                this.FTPS = false;
                this.SFTP = false;
                this.AZURE = false;
                this.AMAZONS3REMOTE = false;
                break;
        }

        // After setting storage flags, re-evaluate validation flags based on current field values
        this.recomputeBucketShapeValidityFromFormData();

        // Trigger update to reflect validation state changes
        this.requestUpdate();
    }

    setPortValue(key: string) {
        // When storage type changes OR when first selecting (new step), clear port
        // Exception: preserve port on initial edit load when initialStorageType matches
        const isInitialEditLoad = this.isEdit && this.initialStorageType === key;

        if (isInitialEditLoad) {
            // Initial load for editing: restore port from secretValue if available
            const secretValue = this.formData.secretValue;
            if (secretValue?.Port) {
                this.formData.Port = secretValue.Port;
            }
        } else {
            // New step or storage type changed: clear port to require re-entry
            this.formData.Port = '';
        }
        if (
            (this.initialStorageType != key && this.isEdit) ||
            (this.isEdit && this.isClone && this.formData.secretValue === null)
        ) {
            this.portPlaceholder = 'Enter valid port';
            this.hostPlaceholder = 'Enter valid Host Name';
            this.sshKeyRefPlaceholder = 'SSH private key';
            this.userPlaceholder = 'Enter valid username';
            this.passPlaceholder = 'Enter valid password';
            this.roleARNPlaceholder = 'Enter valid Role ARN';
            this.regionPlaceholder = 'Select Region';
        } else if (this.isEdit) {
            this.portPlaceholder = '*****';
            this.hostPlaceholder = '*****';
            this.sshKeyRefPlaceholder = '*****';
            this.userPlaceholder = '*****';
            this.passPlaceholder = '*****';
            this.roleARNPlaceholder = '*****';
            this.regionPlaceholder = '*****';
        } else {
            // do nothing
        }
        const s3Remote = this.formData.storageType === 'amazons3remote';
        const workflowNewOrClone =
            s3Remote && !this.useTemplateVariables && (!this.isEdit || this.isClone);
        const templateNewOnly = s3Remote && this.useTemplateVariables && !this.isEdit && !this.isClone;
        if (workflowNewOrClone || templateNewOnly) {
            const cur = (this.formData.Region ?? '').trim();
            const preserveVar =
                this.useTemplateVariables && valueIsSingleTemplateVariablePlaceholder(cur);
            if (!preserveVar) {
                this.formData.Region = this.useTemplateVariables ? '' : 'us-east-1';
            }
            if (this.useTemplateVariables) {
                this.secondPageRegionWarning = !this.hasValueOrVariable(this.formData.Region);
            }
        }
    }

    /**
     * Template + S3 Remote: API requires variable-only credentialPlaceholders (see backend IsVariableOnlyValue).
     * Region may only be `{BUILTIN_REGION_VARIABLE}`.
     */
    isValidTemplateS3RegionOrBuiltin(value: string): boolean {
        return isBuiltinRegionPlaceholderString(value);
    }

    getTemplateRegionSelectOptions() {
        return [{ value: BUILTIN_REGION_VARIABLE, name: 'Use Template Variable…' }];
    }

    getTemplateRegionSelectDisplayValue() {
        const r = (this.formData.Region ?? '').trim();
        if (isBuiltinRegionPlaceholderString(r)) {
            return BUILTIN_REGION_VARIABLE;
        }
        return '';
    }

    onTemplateRegionSelectChange(e: CustomEvent) {
        const v = e.detail ?? '';
        if (v === BUILTIN_REGION_VARIABLE) {
            this.updateProperty('Region', BUILTIN_REGION_PLACEHOLDER);
            this.credentialFieldErrors.delete('Region');
            this.secondPageRegionWarning = !this.hasValueOrVariable(this.formData.Region);
            this.requestUpdate();
            return;
        }
        this.updateProperty('Region', v);
        this.credentialFieldErrors.delete('Region');
        this.secondPageRegionWarning = !this.hasValueOrVariable(this.formData.Region);
        this.requestUpdate();
    }

    setFunctionFlag(key: string) {
        this.isFolderBucketNameDisable = false;
        const pathSegment = resolveWorkflowPathSegment(this.workflowId, this.workflowName);
        switch (key.toLowerCase()) {
            case 'filecopy':
                this.FileCopy = true;
                this.FileDownload = false;
                this.FileEncrypt = false;
                this.FileZip = false;
                this.FileDelete = false;
                this.UnprocessedFileArchive = false;
                this.isStorageDisabled = false;
                this.formData.storageType = this.isEdit === false ? '' : this.formData.storageType;
                if (!this.isEdit && this.workflowTransferType == 'push') {
                    this.formData.deleteSourceFile = false;
                }
                break;
            case 'filedownload':
                this.FileCopy = false;
                this.FileDownload = true;
                this.FileEncrypt = false;
                this.FileZip = false;
                this.FileDelete = false;
                this.UnprocessedFileArchive = false;
                this.isStorageDisabled = false;
                this.formData.storageType = this.isEdit === false ? '' : this.formData.storageType;
                if (!this.isEdit) {
                    this.formData.deleteSourceFile = false;
                }
                break;
            case 'filezip':
                this.FileCopy = false;
                this.FileDownload = false;
                this.FileEncrypt = false;
                this.FileZip = true;
                this.FileDelete = false;
                this.UnprocessedFileArchive = false;
                this.setStorage('amazons3');
                this.formData.storageType = 'amazons3';
                this.isStorageDisabled = true;
                this.formData.path = pathSegment ? '/' + pathSegment + '/' : this.formData.path;
                this.formData.deleteSourceFile = false;
                break;
            case 'fileencrypt':
                this.FileCopy = false;
                this.FileDownload = false;
                this.FileEncrypt = true;
                this.FileZip = false;
                this.FileDelete = false;
                this.UnprocessedFileArchive = false;
                this.setStorage('amazons3');
                this.formData.storageType = 'amazons3';
                this.isStorageDisabled = true;
                this.formData.path = pathSegment ? '/' + pathSegment + '/' : this.formData.path;
                this.formData.deleteSourceFile = false;
                break;
            case 'filedelete':
                this.FileCopy = false;
                this.FileDownload = false;
                this.FileEncrypt = false;
                this.FileZip = false;
                this.FileDelete = true;
                this.UnprocessedFileArchive = false;
                this.isStorageDisabled = false;
                this.formData.storageType = this.isEdit === false ? '' : this.formData.storageType;
                if (!this.isEdit) {
                    this.formData.deleteSourceFile = false;
                }
                break;
            case 'unprocessedfilearchive':
                this.FileCopy = false;
                this.FileDownload = false;
                this.FileEncrypt = false;
                this.FileZip = false;
                this.FileDelete = false;
                this.UnprocessedFileArchive = true;
                this.formData.deleteSourceFile = true;
                this.setStorage('amazons3');
                this.formData.storageType = 'amazons3';
                this.isStorageDisabled = true;
                break;

            default:
                break;
        }
        // ponytail: setFunctionFlag clears isFolderBucketNameDisable; re-stamp role token when
        // internal amazons3 was already selected (e.g. page-1 function change after page-2 visit).
        if (this.AMAZONS3) {
            this.applyInternalS3RoleDefault();
            this.recomputeBucketShapeValidityFromFormData();
        }
        // Trigger update to reflect validation state changes
        this.requestUpdate();
    }

    onFunctionChange() {
        const wfDialog = document.querySelector('body > dialog > add-workflow-step-popup');
        const jhaFormSelect = wfDialog?.shadowRoot?.querySelector(
            '#inputsDiv > jha-tooltip > jha-form-select'
        );
        const selectEl = jhaFormSelect?.shadowRoot?.querySelector(
            'form > jha-form-floating-group > select'
        ) as HTMLSelectElement | null;
        this.formData.functionName = selectEl?.value ?? '';
        const storageKey = (this.formData.storageType ?? '').toString().trim().toLowerCase();
        const isInternalS3 = storageKey === 'amazons3' || this.AMAZONS3;
        // AC8b: re-apply role defaults when function changes on edit/clone (internal amazons3 only).
        if ((this.isEdit || this.isClone) && isInternalS3) {
            this.formData.name = '';
        }
        this.setFunctionFlag(this.formData.functionName);
        if (isInternalS3) {
            this.setStorage('amazons3');
        }
        if (
            this.initialStepName != this.formData.functionName &&
            this.isEdit &&
            this.formData.functionName === 'fileencrypt'
        ) {
            this.pgpkeyPlaceholder = 'Enter valid PGP Public Key';
        } else if (this.isEdit) {
            this.pgpkeyPlaceholder = '*****';
        } else {
            // do nothing
        }
        // Trigger update to reflect validation state changes
        this.requestUpdate();
    }

    onSftpAuthTypeChange(e: Event) {
        const el = e.currentTarget as HTMLElement & { value?: string };
        const next = normalizeSftpAuthType(el?.value);
        const prev = normalizeSftpAuthType(this.formData.AuthType);
        this.formData.AuthType = next;
        this.formData.sourceAuthType = next;
        this.formData.destinationAuthType = next;
        if (prev !== next) {
            this.formData.Password = '';
            this.formData.privateKey = '';
            this.sftpPrivateKeyFormatMessage = '';
            this.sftpSshKeyReplaceMode = false;
            this.originalPassword = '';
            this.showPassword = false;
            if (this.SecretValue instanceof Map) {
                this.SecretValue.delete('Password');
                this.SecretValue.delete('password');
                this.SecretValue.delete('privateKey');
            }
            if (this.formData.secretValue && typeof this.formData.secretValue === 'object') {
                const sv = { ...this.formData.secretValue } as Record<string, unknown>;
                delete sv.Password;
                delete sv.password;
                delete sv.privateKey;
                delete sv.SshPrivateKeyReference;
                delete sv.sshPrivateKeyReference;
                this.formData.secretValue = sv;
            }
        }
        this.requestUpdate();
    }

    async connectedCallback() {
        super.connectedCallback();
        // DialogUtil may re-attach this instance; a latched Leave from the last
        // open must not skip the dirty gate on the next one.
        this._forceClose = false;
        this._closePromptOpen = false;

        // Listen for modal events from template-string-input to manage z-index conflicts
        this.addEventListener('modal-opened', this.handleModalOpened);
        this.addEventListener('modal-closed', this.handleModalClosed);

        // MODAL BEHAVIOR: Prevent native dialog cancel event (ESC key)
        // The dialog-util creates a native <dialog> that wraps this component
        // We need to prevent cancel on that parent dialog
        this.handleDialogCancel = this.handleDialogCancel.bind(this);
        document.addEventListener('cancel', this.handleDialogCancel, true);
        // firstUpdated does not re-run on re-attach; bind here so X still hits the dirty gate.
        this.bindJhaDialogCancel();

        // Capture before function/source/region lookups: the wizard is already typable,
        // and a null baseline reads as clean. Fold edit hydrate in after those writes.
        this._cancelBaseline = captureWorkflowStepPopupBaseline(this.cancelSnapshotInput());

        // Fallback data for Step Functions if API fails
        // Pull Transfer Type shows: filecopy, filedownload, filezip, fileencrypt, filedelete
        // Push Transfer Type shows: filecopy, filezip, fileencrypt, filedelete (filedownload is filtered out)
        const fallbackFunctionTypes = mapStepFunctionOptions([
            'filecopy',
            'filedownload',
            'filezip',
            'fileencrypt',
            'filedelete',
        ]);

        // getEnvApiUrl: localhost-only; .env.local never ships — no effect in prod, test, staging, or CI builds.
        try {
            const functionTypes = await getRequest(getEnvApiUrl(Apis.FUNCTION_TYPE));

            // Check if we got valid data from the API
            if (
                functionTypes?.list &&
                Array.isArray(functionTypes.list) &&
                functionTypes.list.length > 0
            ) {
                this.selectFuncOptions = mapStepFunctionOptions(functionTypes.list);
            } else {
                // Use fallback data if API returns empty/invalid response
                console.warn('Using fallback Step Function data - API returned empty response');
                this.selectFuncOptions = fallbackFunctionTypes;
            }
        } catch (error) {
            // Use fallback data if API call fails (e.g., unauthorized)
            console.error('Failed to load Step Functions from API, using fallback data:', error);
            this.selectFuncOptions = fallbackFunctionTypes;
        }

        if (this.workflowTransferType === 'push' && this.selectFuncOptions.length > 0) {
            this.selectFuncOptions = this.selectFuncOptions.filter((element) => {
                return element.value != 'filedownload';
            });
        }

        if (this.transferType === 'push' && this.selectFuncOptions.length > 0) {
            this.selectFuncOptions = this.selectFuncOptions.filter(
                (element) => element.value != 'filedownload'
            );
        }

        // Fallback data for Source Types if API fails.
        // ACME-1940: FTPS omitted — not offered for new configuration (existing ftps steps still hydrate via setStorage).
        const fallbackSourceTypes = [
            { value: 'amazons3', name: 'Amazon S3' },
            { value: 'gcs', name: 'GCS' },
            { value: 'sftp', name: 'SFTP' },
            { value: 'azure', name: 'Azure' },
            { value: 'amazons3remote', name: 'Amazon S3 Remote' },
        ];

        // Fallback data for AWS Regions if API fails
        const fallbackRegions = [
            { value: 'us-east-1', name: 'us-east-1' },
            { value: 'us-east-2', name: 'us-east-2' },
            { value: 'us-west-1', name: 'us-west-1' },
            { value: 'us-west-2', name: 'us-west-2' },
            { value: 'eu-west-1', name: 'eu-west-1' },
            { value: 'eu-central-1', name: 'eu-central-1' },
            { value: 'ap-southeast-1', name: 'ap-southeast-1' },
            { value: 'ap-southeast-2', name: 'ap-southeast-2' },
            { value: 'ap-northeast-1', name: 'ap-northeast-1' },
        ];

        // getEnvApiUrl: localhost-only; .env.local never ships — no effect in prod, test, staging, or CI builds.
        try {
            const sourceTypes = await getRequest(getEnvApiUrl(Apis.SOURCE_TYPE));

            enum SourceType {
                amazons3 = 'Amazon S3',
                gcs = 'GCS',
                sftp = 'SFTP',
                ftps = 'FTPS', // label only for legacy hydrate / filteredSourceOptions AC3 path
                azure = 'Azure',
                amazons3remote = 'Amazon S3 Remote',
            }

            if (sourceTypes?.list && Array.isArray(sourceTypes.list) && sourceTypes.list.length > 0) {
                // ACME-1940: drop ftps from selectable lists even if the API still returns it.
                const withoutFtps = getRoleData(sourceTypes.list).filter(
                    (sourceType) => String(sourceType?.value ?? '').toLowerCase() !== 'ftps'
                );
                this.selectSourceOptions = withoutFtps.map((sourceType) => {
                    sourceType.name = SourceType[sourceType.value];
                    return sourceType;
                });
                this.allOptions = withoutFtps;
            } else {
                console.warn('Using fallback Source Type data - API returned empty response');
                this.selectSourceOptions = fallbackSourceTypes;
                this.allOptions = fallbackSourceTypes;
            }
        } catch (error) {
            console.error('Failed to load Source Types from API, using fallback data:', error);
            this.selectSourceOptions = fallbackSourceTypes;
            this.allOptions = fallbackSourceTypes;
        }

        // getEnvApiUrl: localhost-only; .env.local never ships — no effect in prod, test, staging, or CI builds.
        try {
            const regionData = await getRequest(getEnvApiUrl(Apis.AWS_REGION_LIST));

            if (regionData?.list && Array.isArray(regionData.list) && regionData.list.length > 0) {
                this.regionList = getRoleData(regionData.list).map((region) => {
                    region.name = region.value;
                    return region;
                });
            } else {
                console.warn('Using fallback AWS Region data - API returned empty response');
                this.regionList = fallbackRegions;
            }
        } catch (error) {
            console.error('Failed to load AWS Regions from API, using fallback data:', error);
            this.regionList = fallbackRegions;
        }
        // Add: do not reset FileRename after lookups — the wizard is typable during
        // load; wiping the map dropped pairs added via +.
        let origBaseline: string | null = null;
        let liveBefore: WorkflowStepPopupSnapshotInput | null = null;
        if (this.isEdit) {
            // Snapshot in-flight typing before hydrate merges editData onto formData.
            // Fold the hydrate result (not this live copy) so those edits stay dirty.
            origBaseline = this._cancelBaseline;
            liveBefore = {
                formData: { ...(this.formData as Record<string, unknown>) },
                dataFileList: Array.isArray(this.dataFileList) ? [...this.dataFileList] : this.dataFileList,
                dataFileName: this.dataFileName,
                sftpSshKeyReplaceMode: this.sftpSshKeyReplaceMode,
            };
            this.sftpSshKeyReplaceMode = false;
            this.DialogTitle = this.isViewOnly ? 'View Workflow Step' : 'Edit Workflow Step';
            // Merge editData onto the live form so keys the user did not touch (and
            // the empty-form defaults) stay put. Replacing the object would drop
            // those keys and make a key-presence fold look dirty on every Edit open.
            this.formData = {
                ...this.formData,
                ...JSON.parse(JSON.stringify(this.editData)),
            };
            this.formData.institutionUuid = readInstitutionUuidFromStep(
                this.formData as Record<string, unknown>
            );
            // Ensure file rename fields are never undefined
            this.formData.fileRenameKey = this.formData.fileRenameKey || '';
            this.formData.fileRenameValue = this.formData.fileRenameValue || '';
            this.isBucketRename =
                this.formData.bucketRename === undefined || this.formData.bucketRename === ''
                    ? false
                    : true;
            const persistedName = this.formData.name;
            this.setFunctionFlag(this.formData.functionName);
            {
                const rawSt = this.formData.storageType ?? this.formData.StorageType;
                if (rawSt != null && String(rawSt).trim() !== '') {
                    this.formData.storageType = String(rawSt).trim().toLowerCase();
                }
            }
            this.setStorage(this.formData.storageType);
            if (persistedName && (this.isEdit || this.isClone)) {
                const resolvedName =
                    resolveLegacyBucketRoleToken(persistedName) ??
                    (isValidBucketRoleToken(persistedName) ? persistedName : null);
                if (resolvedName) {
                    this.formData.name = resolvedName;
                    this.isFolderBucketNameDisable = true;
                    if (this.FileCopy && this.AMAZONS3) {
                        this.syncPullInternalS3DestRoleFromName(resolvedName);
                    }
                }
            }

            const authBase = normalizeSftpAuthType(this.formData.AuthType);
            this.formData.sourceAuthType = normalizeSftpAuthType(
                this.formData.sourceAuthType ?? this.formData.SourceAuthType ?? authBase
            );
            this.formData.destinationAuthType = normalizeSftpAuthType(
                this.formData.destinationAuthType ?? this.formData.DestinationAuthType ?? authBase
            );
            this.formData.AuthType = authBase;

            // Initialize validation flags when loading existing data
            this.recomputeBucketShapeValidityFromFormData();
            // Load file patterns / rename / bucket pattern from persisted step (both casings).
            this.applyPersistedRenameAndPatternFromForm();
            if (this.formData.secretValue != null) {
                this.formData.HostName =
                    this.formData.secretValue.Host != undefined && this.formData.secretValue.Host
                        ? this.formData.secretValue.Host
                        : '';
                this.formData.UserName =
                    this.formData.secretValue.UserName != undefined && this.formData.secretValue.UserName
                        ? this.formData.secretValue.UserName
                        : '';
                this.formData.Password =
                    this.formData.secretValue.Password != undefined && this.formData.secretValue.Password
                        ? this.formData.secretValue.Password
                        : '';
                this.originalPassword = this.formData.Password;
                this.formData.Port =
                    this.formData.secretValue.Port != undefined && this.formData.secretValue.Port
                        ? this.formData.secretValue.Port
                        : '';
                const svPk = this.formData.secretValue;
                this.formData.privateKey =
                    svPk.privateKey != undefined && svPk.privateKey !== ''
                        ? svPk.privateKey
                        : svPk.SshPrivateKeyReference != undefined && svPk.SshPrivateKeyReference !== ''
                            ? svPk.SshPrivateKeyReference
                            : svPk.sshPrivateKeyReference != undefined && svPk.sshPrivateKeyReference !== ''
                                ? svPk.sshPrivateKeyReference
                                : '';
                // PGPKey: check both PascalCase and camelCase
                const svPGPKey = this.formData.secretValue.PGPKey ?? this.formData.secretValue.pgpKey ?? '';
                if (svPGPKey) {
                    this.formData.PGPKey = svPGPKey;
                }
                // ConnectionString: check both PascalCase and camelCase
                const svConnectionString =
                    this.formData.secretValue.ConnectionString ??
                    this.formData.secretValue.connectionString ??
                    '';
                if (svConnectionString) {
                    this.formData.ConnectionString = svConnectionString;
                }
                // For RoleARN and Region, check secretValue with both PascalCase and camelCase
                // Only set from secretValue if it actually has a value (not empty string)
                const svRoleARN =
                    this.formData.secretValue.RoleARN ?? this.formData.secretValue.roleARN ?? '';
                const svRegion = this.formData.secretValue.Region ?? this.formData.secretValue.region ?? '';
                if (svRoleARN) {
                    this.formData.RoleARN = svRoleARN;
                }
                if (svRegion) {
                    this.formData.Region = svRegion;
                }
            }
            // AuthType is persisted on FileLocation (Dynamo authType), not in Secrets Manager — prefer top-level from API, then legacy secret.
            {
                const fromTop = this.formData.authType ?? this.formData.AuthType;
                const fromSv =
                    this.formData.secretValue?.AuthType ?? this.formData.secretValue?.authType;
                this.formData.AuthType = normalizeSftpAuthType((fromTop ?? fromSv) as string);
                if (this.formData.secretValue && typeof this.formData.secretValue === 'object') {
                    delete (this.formData.secretValue as Record<string, unknown>).AuthType;
                    delete (this.formData.secretValue as Record<string, unknown>).authType;
                }
            }
            // Template-string-input updates top-level ConnectionString / PGPKey; secretValue may still hold an old copy.
            // Prefer editData's top-level fields (from normalizeStep) so the wizard shows what was last saved.
            const editConnectionString =
                this.editData?.ConnectionString ?? this.editData?.connectionString ?? '';
            if (editConnectionString) {
                this.formData.ConnectionString = editConnectionString;
            }
            const editPGPKey = this.editData?.PGPKey ?? this.editData?.pgpKey ?? '';
            if (editPGPKey) {
                this.formData.PGPKey = editPGPKey;
            }
            const editRoleARN = this.editData?.RoleARN ?? this.editData?.roleARN ?? '';
            if (editRoleARN) {
                this.formData.RoleARN = editRoleARN;
            }
            const editRegion = this.editData?.Region ?? this.editData?.region ?? '';
            if (editRegion) {
                this.formData.Region = editRegion;
            }
            this.initialStepName = this.formData.functionName;
            this.initialStorageType = this.formData.storageType;
            if (
                this.formData.functionName &&
                this.formData.functionName === 'fileencrypt' &&
                !(this.isClone && this.formData.secretValue?.PGPKey === undefined)
            ) {
                this.pgpkeyPlaceholder = '*****';
            } else {
                this.pgpkeyPlaceholder = 'Enter valid PGP Public Key';
            }
            if (
                this.formData.storageType &&
                this.formData.storageType === 'azure' &&
                !(this.isClone && this.formData.secretValue?.ConnectionString === undefined)
            ) {
                this.connectionStringPlaceholder = '*****';
            } else {
                this.connectionStringPlaceholder = 'Enter valid Connection String';
            }
            if (
                ((this.formData.storageType && this.formData.storageType === 'ftps') ||
                    this.formData.storageType === 'sftp' ||
                    this.formData.storageType === 'amazons3remote') &&
                this.isClone &&
                this.formData.secretValue !== null
            ) {
                this.portPlaceholder = '*****';
                this.hostPlaceholder = '*****';
                this.sshKeyRefPlaceholder = '*****';
                this.userPlaceholder = '*****';
                this.passPlaceholder = '*****';
                this.roleARNPlaceholder = '*****';
                this.regionPlaceholder = '*****';
            } else {
                this.portPlaceholder = 'Enter valid port';
                this.hostPlaceholder = 'Enter valid Host Name';
                this.sshKeyRefPlaceholder = 'SSH private key';
                this.userPlaceholder = 'Enter valid username';
                this.passPlaceholder = 'Enter valid password';
                this.roleARNPlaceholder = 'Enter valid Role arn';
                this.regionPlaceholder = 'Select Region';
            }
        }

        // Fold only keys hydrate changed vs the pre-hydrate live snapshot — not the
        // whole form, which may still hold typing hydrate did not overwrite.
        if (this.isEdit && liveBefore) {
            this._cancelBaseline = applyWorkflowStepPopupBaselineDefaults(
                origBaseline,
                this.hydrateFoldDefaults(liveBefore),
            );
            this.restoreUserEditsAfterHydrate(origBaseline, liveBefore);
            this.applyPersistedRenameAndPatternFromForm();
        }

        this.requestUpdate();
        await this.updateComplete;
        if (this.isEdit) {
            // jha-form-input.updated() can dispatch change after first paint and
            // wipe bucketRename; re-apply once the wizard DOM exists.
            this.applyPersistedRenameAndPatternFromForm();
            this.requestUpdate();
            await this.updateComplete;
        }

        // Force re-render after all async operations complete.
        // This ensures jha-form-select displays the correct selected value
        // after both options and formData are loaded.
        await this.loadInstitutionsForStep();
        if (this.isEdit) {
            this.applyPersistedRenameAndPatternFromForm();
        }
        this.requestUpdate();
    }

    private cancelSnapshotInput() {
        return {
            formData: this.formData as Record<string, unknown>,
            dataFileList: this.dataFileList,
            dataFileName: this.dataFileName,
            sftpSshKeyReplaceMode: this.sftpSshKeyReplaceMode,
        };
    }

    /**
     * Snapshot keys hydrate changed relative to the pre-hydrate live form.
     * Keys the user typed that hydrate did not overwrite are omitted so they
     * are not absorbed into the baseline.
     */
    private hydrateFoldDefaults(
        liveBefore: WorkflowStepPopupSnapshotInput,
    ): WorkflowStepPopupSnapshotInput {
        const before = JSON.parse(
            captureWorkflowStepPopupBaseline(liveBefore),
        ) as Record<string, unknown>;
        const afterInput = this.cancelSnapshotInput();
        const after = JSON.parse(
            captureWorkflowStepPopupBaseline(afterInput),
        ) as Record<string, unknown>;
        const formData: Record<string, unknown> = {};
        const extras: WorkflowStepPopupSnapshotInput = {};
        const afterFd = afterInput.formData ?? {};
        for (const key of Object.keys(after)) {
            if (JSON.stringify(after[key]) === JSON.stringify(before[key])) continue;
            if (key === 'dataFileList') extras.dataFileList = afterInput.dataFileList;
            else if (key === 'dataFileName') extras.dataFileName = afterInput.dataFileName;
            else if (key === 'sftpSshKeyReplaceMode') {
                extras.sftpSshKeyReplaceMode = afterInput.sftpSshKeyReplaceMode;
            } else if (Object.prototype.hasOwnProperty.call(afterFd, key)) {
                formData[key] = afterFd[key];
            }
        }
        return { formData, ...extras };
    }

    /**
     * Re-apply fields the user changed during lookups after edit hydrate merged
     * editData onto formData. Compare against the pre-hydrate baseline so
     * hydrate-written values stay folded and in-flight edits remain dirty.
     */
    private restoreUserEditsAfterHydrate(
        origBaseline: string | null,
        liveBefore: WorkflowStepPopupSnapshotInput,
    ) {
        if (!origBaseline) return;
        const orig = JSON.parse(origBaseline) as Record<string, unknown>;
        const before = JSON.parse(
            captureWorkflowStepPopupBaseline(liveBefore),
        ) as Record<string, unknown>;
        const prev = liveBefore.formData ?? {};
        let restoredFunction = false;
        let restoredStorage = false;
        for (const key of Object.keys(before)) {
            if (JSON.stringify(before[key]) === JSON.stringify(orig[key])) continue;
            if (key === 'dataFileList') {
                const incoming = Array.isArray(liveBefore.dataFileList)
                    ? [...(liveBefore.dataFileList as unknown[])]
                    : [];
                // Empty pre-hydrate list must not wipe patterns loaded from the step.
                if (incoming.length === 0) continue;
                this.dataFileList = incoming;
            } else if (key === 'dataFileName') {
                this.dataFileName = String(liveBefore.dataFileName ?? '');
            } else if (key === 'sftpSshKeyReplaceMode') {
                this.sftpSshKeyReplaceMode = Boolean(liveBefore.sftpSshKeyReplaceMode);
            } else if (Object.prototype.hasOwnProperty.call(prev, key)) {
                const incoming = prev[key];
                if (key === 'fileRename' && Object.keys(coerceFileRenameMap(incoming)).length === 0) {
                    continue;
                }
                if (key === 'bucketRename' && !String(incoming ?? '').trim()) {
                    continue;
                }
                if (key === 'FileMovePattern' && (!Array.isArray(incoming) || incoming.length === 0)) {
                    continue;
                }
                (this.formData as Record<string, unknown>)[key] = incoming;
                if (key === 'functionName') restoredFunction = true;
                if (key === 'storageType') restoredStorage = true;
            }
        }
        if (restoredFunction) this.setFunctionFlag(this.formData.functionName);
        if (restoredStorage) this.setStorage(this.formData.storageType);
    }

    onInstitutionChange(e: Event) {
        const target = e.target as HTMLSelectElement & { value?: string };
        this.formData.institutionUuid = target?.value ?? '';
        this.institutionNotInList = false;
    }

    private appendOrphanInstitutionOption(selected: string, markNotInList = true) {
        if (!selected || this.institutionsOptions.some((o) => o.value === selected)) {
            return;
        }
        this.institutionsOptions = [
            ...this.institutionsOptions,
            {
                value: selected,
                name: `${selected} (no longer in list)`,
            },
        ];
        if (markNotInList) {
            this.institutionNotInList = true;
        }
    }

    private handleInstitutionsLoadFailure() {
        this.institutionsLoadFailed = true;
        this.institutionsOptions = [];
        const selected = readInstitutionUuidFromStep(
            this.formData as Record<string, unknown>
        );
        if (selected) {
            this.appendOrphanInstitutionOption(selected, false);
        }
    }

    private async loadInstitutionsForStep() {
        this.institutionNotInList = false;
        this.institutionsLoadFailed = false;
        const buId = this.buName?.trim() ?? "";
        if (!this.showInstitutionField || this.useTemplateVariables || !buId) {
            this.institutionsOptions = [];
            this.institutionsLoaded = true;
            return;
        }
        try {
            const url =
                Apis.INSTITUTION_ALL +
                `?businessUnitId=${fixedEncodeURIComponent(buId)}` +
                `&count=100000`;
            const response = await getRequest<InstitutionListResponse>(url);

            if (!response || response instanceof Response) {
                showToastMessage(
                    'Unable to load institutions for this business unit.',
                    'danger'
                );
                this.handleInstitutionsLoadFailure();
                return;
            }

            if (response.messageStatus === null) {
                const normalized = (response.institutions || [])
                    .map((row) =>
                        normalizeInstitution(row as Record<string, unknown>)
                    )
                    .filter((inst) => inst.institutionUuid.trim());
                this.institutionsOptions = normalized.map((inst) => ({
                    value: inst.institutionUuid,
                    name: `${inst.institutionRtId} - ${inst.institutionEnvironment}${inst.isDefault ? ' (Default)' : ''
                        }`,
                }));
                const selected = readInstitutionUuidFromStep(
                    this.formData as Record<string, unknown>
                );
                if (
                    selected &&
                    !normalized.some((inst) => inst.institutionUuid === selected)
                ) {
                    this.appendOrphanInstitutionOption(selected);
                }
            } else if (response.details?.length > 0) {
                showToastMessage(getErrorMessage(response.details), 'danger');
                this.handleInstitutionsLoadFailure();
            } else {
                showToastMessage(
                    'Unable to load institutions for this business unit.',
                    'danger'
                );
                this.handleInstitutionsLoadFailure();
            }
        } catch {
            showToastMessage(
                'Unable to load institutions for this business unit.',
                'danger'
            );
            this.handleInstitutionsLoadFailure();
        } finally {
            this.institutionsLoaded = true;
        }
    }

    firstUpdated() {
        super.firstUpdated?.();
        // First paint: jha-dialog is not in the tree during the initial connectedCallback.
        this.bindJhaDialogCancel();
        this.syncPage3DialogWidth();
    }

    updated(changed: Map<string, unknown>) {
        super.updated?.(changed);
        if (changed.has('activePage')) {
            this.syncPage3DialogWidth();
        }
    }

    /** Page 3 is sparse — narrow the dialog so it is not left-heavy empty space. */
    private syncPage3DialogWidth() {
        this.toggleAttribute('data-page3', stringComparison(this.activePage, 'page3'));
    }

    /**
     * X on inner jha-dialog fires CustomEvent('cancel') → DialogUtil closes immediately.
     * Intercept so X uses the same dirty gate as ESC. Idempotent for reconnect.
     */
    private bindJhaDialogCancel() {
        const jhaDialog = this.shadowRoot?.querySelector('jha-dialog');
        jhaDialog?.removeEventListener('cancel', this.handleJhaDialogCancel, true);
        jhaDialog?.addEventListener('cancel', this.handleJhaDialogCancel, true);
    }

    /**
     * jha-dialog header X (and footer Cancel if shown).
     * DialogUtil listens for bubbled `cancel` and closes without dirty checks — we must gate first.
     */
    private handleJhaDialogCancel = async (e: Event) => {
        if (this._forceClose) {
            return;
        }
        // Prompt is up — do not let X reach DialogUtil (that would skip the confirm).
        if (this._closePromptOpen) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }
        // View-only / no changes — let event reach DialogUtil (silent close).
        if (this.isViewOnly || !this.hasUnsavedChanges()) {
            return;
        }

        e.stopImmediatePropagation();
        e.preventDefault();

        if (await this.confirmClose()) {
            this.dispatchForceClose();
        }
    };

    /**
     * Native &lt;dialog&gt; cancel (ESC). Same dirty gate as the X button.
     * ACME-1050: no change → allow close; dirty → openJhftDialog (stacked, Windows-like).
     */
    async handleDialogCancel(e: Event) {
        if (this._forceClose) {
            return;
        }
        const target = e.target as Node | null;
        const hostDialog = this.closest('dialog');
        if (!hostDialog || target !== hostDialog) {
            return;
        }
        // Prompt is up (possibly non-modal over this shell). ESC still targets this
        // modal — keep preventDefault so the wizard cannot close past the confirm.
        if (this._closePromptOpen) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        // View-only / no changes — close silently (ACME-1050). Do not remove this gate.
        if (this.isViewOnly || !this.hasUnsavedChanges()) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (await this.confirmClose()) {
            this.dispatchForceClose();
        }
    }

    /**
     * Re-dispatch cancel so DialogUtil closes the shell after Leave Without Saving.
     * Leave `_forceClose` true until disconnect so a late/bubbled cancel cannot
     * re-open the prompt. The document listener stays; disconnectedCallback removes it.
     */
    private dispatchForceClose() {
        this._forceClose = true;
        const dialog = this.shadowRoot?.querySelector('jha-dialog');
        (dialog as any)?.dispatchDialogEvent?.('cancel');
    }

    private hasUnsavedChanges(): boolean {
        return isWorkflowStepPopupDirty(this._cancelBaseline, this.cancelSnapshotInput());
    }

    /**
     * Show confirmation before closing with unsaved changes.
     * openJhftDialog is a sibling modal on body (top layer) so ESC/backdrop stay
     * on the prompt. Returns true if the user wants to close.
     */
    async confirmClose(): Promise<boolean> {
        this._closePromptOpen = true;
        try {
            const result = await openJhftDialog({
                variant: 'warning',
                title: 'Unsaved Changes',
                message: 'You have unsaved changes. Are you sure you want to leave without saving?',
                cancelLabel: 'Stay',
                confirmLabel: 'Leave Without Saving',
            });
            if (result === 'confirm') {
                // Latch Leave before finally clears _closePromptOpen so a second X
                // cannot stack another prompt in the gap before dispatchForceClose.
                this._forceClose = true;
            }
            return result === 'confirm';
        } finally {
            this._closePromptOpen = false;
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up event listeners
        this.removeEventListener('modal-opened', this.handleModalOpened);
        this.removeEventListener('modal-closed', this.handleModalClosed);
        document.removeEventListener('cancel', this.handleDialogCancel, true);
        const jhaDialog = this.shadowRoot?.querySelector('jha-dialog');
        jhaDialog?.removeEventListener('cancel', this.handleJhaDialogCancel, true);
    }

    onDataFileNameChange(e) {
        this.dataFileName = e.target.value;
        const addReminder = this.shadowRoot?.querySelector('#add-reminder') as HTMLElement | null;
        const val = (e?.target?.value ?? '')?.toString() ?? '';

        // Show/hide reminder message based on input value
        if (addReminder) {
            if (val.trim() === '') {
                addReminder.style.display = 'none';
            } else {
                addReminder.style.display = '';
            }
        }

        // Update button state when field changes
        this.requestUpdate();
    }

    /**
     * Handle change from template-string-input for file pattern field
     * Updates dataFileName and shows/hides reminder message
     */
    onTemplateFilePatternChange(e: CustomEvent) {
        this.dataFileName = e.detail.value;
        const addReminder = this.shadowRoot?.querySelector(
            '#add-reminder-template'
        ) as HTMLElement | null;
        const val = (e?.detail?.value ?? '')?.toString() ?? '';

        // Show/hide reminder message based on input value
        if (addReminder) {
            if (val.trim() === '') {
                addReminder.style.display = 'none';
            } else {
                addReminder.style.display = '';
            }
        }

        // Update button state when field changes
        this.requestUpdate();
    }

    onStepFilePatternKeyDown(e: KeyboardEvent) {
        if (e.key !== 'Enter' || e.isComposing || this.isViewOnly) return;
        e.preventDefault();
        this.onDataFileAdd();
    }

    onDataFileAdd() {
        if (this.editDataPattern === false) {
            if (this.dataFileName != '') {
                const isAlreadyPresent = this.dataFileList.find(
                    (r) => r.toLowerCase() === this.dataFileName.toLowerCase()
                );
                if (!isAlreadyPresent) {
                    this.dataFileList = [...this.dataFileList, this.dataFileName];
                    this.dataFileName = '';

                    // Hide the reminder after adding
                    const addReminder = this.shadowRoot?.querySelector('#add-reminder') as HTMLElement | null;
                    if (addReminder) {
                        addReminder.style.display = 'none';
                    }
                    const addReminderTemplate = this.shadowRoot?.querySelector(
                        '#add-reminder-template'
                    ) as HTMLElement | null;
                    if (addReminderTemplate) {
                        addReminderTemplate.style.display = 'none';
                    }
                } else {
                    showToastMessage('Pattern already exists.', 'danger');
                }
                // Dirty tracks dataFileList; persist FileMovePattern (*-prefixed) only in addStep.
                this.rememberFilePatternsFromList();
                this.toUpdate = this.toUpdate == '' ? 'update' : '';
                this.requestUpdate();
            }
        } else if (this.editDataPattern === true) {
            if (this.dataFileName != '') {
                const isAlreadyPresent = this.dataFileList.find(
                    (r) => r.toLowerCase() === this.dataFileName.toLowerCase()
                );
                if (!isAlreadyPresent) {
                    this.dataFileList = [...this.dataFileList, this.dataFileName];
                    this.dataFileName = '';
                    this.editDataPattern = false;

                    // Hide the reminder after adding
                    const addReminder = this.shadowRoot?.querySelector('#add-reminder') as HTMLElement | null;
                    if (addReminder) {
                        addReminder.style.display = 'none';
                    }
                    const addReminderTemplate = this.shadowRoot?.querySelector(
                        '#add-reminder-template'
                    ) as HTMLElement | null;
                    if (addReminderTemplate) {
                        addReminderTemplate.style.display = 'none';
                    }
                } else {
                    showToastMessage('Pattern already exists.', 'danger');
                }
            }
            this.rememberFilePatternsFromList();
            this.toUpdate = this.toUpdate == '' ? 'update' : '';
            this.requestUpdate();
        }
    }

    onEditDataName(i) {
        this.dataFileName = i;
        this.editDataPattern = true;
        this.editDataFilePatternName = i;
        const deleteIndex = this.dataFileList.indexOf(i);
        if (deleteIndex >= 0) {
            this.dataFileList = this.dataFileList.filter((_, idx) => idx !== deleteIndex);
        }
        // Do not copy display list onto FileMovePattern — hydrate keeps *-prefixed
        // persisted values; overwriting with stripped names breaks dirty after clear.
        this.toUpdate = this.toUpdate == '' ? 'update' : '';
        this.requestUpdate();
    }

    onDeleteDataName(i) {
        const deleteIndex = this.dataFileList.indexOf(i);
        if (deleteIndex >= 0) {
            this.dataFileList = this.dataFileList.filter((_, idx) => idx !== deleteIndex);
        }
        this.rememberFilePatternsFromList();
        this.toUpdate = this.toUpdate == '' ? 'update' : '';
        this.requestUpdate();
    }

    addStep() {
        if (
            !this.UnprocessedFileArchive &&
            !this.FileDelete &&
            this.lastDelete &&
            !this.isEdit &&
            stringComparison(this.formData.deleteSourceFile, 'true')
        ) {
            showToastMessage(
                'Source File Is Set To Delete In Previous Step. Please Edit It To Continue',
                'danger'
            );
            this.toUpdate = this.toUpdate == '' ? 'update' : '';
        } else if (
            !this.UnprocessedFileArchive &&
            !this.FileDelete &&
            this.isEdit &&
            this.lastDelete &&
            stringComparison(this.formData.deleteSourceFile, 'true')
        ) {
            if (stringComparison(this.formData.deleteSourceFile, 'true')) {
                showToastMessage(
                    'Source File Is Set To Delete In Previous Step. Please Edit It To Continue',
                    'danger'
                );
                this.toUpdate = this.toUpdate == '' ? 'update' : '';
            }
        } else if (!this.effectiveFormValid) {
            const sshMsg = this.getSftpPrivateKeyBlockingMessage();
            if (sshMsg) {
                showToastMessage(sshMsg, 'danger');
                this.sftpPrivateKeyFormatMessage = sshMsg;
            } else if (this.useTemplateVariables && !this.validateAllCredentialFields()) {
                const invalidFields = this.getInvalidCredentialFields();
                if (invalidFields.length > 0) {
                    showToastMessage(
                        `Credential fields must use variables only: ${invalidFields.join(', ')}`,
                        'danger'
                    );
                } else {
                    showToastMessage('Please enter all required fields', 'danger');
                }
            } else {
                showToastMessage('Please enter all required fields', 'danger');
            }
            this.toUpdate = this.toUpdate == '' ? 'update' : '';
        } else {
            const sshBlock = this.getSftpPrivateKeyBlockingMessage();
            if (sshBlock) {
                showToastMessage(sshBlock, 'danger');
                this.sftpPrivateKeyFormatMessage = sshBlock;
                this.toUpdate = this.toUpdate == '' ? 'update' : '';
                return;
            }
            stringComparison(this.formData.deleteSourceFile, 'true') ? 'true' : 'false';
            this.syncFileRenameBeforePersist();
            this.addSecretValue();
            const patterns = this.resolvePersistedPatterns();
            if (patterns.length > 0) {
                this.formData.FileMovePattern = patterns;
                this.formData.fileMovePattern = patterns;
                this.formData.dataFileList = patterns.map((element) =>
                    element ? element.replace(element[0], '').replace('\\/', '/') : element
                );
            }
            const rename = this.resolvePersistedRenameMap();
            if (Object.keys(rename).length > 0) {
                this.formData.fileRename = rename;
                this.formData.FileRename = rename;
                this.formData.fileRenameList = Object.entries(rename).map((entry) => JSON.stringify(entry));
            }
            if (this.useTemplateVariables) {
                this.formData.name = toPersistedTemplatePullSmbBucketName(
                    this.workflowTransferType,
                    this.formData.functionName,
                    this.formData.storageType,
                    this.formData.name
                );
            }
            const dialog = this.shadowRoot.querySelector('jha-dialog');
            if (dialog) {
                dialog.dispatchDialogConfirm(JSON.parse(JSON.stringify(this.formData)));
            }
        }
    }

    closeStep() {
        const dialog = this.shadowRoot.querySelector('jha-dialog');
        if (!dialog) return;
        if (this.isViewOnly) {
            (dialog as { dispatchDialogEvent?: (name: string) => void }).dispatchDialogEvent?.('cancel');
            return;
        }
        dialog.dispatchDialogConfirm(this.formData);
    }

    addSecretValue() {
        if (this.SFTP) {
            const auth = normalizeSftpAuthType(this.formData.AuthType);
            const hostOk = this.formData.HostName != '' && this.formData.Port != '' && this.formData.UserName != '';
            const pwdOk = auth === SFTP_AUTH_TYPE.Password && this.formData.Password != '';
            const keyOk =
                auth === SFTP_AUTH_TYPE.SshKey && (this.isEdit || (this.formData.privateKey ?? '').toString().trim() !== '');
            if (hostOk && (pwdOk || keyOk)) {
                this.SecretValue = new Map();
                this.SecretValue.set(
                    'Host',
                    this.isEdit ? this.formData.HostName?.replace(/\*/g, '') : this.formData.HostName
                );
                this.SecretValue.set(
                    'Port',
                    this.isEdit ? this.formData.Port?.replace(/\*/g, '') : this.formData.Port
                );
                this.SecretValue.set(
                    'UserName',
                    this.isEdit ? this.formData.UserName?.replace(/\*/g, '') : this.formData.UserName
                );
                if (auth === SFTP_AUTH_TYPE.Password) {
                    this.SecretValue.set(
                        'Password',
                        this.isEdit ? this.formData.Password?.replace(/\*/g, '') : this.formData.Password
                    );
                } else {
                    const refRaw = this.isEdit
                        ? (this.formData.privateKey ?? '').replace(/\*/g, '')
                        : this.formData.privateKey ?? '';
                    if (refRaw) {
                        this.SecretValue.set('privateKey', refRaw);
                    }
                }
                this.formData.secretValue = Object.fromEntries(this.SecretValue);
            }
        } else if (this.FTPS) {
            if (
                this.formData.HostName != '' &&
                this.formData.Password != '' &&
                this.formData.Port != '' &&
                this.formData.UserName != ''
            ) {
                this.SecretValue = new Map();
                this.SecretValue.set(
                    'Host',
                    this.isEdit ? this.formData.HostName?.replace(/\*/g, '') : this.formData.HostName
                );
                this.SecretValue.set(
                    'Password',
                    this.isEdit ? this.formData.Password?.replace(/\*/g, '') : this.formData.Password
                );
                this.SecretValue.set(
                    'Port',
                    this.isEdit ? this.formData.Port?.replace(/\*/g, '') : this.formData.Port
                );
                this.SecretValue.set(
                    'UserName',
                    this.isEdit ? this.formData.UserName?.replace(/\*/g, '') : this.formData.UserName
                );
                this.formData.secretValue = Object.fromEntries(this.SecretValue);
            }
        }
        if (this.FileEncrypt) {
            // retainPGP is set by masked jha-form-input; template-string-input keeps value on formData.PGPKey only.
            const pgpRaw = this.retainPGP !== '' ? this.retainPGP : (this.formData.PGPKey ?? '');
            const pgpVal = this.isEdit ? pgpRaw.replace(/\*/g, '') : pgpRaw;
            if (pgpVal) {
                this.formData.secretValue = Object.fromEntries(new Map().set('PGPKey', pgpVal));
            }
        }
        if (this.AZURE) {
            // retainConnectionString is set by masked textarea; template-string-input updates formData.ConnectionString only.
            const csRaw =
                this.retainConnectionString !== ''
                    ? this.retainConnectionString
                    : (this.formData.ConnectionString ?? '');
            const csVal = this.isEdit ? csRaw.replace(/\*/g, '') : csRaw;
            if (csVal) {
                this.formData.secretValue = Object.fromEntries(new Map().set('ConnectionString', csVal));
            }
        }
        if (this.AMAZONS3REMOTE) {
            // Workflow templates: RoleARN and Region use template-string-input (like ConnectionString); persist to secretValue / credentialPlaceholders.
            if (this.useTemplateVariables) {
                const prev =
                    this.formData.secretValue &&
                        typeof this.formData.secretValue === 'object' &&
                        !Array.isArray(this.formData.secretValue)
                        ? { ...this.formData.secretValue }
                        : {};
                const arnRaw = this.isEdit
                    ? (this.formData.RoleARN ?? '').replace(/\*/g, '')
                    : (this.formData.RoleARN ?? '');
                const regRaw = this.isEdit
                    ? (this.formData.Region ?? '').replace(/\*/g, '')
                    : (this.formData.Region ?? '');
                const arnVal = String(arnRaw).trim();
                const regVal = String(regRaw).trim();
                if (arnVal) prev.RoleARN = arnVal;
                if (regVal) prev.Region = regVal;
                if (arnVal || regVal) {
                    this.SecretValue = new Map(Object.entries(prev));
                    this.formData.secretValue = prev;
                }
            } else if (this.formData.RoleARN != '' && this.formData.Region != '') {
                this.SecretValue = new Map();
                const arnRaw = this.isEdit
                    ? (this.formData.RoleARN ?? '').replace(/\*/g, '')
                    : (this.formData.RoleARN ?? '');
                const regRaw = this.isEdit
                    ? (this.formData.Region ?? '').replace(/\*/g, '')
                    : (this.formData.Region ?? '');
                this.SecretValue.set('RoleARN', String(arnRaw).trim());
                this.SecretValue.set('Region', String(regRaw).trim());
                this.formData.secretValue = Object.fromEntries(this.SecretValue);
            }
        }
    }

    get displayedFileRenameList(): string[] {
        if (this.fileRenameList?.length) return this.fileRenameList;
        if (this.retainedStepFileInfo.fileRenameList.length) {
            return this.retainedStepFileInfo.fileRenameList;
        }
        return this.committedFileRenameList;
    }

    get displayedDataFileList(): string[] {
        if (this.dataFileList?.length) return this.dataFileList;
        if (this.retainedStepFileInfo.dataFileList.length) {
            return this.retainedStepFileInfo.dataFileList;
        }
        return this.committedDataFileList;
    }

    private rememberFileRenameFromMap(): void {
        const map = Object.fromEntries(this.FileRename);
        const list = Object.entries(map).map((entry) => JSON.stringify(entry));
        this.fileRenameList = list;
        this.committedFileRenameList = [...list];
        this.formData.fileRename = map;
        this.formData.FileRename = map;
        this.formData.fileRenameList = [...list];
        this.retainedStepFileInfo.fileRename = { ...map };
        this.retainedStepFileInfo.fileRenameList = [...list];
    }

    private rememberFilePatternsFromList(writeFormPatterns = false): void {
        const display = Array.isArray(this.dataFileList) ? [...this.dataFileList] : [];
        const patterns = display.map((element) =>
            element ? '*'.concat(String(element).replace('/', '\\/')) : element
        );
        this.committedDataFileList = [...display];
        this.retainedStepFileInfo.dataFileList = [...display];
        this.retainedStepFileInfo.FileMovePattern = patterns;
        this.formData.dataFileList = [...display];
        if (writeFormPatterns) {
            this.formData.FileMovePattern = patterns;
            this.formData.fileMovePattern = patterns;
        }
    }

    private rememberBucketRename(value: string): void {
        const bucket = value == null ? '' : String(value);
        this.formData.bucketRename = bucket;
        this.formData.BucketRename = bucket;
        this.retainedStepFileInfo.bucketRename = bucket;
        this.isBucketRename = bucket !== '';
    }

    private seedRetainedFromStep(raw: Record<string, any> | null | undefined): void {
        if (!raw) return;
        const transferType = this.workflowTransferType ?? this.transferType ?? '';
        let map = readFileRenameFromLocation(raw);
        if (Object.keys(map).length === 0) {
            map = readFileRenameFromStep(raw, transferType, raw?.functionName);
        }
        if (Object.keys(map).length > 0) {
            this.FileRename = new Map(Object.entries(map));
            this.rememberFileRenameFromMap();
        }
        const bucket =
            readBucketRenameFromLocation(raw) ||
            readBucketRenameFromStep(raw, transferType, raw?.functionName);
        if (bucket) {
            this.rememberBucketRename(bucket);
        }
        const patterns = readFileMovePatternFromStep(raw);
        if (patterns.length > 0) {
            this.dataFileList = patterns.map((element) =>
                element ? element.replace(element[0], '').replace('\\/', '/') : element
            );
            this.rememberFilePatternsFromList(true);
        }
    }

    private resolvePersistedRenameMap(): Record<string, string> {
        if (Object.keys(this.retainedStepFileInfo.fileRename).length > 0) {
            return { ...this.retainedStepFileInfo.fileRename };
        }
        const fromMap = Object.fromEntries(this.FileRename);
        if (Object.keys(fromMap).length > 0) {
            return fromMap;
        }
        const fromForm = readFileRenameFromLocation(this.formData);
        if (Object.keys(fromForm).length > 0) {
            return fromForm;
        }
        const liveList = this.fileRenameList.length > 0 ? this.fileRenameList : this.committedFileRenameList;
        return readFileRenameFromLocation({ fileRenameList: liveList });
    }

    private resolvePersistedPatterns(): string[] {
        if (this.retainedStepFileInfo.FileMovePattern.length > 0) {
            return [...this.retainedStepFileInfo.FileMovePattern];
        }
        const live = this.dataFileList.length > 0 ? this.dataFileList : this.committedDataFileList;
        if (live.length > 0) {
            return live.map((element) => '*'.concat(element.replace('/', '\\/')));
        }
        return readFileMovePatternFromStep(this.formData);
    }

    private syncBucketRenameFromLiveInput(): void {
        const el = this.shadowRoot?.querySelector('[data-auto-id="bucketRenameInput"]') as
            | { value?: string }
            | null;
        const live = el?.value;
        if (live != null && String(live).trim() !== '') {
            this.rememberBucketRename(String(live));
            return;
        }
        const fromForm = readBucketRenameFromLocation(this.formData);
        if (fromForm) {
            this.rememberBucketRename(fromForm);
        }
    }

    /** Rebuild FileRename from fileRenameList when map/list desynced (e.g. pre-fix load race). */
    private syncFileRenameBeforePersist(): void {
        if (this.FileRename.size === 0 && this.fileRenameList.length > 0) {
            for (const item of this.fileRenameList) {
                const pair = JSON.parse(item) as [string, string];
                this.FileRename.set(pair[0], pair[1]);
            }
        }
        const map = this.resolvePersistedRenameMap();
        if (Object.keys(map).length > 0) {
            this.formData.fileRename = map;
            this.formData.FileRename = map;
            if (Object.keys(this.retainedStepFileInfo.fileRename).length === 0) {
                this.FileRename = new Map(Object.entries(map));
                this.rememberFileRenameFromMap();
            }
        }
        this.syncBucketRenameFromLiveInput();
        const bucket =
            this.retainedStepFileInfo.bucketRename || readBucketRenameFromLocation(this.formData);
        this.formData.bucketRename = bucket;
        this.formData.BucketRename = bucket;
    }

    /** Prefer retained bag / constructor snapshot — never replace a list with `[]`. */
    private applyPersistedRenameAndPatternFromForm(): void {
        const persisted = this.editStepSnapshot ?? this.editData;
        this.seedRetainedFromStep(persisted);
        const map = this.resolvePersistedRenameMap();
        if (Object.keys(map).length > 0) {
            this.FileRename = new Map(Object.entries(map));
            this.fileRenameList = Object.entries(map).map((entry) => JSON.stringify(entry));
            this.committedFileRenameList = [...this.fileRenameList];
            this.formData.fileRename = map;
            this.formData.FileRename = map;
        }

        const transferType = this.workflowTransferType ?? this.transferType ?? '';
        const bucket =
            this.retainedStepFileInfo.bucketRename ||
            readBucketRenameFromLocation(persisted) ||
            readBucketRenameFromStep(persisted, transferType, persisted?.functionName) ||
            readBucketRenameFromLocation(this.formData) ||
            readBucketRenameFromStep(this.formData, transferType, this.formData.functionName);
        if (bucket) {
            this.rememberBucketRename(bucket);
        }

        const patterns = this.resolvePersistedPatterns();
        if (patterns.length > 0) {
            this.dataFileList = patterns.map((element) =>
                element ? element.replace(element[0], '').replace('\\/', '/') : element
            );
            this.formData.FileMovePattern = patterns;
            this.formData.fileMovePattern = patterns;
            this.committedDataFileList = [...this.dataFileList];
        }
    }

    addFileRename() {
        if (this.editFilePattern === false) {
            if (
                this.hasValueOrVariable(this.formData.fileRenameKey) &&
                this.hasValueOrVariable(this.formData.fileRenameValue)
            ) {
                this.FileRename.set(this.formData.fileRenameKey.toString(), this.formData.fileRenameValue);
                this.formData.fileRenameKey = '';
                this.formData.fileRenameValue = '';
                this.rememberFileRenameFromMap();
                this.toUpdate = this.toUpdate == '' ? 'update' : '';
            } else if (
                this.hasValueOrVariable(this.formData.fileRenameKey) ||
                this.hasValueOrVariable(this.formData.fileRenameValue)
            ) {
                showToastMessage('Enter both File Rename Key and File Rename Value to add.', 'danger');
            }
        } else if (this.editFilePattern === true) {
            if (
                this.hasValueOrVariable(this.formData.fileRenameKey) &&
                this.hasValueOrVariable(this.formData.fileRenameValue)
            ) {
                this.FileRename.set(this.formData.fileRenameKey.toString(), this.formData.fileRenameValue);
                this.formData.fileRenameKey = '';
                this.formData.fileRenameValue = '';
                this.editFilePattern = false;
                this.rememberFileRenameFromMap();
                this.toUpdate = this.toUpdate == '' ? 'update' : '';
            } else if (
                this.hasValueOrVariable(this.formData.fileRenameKey) ||
                this.hasValueOrVariable(this.formData.fileRenameValue)
            ) {
                showToastMessage('Enter both File Rename Key and File Rename Value to add.', 'danger');
            }
        }
        this.requestUpdate();
    }

    onEditFileRename(i) {
        const deleteIndex = this.fileRenameList.indexOf(i);
        this.editFileIndex = deleteIndex;
        this.editFilePattern = true;
        this.editFileNameKeyBackup = i;
        const decipherJSON = JSON.parse(i);
        this.formData.fileRenameKey = decipherJSON[0];
        this.formData.fileRenameValue = decipherJSON[1];
        if (deleteIndex >= 0) {
            this.fileRenameList = this.fileRenameList.filter((_, idx) => idx !== deleteIndex);
        }
        this.FileRename.delete(decipherJSON[0]);
        this.rememberFileRenameFromMap();
        this.toUpdate = this.toUpdate == '' ? 'update' : '';
        this.requestUpdate();
    }

    onDeleteFileRename(i) {
        const deleteIndex = this.fileRenameList.indexOf(i);
        if (deleteIndex >= 0) {
            this.fileRenameList = this.fileRenameList.filter((_, idx) => idx !== deleteIndex);
        }
        const decipherJSON = JSON.parse(i);
        this.FileRename.delete(decipherJSON[0]);
        this.rememberFileRenameFromMap();
        this.toUpdate = this.toUpdate == '' ? 'update' : '';
        this.requestUpdate();
    }

    setBucketRename(e) {
        const value = e?.target?.value ?? e?.detail ?? '';
        this.rememberBucketRename(String(value));
    }

    /** Native `input` events carry `detail: 0`; read the typed text from the target. */
    onBucketPatternInput(e: Event) {
        this.setBucketRename(e);
        this.requestUpdate();
    }

    updatepgpkey(e) {
        this.updateProperty('PGPKey', e.target.value);
    }

    maskpgpkey(e) {
        this.retainPGP = e.target.value;
        this.updateProperty('PGPKey', '*'.repeat(e.target.value?.length));
    }

    unmaskpgpkey() {
        this.updateProperty('PGPKey', this.retainPGP);
    }

    preventNewLines(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
        }
    }

    onPasswordIconClick() {
        this.showPassword = !this.showPassword;
    }

    updateConnectionString(e) {
        let value = e.target.value;
        value = value.replace(/\s+/g, '');
        this.formData.ConnectionString = value;
        this.updateProperty('ConnectionString', value);
        e.target.value = value;
        this.azureConnectionStringUserEdited = true;
        this.secondPageConnectionStringWarning =
            azureConnectionStringWarning(value, { required: true }) !== null;
    }

    updateRoleARN(e) {
        const value = String(e.target.value ?? '').trim();
        // Binding .value to ***** on edit can emit change; that is not a user replacement.
        if (isMaskedAwsIamRoleArn(value)) {
            return;
        }
        const current = String(this.formData.RoleARN ?? '').trim();
        if (this.isEdit && !this.roleArnUserEdited && (value === current || !value)) {
            return;
        }
        this.formData.RoleARN = value;
        this.updateProperty('RoleARN', value);
        e.target.value = value;
        this.roleArnUserEdited = true;
        this.secondPageRoleARNWarning = awsIamRoleArnWarning(value, { required: true }) !== null;
    }

    maskConnectionString(e) {
        this.retainConnectionString = e.target.value;
        this.updateProperty('ConnectionString', '*'.repeat(e.target.value?.length));
    }

    unmaskConnectionString() {
        this.updateProperty('ConnectionString', this.retainConnectionString);
    }

    clearFileName() {
        if (this.editFilePattern) {
            if (this.editFileNameKeyBackup) {
                this.fileRenameList = [];
                const parsedEdit = JSON.parse(this.editFileNameKeyBackup);
                let entries = this.FileRename.entries();
                for (let entry of entries) {
                    this.fileRenameList.push(JSON.stringify(entry));
                    this.FileRename.set(entry[0], entry[1]);
                }
                this.fileRenameList.push(this.editFileNameKeyBackup);
                this.FileRename.set(parsedEdit[0], parsedEdit[1]);
                this.rememberFileRenameFromMap();
                this.editFileNameKeyBackup = '';
                this.formData.fileRenameKey = '';
                this.formData.fileRenameValue = '';
                this.editFilePattern = false;
                this.toUpdate = this.toUpdate == '' ? 'update' : '';
            }
        } else {
            this.formData.fileRenameKey = '';
            this.formData.fileRenameValue = '';
            this.editFileNameKeyBackup = '';
        }
        this.requestUpdate();
    }

    onDataFileNameClear() {
        if (this.editDataPattern) {
            // Undo onEditDataName list/input only. Leave FileMovePattern alone — it stays
            // in hydrate (*-prefixed) form until addStep so dirty matches baseline after cancel.
            this.dataFileList = [...this.dataFileList, this.editDataFilePatternName];
            this.editDataPattern = false;
            this.dataFileName = '';
            this.editDataFilePatternName = '';
            this.toUpdate = this.toUpdate == '' ? 'update' : '';
            this.requestUpdate();
        } else {
            this.dataFileName = '';
        }

        // Hide reminder messages for both template and non-template modes
        const addReminder = this.shadowRoot?.querySelector('#add-reminder') as HTMLElement | null;
        const addReminderTemplate = this.shadowRoot?.querySelector(
            '#add-reminder-template'
        ) as HTMLElement | null;

        if (addReminder) {
            addReminder.style.display = 'none';
        }
        if (addReminderTemplate) {
            addReminderTemplate.style.display = 'none';
        }

        // Simulate the change event to make the UI display warnings and reset the input field
        this.onDataFileNameChange({ target: { value: this.dataFileName } });
    }

    onSecretValueChange(e) {
        const val = e.detail.replace(/\*/g, '');
        this.retainPGP = this.retainPGP + val;
        this.updateProperty('PGPKey', this.retainPGP);
        this.formData.PGPKey = this.retainPGP;
    }

    countNewlines(str) {
        return str.split('\n').length - 1;
    }

    /**
     * Treat values containing template variables as valid for path/name validation
     */
    private hasTemplateVariable(value: string): boolean {
        return /\{[a-zA-Z0-9][a-zA-Z0-9_\-]*\}/.test(value);
    }

    // ============================================================================
    // PATH / BUCKET NAME SHAPE VALIDATION (ACME-1503)
    // Template mode: pure literals use workflow rules; {var} frames check structural
    // impossibility (boundaries + literal charset). Regular workflows unchanged.
    // ============================================================================

    private pathShapeAllowSpaces(): boolean {
        return this.AZURE || this.GCS;
    }

    private hasLiteralOutsidePlaceholders(value: string): boolean {
        return stripTemplateVariablePlaceholders(value).length > 0;
    }

    private shouldSkipTemplateNameShapeValidation(): boolean {
        if (
            this.isFolderBucketNameDisable &&
            isTemplatePullSmbBucketStep(
                this.workflowTransferType,
                this.formData.functionName,
                this.formData.storageType
            )
        ) {
            return true;
        }
        // Internal amazons3 persists {{home}}/{{cache}}/{{filepickup}} — not literal bucket names.
        return this.AMAZONS3 && isValidBucketRoleToken(this.formData.name ?? '');
    }

    private applyTemplateShapeWarning(
        templateInput: any,
        result: { valid: boolean; message: string },
        field: string,
        value: string
    ) {
        if (!templateInput) return;
        if (!result.valid && result.message) {
            templateInput.errorText = result.message;
            templateInput.forceShowWarning = true;
            return;
        }
        if (
            result.valid &&
            !this.isCredentialField(field) &&
            !this.fieldHasUndefinedVariables(value) &&
            !(
                field === 'privateKey' &&
                this.SFTP &&
                this.isSftpSshKeyAuth() &&
                this.sftpPrivateKeyFormatMessage
            )
        ) {
            templateInput.errorText = '';
            templateInput.forceShowWarning = false;
        }
    }

    /**
     * [ACME-1503] Recompute path/name shape flags for template-string-input fields.
     */
    private refreshTemplatePathOrNameShapeValidity(
        field: 'path' | 'name',
        value: string,
        templateInput?: any
    ) {
        if (!this.useTemplateVariables) return;

        if (field === 'name' && this.shouldSkipTemplateNameShapeValidation()) {
            this.bucketNameValid = true;
            return;
        }

        let result: { valid: boolean; message: string };
        if (field === 'path') {
            result = this.resolvePathFieldShape(value);
            this.bucketPathValid = Boolean(value) && result.valid;
            this.applyTemplateShapeWarning(templateInput, result, field, value);
            return;
        }

        if (this.isFolderBucketNameDisable) {
            this.bucketNameValid = true;
            return;
        }

        if (this.SFTP || this.FTPS) {
            result = this.resolveSftpFolderPathShape(value);
        } else if (this.AZURE || this.AMAZONS3 || this.GCS || this.AMAZONS3REMOTE) {
            result = this.resolveBucketContainerNameShape(value);
        } else {
            return;
        }

        this.bucketNameValid = Boolean(value) && result.valid;
        this.applyTemplateShapeWarning(templateInput, result, field, value);
    }

    /** Recompute bucketPathValid / bucketNameValid from formData (no DOM). */
    private recomputeBucketShapeValidityFromFormData() {
        const pathValue = this.formData.path ?? '';
        const nameValue = this.formData.name ?? '';

        if (this.SFTP || this.FTPS) {
            const nameResult = this.resolveNameFieldShape(nameValue);
            this.bucketNameValid = Boolean(nameValue) && nameResult.valid;
            this.bucketPathValid = false;
            return;
        }

        const pathResult = this.resolvePathFieldShape(pathValue);
        this.bucketPathValid = Boolean(pathValue) && pathResult.valid;

        if (
            this.shouldSkipTemplateNameShapeValidation() ||
            this.shouldHideLockedInternalS3BucketRoleInput()
        ) {
            if (this.shouldHideLockedInternalS3BucketRoleInput()) {
                const destOk =
                    !this.isPullFileCopyDestRoleSelectVisible() ||
                    this.hasValidPullInternalS3DestRole();
                this.bucketNameValid =
                    this.hasValidInternalS3ManagedBucketName(nameValue) && destOk;
            } else {
                this.bucketNameValid = true;
            }
        } else if (this.isFolderBucketNameDisable) {
            this.bucketNameValid = true;
        } else if (this.AMAZONS3 && isValidBucketRoleToken(nameValue)) {
            this.bucketNameValid = true;
        } else if (this.hasValueOrVariable(nameValue)) {
            const nameResult = this.resolveNameFieldShape(nameValue);
            this.bucketNameValid = nameResult.valid;
        } else {
            this.bucketNameValid = false;
        }
    }

    private resolveNameFieldShape(value: string): { valid: boolean; message: string } {
        if (this.SFTP || this.FTPS) {
            return this.resolveSftpFolderPathShape(value);
        }
        if (this.AZURE || this.AMAZONS3 || this.GCS || this.AMAZONS3REMOTE) {
            return this.resolveBucketContainerNameShape(value);
        }
        return { valid: false, message: '' };
    }

    private resolvePathFieldShape(value: string): { valid: boolean; message: string } {
        if (!value) {
            return { valid: false, message: '' };
        }
        if (this.useTemplateVariables && this.hasTemplateVariable(value)) {
            if (!this.hasLiteralOutsidePlaceholders(value)) {
                return { valid: true, message: '' };
            }
            return this.validateTemplateVariablePathFrame(value, this.pathShapeAllowSpaces());
        }
        return this.validateLiteralFolderBucketPath(value);
    }

    private resolveSftpFolderPathShape(value: string): { valid: boolean; message: string } {
        if (!value) {
            return { valid: false, message: '' };
        }
        if (this.useTemplateVariables && this.hasTemplateVariable(value)) {
            if (!this.hasLiteralOutsidePlaceholders(value)) {
                return { valid: true, message: '' };
            }
            return this.validateTemplateVariablePathFrame(value, false);
        }
        return this.validateLiteralSftpFolderPath(value);
    }

    private resolveBucketContainerNameShape(value: string): { valid: boolean; message: string } {
        if (!value) {
            return { valid: false, message: '' };
        }
        if (this.AMAZONS3 && isValidBucketRoleToken(value)) {
            return { valid: true, message: '' };
        }
        if (value.includes('/') || value.includes('\\')) {
            return {
                valid: false,
                message:
                    'Bucket/Container names cannot contain slashes. Please enter a valid name.',
            };
        }
        if (this.useTemplateVariables && this.hasTemplateVariable(value)) {
            const literal = stripTemplateVariablePlaceholders(value);
            if (literal.length === 0) {
                return { valid: true, message: '' };
            }
            if (!/^[a-zA-Z0-9._\-]*$/.test(literal)) {
                return {
                    valid: false,
                    message:
                        'Please enter a valid bucket/container name. Only alphanumeric characters, hyphens, underscores, and periods are allowed.',
                };
            }
            return { valid: true, message: '' };
        }
        return this.validateLiteralBucketContainerName(value);
    }

    /**
     * Template paths with {var}: fail only when no variable assignment can satisfy /…/ rules.
     */
    private validateTemplateVariablePathFrame(
        value: string,
        allowSpaces: boolean
    ): { valid: boolean; message: string } {
        const trimmed = value.trim();
        if (!trimmed) {
            return { valid: false, message: '' };
        }

        const first = trimmed[0];
        const last = trimmed[trimmed.length - 1];
        if (first !== '/' && first !== '{') {
            return {
                valid: false,
                message:
                    'Please enter a valid path. It must start with /. Example: /Folder/Path/',
            };
        }
        if (last !== '/' && last !== '}') {
            return {
                valid: false,
                message:
                    'Please enter a valid path. It must end with /. Example: /Folder/Path/',
            };
        }

        const literal = stripTemplateVariablePlaceholders(trimmed);
        if (literal.length === 0) {
            return { valid: true, message: '' };
        }

        return this.validatePathLiteralCharset(literal, allowSpaces);
    }

    /**
     * Charset rules for literal text outside {placeholders} in template paths.
     * ponytail: no per-segment boundary checks here — stripTemplateVariablePlaceholders
     * fuses literals (e.g. /{env}-data/ → /-data/) so segment rules would false-fail.
     */
    private validatePathLiteralCharset(
        literal: string,
        allowSpaces: boolean
    ): { valid: boolean; message: string } {
        if (!allowSpaces && /\s/.test(literal)) {
            return {
                valid: false,
                message: 'Please enter a valid input. Spaces are not allowed in the path.',
            };
        }
        if (allowSpaces && /\/ |\s\//.test(literal)) {
            return {
                valid: false,
                message:
                    'Please enter a valid input. Leading or trailing spaces are not allowed in the path.',
            };
        }

        const allowedPattern = allowSpaces
            ? /^[a-zA-Z0-9#_\-/ ]*$/
            : /^[a-zA-Z0-9#_\-/]*$/;
        if (!allowedPattern.test(literal)) {
            return {
                valid: false,
                message: allowSpaces
                    ? 'Please enter a valid path. Use letters, numbers, #, underscores, hyphens, and spaces only inside folder names.'
                    : 'Please enter a valid path. Each folder name may contain only letters, numbers, #, underscores, and hyphens.',
            };
        }

        return { valid: true, message: '' };
    }

    /** Full path validation for pure literals (regular + template workflow parity). */
    private validateLiteralFolderBucketPath(value: string): { valid: boolean; message: string } {
        if (!value) {
            return { valid: false, message: '' };
        }

        const allowSpaces = this.pathShapeAllowSpaces();
        const regex = allowSpaces
            ? /^(\/)([a-zA-Z0-9#_\-]+( [a-zA-Z0-9#_\-]+)*\/)*[a-zA-Z0-9#_\-]+( [a-zA-Z0-9#_\-]+)*\/$/
            : /^(\/)([a-zA-Z0-9#_\-]+\/)*[a-zA-Z0-9#_\-]+\/$/;
        const strRegex = allowSpaces ? /^[a-zA-Z0-9]/ : /^[a-zA-Z0-9]+$/;

        if (!value.startsWith('/')) {
            return {
                valid: false,
                message:
                    'Please enter a valid path. It must start with /. Example: /Folder/Path/',
            };
        }
        if (!value.endsWith('/')) {
            return {
                valid: false,
                message:
                    'Please enter a valid path. It must end with /. Example: /Folder/Path/',
            };
        }
        if (!allowSpaces && /\s/.test(value)) {
            return {
                valid: false,
                message: 'Please enter a valid input. Spaces are not allowed in the path.',
            };
        }
        if (allowSpaces && /\/ |\s\//.test(value)) {
            return {
                valid: false,
                message:
                    'Please enter a valid input. Leading or trailing spaces are not allowed in the path.',
            };
        }
        if (!regex.test(value)) {
            return {
                valid: false,
                message: allowSpaces
                    ? 'Please enter a valid path. Use letters, numbers, #, underscores, hyphens, and spaces only inside folder names.'
                    : 'Please enter a valid path. Each folder name may contain only letters, numbers, #, underscores, and hyphens.',
            };
        }

        const innerValues = value.split('/');
        for (const element of innerValues) {
            if (element === '') continue;
            if (allowSpaces) {
                if (
                    !strRegex.test(element[0]) ||
                    !/[a-zA-Z0-9]$/.test(element.slice(-1)) ||
                    element[0] === ' ' ||
                    element.slice(-1) === ' '
                ) {
                    return {
                        valid: false,
                        message:
                            'Please enter a valid input. Leading or trailing spaces are not allowed in the path.',
                    };
                }
            } else if (!strRegex.test(element[0]) || !strRegex.test(element.slice(-1))) {
                return {
                    valid: false,
                    message:
                        'Please enter a valid path. Each folder name must start and end with a letter or number.',
                };
            }
        }

        return { valid: true, message: '' };
    }

    private validateLiteralSftpFolderPath(value: string): { valid: boolean; message: string } {
        // Same rules and messages as Bucket Path (leading/trailing /, charset).
        // pathShapeAllowSpaces() is false for SFTP/FTPS, so spaces stay disallowed.
        return this.validateLiteralFolderBucketPath(value);
    }

    /**
     * Mirrors the API bucket rules (AppConstants.S3BucketRegex / GcsBucketRegex /
     * AzureContainerRegex) so the wizard blocks names the server would reject on save.
     * The API validates every step on every update with no unchanged-value exemption, so
     * there is deliberately no grandfathering here — letting a legacy name through would
     * only trade this inline message for an opaque "Invalid bucket name." toast later.
     *
     * ponytail: internal `amazons3` is intentionally left on the loose literal rule. Those
     * names are path-role tokens (`{{home}}`, `smb`, `destination`) already resolved by
     * isValidBucketRoleToken / isFolderBucketNameDisable above; tightening them here would
     * fight the ACME-1422 / ACME-1817 token machinery. Upgrade path: mirror
     * InternalBucketRoleValidation.IsValidFileLocationBucketNameForWrite.
     */
    private validateLiteralBucketContainerName(value: string): { valid: boolean; message: string } {
        if (this.AMAZONS3REMOTE) {
            if (IPV4_SHAPED_BUCKET_REGEX.test(value)) {
                return { valid: false, message: BUCKET_NAME_IP_MESSAGE };
            }
            return S3_BUCKET_NAME_REGEX.test(value)
                ? { valid: true, message: '' }
                : { valid: false, message: S3_BUCKET_NAME_MESSAGE };
        }

        if (this.GCS) {
            return GCS_BUCKET_NAME_REGEX.test(value)
                ? { valid: true, message: '' }
                : { valid: false, message: GCS_BUCKET_NAME_MESSAGE };
        }

        if (this.AZURE) {
            return AZURE_CONTAINER_NAME_REGEX.test(value)
                ? { valid: true, message: '' }
                : { valid: false, message: AZURE_CONTAINER_NAME_MESSAGE };
        }

        const regex = /^[a-zA-Z0-9][a-zA-Z0-9._\-]*[a-zA-Z0-9]$/;
        const singleCharRegex = /^[a-zA-Z0-9]$/;
        if (!regex.test(value) && !singleCharRegex.test(value)) {
            return {
                valid: false,
                message:
                    'Please enter a valid bucket/container name. Only alphanumeric characters, hyphens, underscores, and periods are allowed.',
            };
        }
        return { valid: true, message: '' };
    }

    private applyPathShapeToFormInput(
        dataAutoId: 'folderBucketPathInput' | 'nameInput',
        result: { valid: boolean; message: string },
        value: string,
        setValid: (valid: boolean) => void,
        updateField: 'path' | 'name'
    ) {
        const invalidField = this.shadowRoot?.querySelector(
            `jha-form-input[data-auto-id='${dataAutoId}']`
        ) as any;
        if (!result.valid && result.message) {
            if (invalidField) {
                invalidField.warning = result.message;
                invalidField.showWarning = true;
            }
            setValid(false);
        } else {
            if (invalidField) {
                invalidField.showWarning = false;
            }
            setValid(true);
        }
        this.updateProperty(updateField, value);
    }

    // ============================================================================
    // CREDENTIAL FIELD VALIDATION (WORKFLOW TEMPLATES ONLY)
    // ============================================================================
    //
    // IMPORTANT CONTEXT FOR DEVELOPERS AND AI:
    // -----------------------------------------
    // This component (AddWorkflowStepPopup) is shared between TWO different features:
    //
    // 1. REGULAR WORKFLOWS (useTemplateVariables = false):
    //    - Users enter LITERAL values (actual hostnames, passwords, etc.)
    //    - These values are stored securely and used directly to create workflows
    //    - Standard HTML inputs are rendered for credential fields
    //    - NO variable-only validation is applied
    //
    // 2. WORKFLOW TEMPLATES (useTemplateVariables = true):
    //    - Users enter VARIABLE PLACEHOLDERS like {HostName}, {Password}, etc.
    //    - Templates are stored and cannot contain actual secret values
    //    - template-string-input components are rendered for text fields
    //    - CREDENTIAL FIELDS MUST contain only variables (no literal text)
    //
    // The `useTemplateVariables` flag is the CRITICAL switch:
    // - It defaults to FALSE in the constructor
    // - Regular workflows (WorkflowStepsView.ts) do NOT pass this parameter
    // - Workflow templates (WorkflowTemplateStepsView.ts) pass TRUE
    //
    // NEVER remove the `if (!this.useTemplateVariables) return null;` checks below!
    // Doing so would break regular workflow creation by rejecting literal values.
    // ============================================================================

    /**
     * Check if a value contains ONLY variable placeholders (no literal text).
     *
     * WORKFLOW TEMPLATES ONLY:
     * This validation ensures credential fields in templates don't contain
     * literal secret values that would be stored insecurely. Users must use
     * variable placeholders that will be filled in when generating a workflow.
     *
     * Valid examples:
     *   - "{Password}" - single variable
     *   - "{Host}" - single variable
     *   - "{host}{domain}" - multiple consecutive variables
     *   - "{host}.{domain}" - variables with separator (e.g., for FQDNs)
     *   - "{user}-{suffix}" - variables with dash separator
     *
     * Invalid examples:
     *   - "mypassword" - literal text (security risk)
     *   - "host.example.com" - literal text
     *   - "prefix{var}" - literal text before variable
     *   - "{var}suffix" - literal text after variable
     *   - "a password and {var}" - mixed literal and variable
     *
     * The rule: Remove all {variableName} placeholders - if anything remains
     * other than dots/dashes/underscores between variables, it's invalid.
     */
    private isVariableOnly(value: string): boolean {
        if (!value || value.trim().length === 0) return false;
        const trimmed = value.trim();
        const withoutVariables = stripTemplateVariablePlaceholders(trimmed);
        if (withoutVariables.length === 0) return true;
        return /^[\.\-_]*$/.test(withoutVariables);
    }

    /**
     * List of credential/secret fields that must be variable-only in TEMPLATES.
     *
     * WORKFLOW TEMPLATES ONLY:
     * These fields contain sensitive data (passwords, keys, connection strings).
     * In regular workflows, users enter actual values that are stored securely.
     * In templates, these MUST be variables because templates are stored as
     * configuration and cannot contain actual secrets.
     *
     * When generating a workflow from a template, users provide actual values
     * for these variables, which are then stored securely in the workflow.
     */
    private static readonly CREDENTIAL_FIELDS = [
        'HostName',
        'Port',
        'UserName',
        'Password',
        'privateKey', // SFTP SSH key secret reference (templates)
        'PGPKey', // File Encryption step function
        'ConnectionString', // Azure storage type
        'RoleARN', // AWS S3 Remote
    ];

    /**
     * Check if a field is a credential field that requires variable-only values.
     * See CREDENTIAL_FIELDS for the list of affected fields.
     */
    private isCredentialField(fieldName: string): boolean {
        return AddWorkflowStepPopup.CREDENTIAL_FIELDS.includes(fieldName);
    }

    /**
     * Validate a credential field value - must be a variable placeholder only.
     *
     * CRITICAL: This validation ONLY applies when useTemplateVariables is TRUE.
     *
     * For REGULAR WORKFLOWS (useTemplateVariables = false):
     *   - Returns null immediately (no validation error)
     *   - Users can enter literal values like actual passwords and hostnames
     *   - These values are stored securely in the workflow
     *
     * For WORKFLOW TEMPLATES (useTemplateVariables = true):
     *   - Validates that credential fields contain ONLY variable placeholders
     *   - Rejects literal text to prevent storing secrets in templates
     *   - Examples: {Password} is valid, "mypassword" is invalid
     *
     * DO NOT remove the useTemplateVariables check - it would break regular workflows!
     */
    private validateCredentialField(fieldName: string, value: string): string | null {
        // CRITICAL: Only validate in template mode. Regular workflows allow literal values.
        if (!this.useTemplateVariables) return null;

        // S3 Remote Region: API rejects literals in credentialPlaceholders — only built-in `{BUILTIN_REGION_VARIABLE}`.
        if (fieldName === 'Region' && this.AMAZONS3REMOTE) {
            if (!value || !value.trim()) return null;
            if (this.isValidTemplateS3RegionOrBuiltin(value)) return null;
            return 'Choose Use template variable… (region is set when you generate a workflow from this template).';
        }

        // Not a credential field - no special validation needed
        if (!this.isCredentialField(fieldName)) return null;

        // Empty is ok here - required validation is handled separately
        if (!value || value.trim().length === 0) return null;

        if (fieldName === 'privateKey' && looksLikeSshPrivateKeyPem(value.trim())) {
            return 'Workflow templates cannot include raw private key PEM. Use a variable for a Secrets Manager secret name or ARN.';
        }

        // In template mode, credential fields must contain only variables
        if (!this.isVariableOnly(value)) {
            return `${fieldName} must use a variable (e.g., {${fieldName}}).`;
        }
        return null;
    }

    /**
     * Normalize file rename key/value for validation and UI hints.
     * Strips zero-width / BOM characters that can make inputs look empty while still
     * satisfying String.trim() / hasValueOrVariable — which caused the "+" reminder to show spuriously.
     */
    private normalizeFileRenameFieldValue(value: unknown): string {
        if (value === undefined || value === null) return '';
        if (typeof value !== 'string') return '';
        return value.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
    }

    /**
     * Check if a field has a usable value (or template variable) to avoid false validation toasts.
     */
    private hasValueOrVariable(value: string | undefined | null): boolean {
        if (value === undefined || value === null) return false;
        const trimmed = value.toString().trim();
        if (trimmed.length === 0) return false;
        if (this.useTemplateVariables && this.hasTemplateVariable(trimmed)) return true;
        return trimmed.length > 0;
    }

    /**
     * Handle immediate input for file rename key/value (non-template inputs)
     */
    onFileRenameInput(field: 'fileRenameKey' | 'fileRenameValue', e: Event) {
        const value = (e.target as any)?.value ?? '';
        this.formData[field] = value;
        this.requestUpdate();
    }

    onFolderBucketPathChange(e) {
        var value = typeof e === 'string' ? e : (e?.target?.value ?? '');
        if (value) {
            const result = this.resolvePathFieldShape(value);
            this.applyPathShapeToFormInput(
                'folderBucketPathInput',
                result,
                value,
                (valid) => {
                    this.bucketPathValid = valid;
                },
                'path'
            );
        } else {
            this.bucketPathValid = false;
            this.updateProperty('path', value);
        }
        this.requestUpdate();
    }

    onFolderBucketNameChange(e) {
        var value = typeof e === 'string' ? e : (e?.target?.value ?? '');
        if (this.FTPS || this.SFTP) {
            if (value) {
                const result = this.resolveSftpFolderPathShape(value);
                this.applyPathShapeToFormInput(
                    'nameInput',
                    result,
                    value,
                    (valid) => {
                        this.bucketNameValid = valid;
                    },
                    'name'
                );
            } else {
                this.bucketNameValid = false;
                this.updateProperty('name', value);
            }
        } else if (this.AZURE || this.AMAZONS3 || this.GCS || this.AMAZONS3REMOTE) {
            if (this.isFolderBucketNameDisable) {
                if (this.shouldHideLockedInternalS3BucketRoleInput()) {
                    const destOk =
                        !this.isPullFileCopyDestRoleSelectVisible() ||
                        this.hasValidPullInternalS3DestRole();
                    this.bucketNameValid =
                        this.hasValidInternalS3ManagedBucketName(value) && destOk;
                } else {
                    this.bucketNameValid = true;
                }
                this.updateProperty('name', value);
            } else if (value) {
                const result = this.resolveBucketContainerNameShape(value);
                this.applyPathShapeToFormInput(
                    'nameInput',
                    result,
                    value,
                    (valid) => {
                        this.bucketNameValid = valid;
                    },
                    'name'
                );
            } else {
                this.bucketNameValid = false;
                this.updateProperty('name', value);
            }
        } else {
            this.bucketNameValid = false;
            this.updateProperty('name', value);
        }
        this.requestUpdate();
    }

    /**
     * Storage Type picker options. ACME-1940: FTPS is never offered for new selection.
     * If the step already has storageType ftps (legacy), keep a single FTPS option so the
     * control can display the current value without crashing; switching away removes it.
     */
    get filteredSourceOptions() {
        const opts = (this.selectSourceOptions || []).filter(
            (o) => String(o?.value ?? '').toLowerCase() !== 'ftps'
        );
        const st = String(this.formData?.storageType ?? '').trim().toLowerCase();
        if (st === 'ftps') {
            return [...opts, { value: 'ftps', name: 'FTPS' }];
        }
        return opts;
    }

    renderPageOne() {
        return html`
      <jha-slider-pane pane-id="page1" focus>
        <article>
          <div id="paneDiv">
            <h3>General Information</h3>
            <div id="inputsDiv">
              ${this.useTemplateVariables
                ? html`
                    <jha-tooltip top text="Enter Step Name. Use variables via icon or '{'.">
                      <template-string-input
                        data-auto-id="stepNameSelect"
                        label="Step Name"
                        placeholder="Enter Step Name or {variable}"
                        maxlength="256"
                        .required=${true}
                        .disabled=${this.isViewOnly}
                        .value=${this.formData.stepName}
                        .options=${this.variableOptions}
                        variableDropdownPosition="bottom"
                        variableButtonTooltipPosition="bottom-right"
                        @change=${(e) => this.onTemplateInputChange('stepName', e)}
                        @template-input-blur=${(e) => this.onTemplateInputBlur('stepName', e)}
                        @variable-added=${this.onVariableAdded}
                      >
                      </template-string-input>
                    </jha-tooltip>
                  `
                : html`
                    <jha-tooltip
                      top
                      text="Enter a unique Step Name to describe the step. Max length of 256 characters. Allowed characters . _ - , ; @ ( )"
                    >
                      <jha-form-input
                        required
                        warning="Step Name is required"
                        ?showWarning=${this.firstPageStepWarning}
                        type="text"
                        id="stepName"
                        label="Step Name"
                        placeholder="Enter Step Name"
                        outline
                        data-id="stepName"
                        data-auto-id="stepNameSelect"
                        .value=${this.formData.stepName}
                        @change=${this.inputValueChange}
                        ?disabled=${this.isViewOnly}
                        maxlength="256"
                        pattern="^[A-Za-z0-9._\\-\\s\\,\\;\\@\\(\\)]+$"
                      >
                      </jha-form-input>
                    </jha-tooltip>
                  `}

              <!-- TODO: Step Function dropdown - needs special handling for variable support when useTemplateVariables=true -->
              <jha-tooltip bottom-right text="Select step to be performed.">
                <jha-form-select
                  outline
                  .options=${this.selectFuncOptions}
                  label="Step Function"
                  labelKey="name"
                  valueKey="value"
                  required
                  warning="Step is required"
                  ?showWarning=${this.firstPageFunctionWarning}
                  data-id="functionName"
                  data-auto-id="functionNameInput"
                  .value=${this.formData.functionName || ''}
                  @change=${this.onFunctionChange}
                  ?disabled=${this.isViewOnly}
                  isValid
                  placeholder="Select Step Function"
                  emptyOptionLabel="Select Step Function"
                >
                </jha-form-select>
              </jha-tooltip>
              ${!this.useTemplateVariables && this.showInstitutionField
                ? html`
                    <jha-tooltip
                      bottom
                      text="Optionally associate this step with an institution for this business unit."
                    >
                      <jha-form-select
                        outline
                        .options=${this.institutionsOptions}
                        label="Institution"
                        labelKey="name"
                        valueKey="value"
                        data-auto-id="institutionSelect"
                        .value=${this.formData.institutionUuid || ''}
                        @change=${this.onInstitutionChange}
                        ?disabled=${this.isViewOnly}
                        isValid
                        placeholder="Select Institution (optional)"
                        emptyOptionLabel="No institution selected"
                      >
                      </jha-form-select>
                    </jha-tooltip>
                    ${this.institutionsLoaded && this.institutionsLoadFailed
                        ? html`<p class="institution-guidance">
                          Unable to load institutions. You may continue without one or try again
                          later.
                        </p>`
                        : nothing}
                    ${this.institutionsLoaded &&
                        !this.institutionsLoadFailed &&
                        (this.buName ?? '').trim() &&
                        this.institutionsOptions.length === 0
                        ? html`<p class="institution-guidance">
                          No institutions found for this business unit. Create institutions in
                          <a
                            href="/business-units/${fixedEncodeURIComponent(
                            (this.buName ?? '').trim()
                        )}/institutions"
                            >Business Unit Management</a
                          >
                          first.
                        </p>`
                        : nothing}
                    ${this.institutionNotInList && !this.institutionsLoadFailed
                        ? html`<p class="institution-guidance">
                          The saved institution is not in the current list. You may keep it or
                          choose another.
                        </p>`
                        : nothing}
                  `
                : nothing}
            </div>
          </div>
        </article>
      </jha-slider-pane>
    `;
    }

    renderStorageSelect() {
        // TODO: Storage Type dropdown - needs special handling for variable support when useTemplateVariables=true
        return html`
      <jha-tooltip bottom text="Select the storage type from list.">
        <jha-form-select
          outline
          .options=${this.filteredSourceOptions}
          label="Storage Type"
          required
          ?showWarning=${this.secondPagStorageWarning}
          warning="Storage Type is required"
          labelKey="name"
          data-id="storageType"
          data-auto-id="storageTypeSelect"
          value=${this.formData.storageType}
          valueKey="value"
          @change=${this.onStorageTypeChange}
          ?disabled=${this.isStorageDisabled || this.isViewOnly}
          isValid
          placeholder="Select Storage Type"
          emptyOptionLabel="Select Storage Type"
        >
        </jha-form-select>
      </jha-tooltip>
    `;
    }

    renderPullFileCopyDestRoleSelect() {
        if (!this.isPullFileCopyDestRoleSelectVisible()) {
            return html``;
        }

        return html`
      <jha-tooltip bottom-right text="Home delivers to a participant home folder (enter its Folder Location as the Bucket Path). File pickup is for an S3 destination that can be given external access. SMB share uses the per-BU SMB bucket.">
        <jha-form-select
          outline
          data-auto-id="pullInternalS3DestRoleSelect"
          .options=${PULL_FILECOPY_DEST_ROLE_FORM_OPTIONS}
          label="Destination Bucket Role"
          labelKey="name"
          valueKey="value"
          .value=${this.pullInternalS3DestRole}
          @change=${this.onPullInternalS3DestRoleChange}
          ?disabled=${this.isViewOnly}
          required
          ?showWarning=${this.secondPagePullDestRoleWarning}
          warning="Destination bucket role is required"
          ?isValid=${!this.secondPagePullDestRoleWarning}
          placeholder="Select destination bucket role"
          emptyOptionLabel="Select Destination bucket role"
        >
        </jha-form-select>
      </jha-tooltip>
    `;
    }

    renderInternalS3BucketFields() {
        return html`
      ${this.renderPullFileCopyDestRoleSelect()}
      ${this.renderBucketRenameInput()}
    `;
    }

    renderBucketRenameInput() {
        if (this.shouldHideLockedInternalS3BucketRoleInput()) {
            return html``;
        }

        const internalS3RoleField = this.AMAZONS3;
        const label = this.AZURE
            ? 'Bucket/Container Name'
            : internalS3RoleField
                ? 'Bucket role'
                : this.GCS || this.AMAZONS3REMOTE
                    ? 'Bucket Name'
                    : this.SFTP || this.FTPS
                        ? 'Folder Path'
                        : 'Name';

        const placeholder = this.AZURE
            ? 'Eg: Bucket/Container Name'
            : internalS3RoleField
                ? BUCKET_ROLE_HOME
                : this.GCS || this.AMAZONS3REMOTE
                    ? 'Bucket Name'
                    : this.SFTP || this.FTPS
                        ? '/Folder/Path/'
                        : 'Name';

        const required = !this.isBucketRename;

        const warning = this.AZURE
            ? 'Bucket/Container Name is required'
            : internalS3RoleField
                ? 'Bucket role is required'
                : this.GCS || this.AMAZONS3REMOTE
                    ? 'Bucket Name is required'
                    : this.SFTP || this.FTPS
                        ? 'Folder Path is required'
                        : 'Name is required';

        // Use template-string-input when useTemplateVariables is true
        if (this.useTemplateVariables) {
            const nameTooltip =
                this.SFTP || this.FTPS
                    ? "Enter the Folder Path. Path should start and end with '/'. Use '{' for variables."
                    : `Enter the ${label}. Use '{' for variables.`;
            return html`
        <jha-tooltip bottom-right text=${nameTooltip}>
          <template-string-input
            data-auto-id="nameInput"
            label=${label}
            placeholder=${placeholder}
            maxlength="256"
            .required=${required}
            .disabled=${this.isFolderBucketNameDisable || this.isViewOnly}
            .value=${this.formData.name}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('name', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('name', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>
      `;
        }

        if (this.isBucketRename) {
            return html`
        <jha-tooltip bottom-right text="Enter the ${label}. Max length of 256 characters.">
          <jha-form-input
            type="text"
            label=${label}
            placeholder=${placeholder}
            outline
            data-id="name"
            data-auto-id="nameInput"
            .value=${this.formData.name}
            ?disabled=${this.isFolderBucketNameDisable || this.isViewOnly}
            @change=${this.onFolderBucketNameChange}
            maxlength="256"
          >
          </jha-form-input>
        </jha-tooltip>
      `;
        }

        const plainNameTooltip =
            this.SFTP || this.FTPS
                ? "Enter the Folder Path. Path should start and end with '/'. Max length of 256 characters."
                : `Enter the ${label}. Max length of 256 characters.`;

        return html`
      <jha-tooltip bottom-right text=${plainNameTooltip}>
        <jha-form-input
          required
          ?showWarning=${this.secondPageNameWarning}
          warning=${warning}
          type="text"
          label=${label}
          placeholder=${placeholder}
          outline
          data-id="name"
          data-auto-id="nameInput"
          .value=${this.formData.name}
          ?disabled=${this.isFolderBucketNameDisable || this.isViewOnly}
          @change=${this.onFolderBucketNameChange}
          maxlength="256"
        >
        </jha-form-input>
      </jha-tooltip>
    `;
    }

    renderPathInput() {
        if (this.FTPS || this.SFTP) {
            return html``;
        }
        const label = this.AZURE
            ? 'Bucket/Container Path'
            : this.AMAZONS3 || this.GCS || this.AMAZONS3REMOTE
                ? 'Bucket Path'
                : 'Path';
        const warning = `${label} is required`;

        // Use template-string-input when useTemplateVariables is true
        // Note: No wrapper div or <p> element needed - template-string-input aligns correctly
        // with renderBucketRenameInput() without the legacy alignment hacks
        if (this.useTemplateVariables) {
            return html`
        <jha-tooltip bottom-right text="Enter the ${label}. Use '{' for variables.">
          <template-string-input
            data-auto-id="folderBucketPathInput"
            label=${label}
            placeholder="Eg: /Folder/Path/"
            maxlength="256"
            .required=${true}
            .disabled=${this.isViewOnly}
            .value=${this.formData.path}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('path', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('path', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>
      `;
        }

        return html`
      <div>
        <p style="height:1%;margin-top:-4%;"></p>
        <jha-tooltip
          bottom
          text="Enter the ${this.AZURE
                ? '/bucket/containerpath/'
                : this.AMAZONS3 || this.GCS || this.AMAZONS3REMOTE
                    ? '/Folder/Path/'
                    : 'Path'}. Path should start and end with '/' . Max length of 256 characters."
        >
          <jha-form-input
            required
            ?showWarning=${this.secondPagePathWarning}
            warning="${warning}"
            type="text"
            label=${label}
            placeholder="Eg: /Folder/Path/"
            outline
            data-id="path"
            data-auto-id="folderBucketPathInput"
            .value=${this.formData.path}
            @change=${this.onFolderBucketPathChange}
            ?disabled=${this.isViewOnly}
            maxlength="256"
          >
          </jha-form-input>
        </jha-tooltip>
      </div>
    `;
    }

    renderFileRenameSection() {
        const showRenameReminder = this.hasPendingFileRename;
        return html`
      <div class="file-rename-section">
        <div class="file-rename-row">
          ${this.useTemplateVariables
                ? html`
                <jha-tooltip top text="Rename Key (optional). Use '{' for variables.">
                  <template-string-input
                    data-auto-id="fileRenameKeyInput"
                    label="File Rename Key"
                    placeholder="Enter Key"
                    maxlength="256"
                    .disabled=${this.isViewOnly}
                    .value=${this.formData.fileRenameKey || ''}
                    .options=${this.variableOptions}
                    variableButtonTooltipPosition="top-right"
                    @change=${(e) => this.onTemplateRenameChange('fileRenameKey', e)}
                    @variable-added=${this.onVariableAdded}
                  >
                  </template-string-input>
                </jha-tooltip>
              `
                : html`
                <jha-tooltip
                  bottom
                  text="Enter Rename Key to search for in original filename. Max length of 256 characters. (Optional)"
                >
                  <jha-form-input
                    label="File Rename Key"
                    type="text"
                    data-id="fileRenameKey"
                    data-auto-id="fileRenameKeyInput"
                    .value=${this.formData.fileRenameKey || ''}
                    @change=${this.inputValueChange}
                    @input=${(e) => this.onFileRenameInput('fileRenameKey', e)}
                    ?disabled=${this.isViewOnly}
                    outline
                  >
                  </jha-form-input>
                </jha-tooltip>
              `}
          ${this.useTemplateVariables
                ? html`
                <jha-tooltip top-left text="Rename Value (optional). Use '{' for variables.">
                  <template-string-input
                    data-auto-id="fileRenameValueInput"
                    label="File Rename Value"
                    placeholder="Enter Value"
                    maxlength="256"
                    .disabled=${this.isViewOnly}
                    .value=${this.formData.fileRenameValue || ''}
                    .options=${this.variableOptions}
                    variableButtonTooltipPosition="top-right"
                    @change=${(e) => this.onTemplateRenameChange('fileRenameValue', e)}
                    @variable-added=${this.onVariableAdded}
                  >
                  </template-string-input>
                </jha-tooltip>
              `
                : html`
                <jha-tooltip
                  bottom
                  text="Enter Rename Value to replace key. Max length of 256 characters. (optional)"
                >
                  <jha-form-input
                    label="File Rename Value"
                    type="text"
                    data-id="fileRenameValue"
                    data-auto-id="fileRenameValueInput"
                    .value=${this.formData.fileRenameValue || ''}
                    @change=${this.inputValueChange}
                    @input=${(e) => this.onFileRenameInput('fileRenameValue', e)}
                    ?disabled=${this.isViewOnly}
                    outline
                  >
                  </jha-form-input>
                </jha-tooltip>
              `}
          ${this.editFilePattern
                ? html`
                <jha-button
                  data-auto-id="clearFileRenameBtn"
                  class="file-rename-add-btn"
                  icon
                  sync
                  @click=${this.clearFileName}
                  type="button"
                >
                  <jha-icon-circle-close></jha-icon-circle-close>
                </jha-button>
              `
                : undefined}
          <jha-tooltip bottom text="Click to add file rename." class="file-rename-add-btn">
            <jha-button
              data-auto-id="addFileRenameBtn"
              icon
              sync
              @click=${this.addFileRename}
              ?disabled=${this.isViewOnly}
              type="button"
            >
              <jha-icon-plus></jha-icon-plus>
            </jha-button>
          </jha-tooltip>
        </div>
        ${showRenameReminder
                ? html`<span id="file-rename-reminder" class="add-reminder-style">
              Click the '+' icon to add.
            </span>`
                : nothing}

        ${this.displayedFileRenameList?.length
                ? html`
        <ul>
          ${this.displayedFileRenameList.map(
                    (i) => html`
              <div style="display: flex;justify-content: left;">
                <li style="font-size:large;">
                  <span title=${String(i)}>${String(i)}</span>
                </li>
                <jha-tooltip bottom text="Click to edit file rename.">
                  <jha-button
                    data-auto-id="editFileRenameBtn"
                    icon
                    sync
                    type="button"
                    style="margin-left:4em;"
                    ?disabled=${this.editFilePattern || this.isViewOnly}
                    @click=${() => this.onEditFileRename(i)}
                  >
                    <jha-icon-edit></jha-icon-edit>
                  </jha-button>
                </jha-tooltip>

                <jha-tooltip bottom text="Click to delete file rename.">
                  <jha-button
                    data-auto-id="deleteFileRenameBtn"
                    icon
                    sync
                    type="button"
                    @click=${() => this.onDeleteFileRename(i)}
                    ?disabled=${this.isViewOnly}
                  >
                    <jha-icon-delete></jha-icon-delete>
                  </jha-button>
                </jha-tooltip>
              </div>
            `
                )}
        </ul>
      `
                : nothing}
      </div>
    `;
    }

    /** Amazon S3 / SFTP / FTPS show an optional bucket/folder pattern field on page 2. */
    showsBucketPatternField(): boolean {
        return !!(this.SFTP || this.FTPS || this.AMAZONS3);
    }

    renderBucketPatternField() {
        if (!this.showsBucketPatternField()) {
            return html``;
        }
        const patternLabel = this.AMAZONS3
            ? 'Bucket Pattern'
            : this.SFTP || this.FTPS
                ? 'Folder Pattern'
                : 'Pattern';
        if (this.useTemplateVariables) {
            return html`
        <jha-tooltip
          bottom-right
          text="Enter the ${patternLabel}. Use '{' for variables. (Optional)"
        >
          <template-string-input
            data-auto-id="bucketRenameInput"
            label=${patternLabel}
            placeholder=${patternLabel}
            maxlength="256"
            .disabled=${this.isViewOnly}
            .value=${this.formData.bucketRename}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('bucketRename', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('bucketRename', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>
      `;
        }
        return html`
      <jha-tooltip
        bottom
        text="Enter the folder/bucket pattern. Max length of 256 characters. (Optional)"
      >
        <jha-form-input
          type="text"
          label=${patternLabel}
          placeholder=${patternLabel}
          outline
          data-id="bucketRename"
          data-auto-id="bucketRenameInput"
          @focusout=${this.setBucketRename}
          .value=${this.formData.bucketRename}
          @input=${this.onBucketPatternInput}
          @change=${this.inputValueChange}
          ?disabled=${this.isViewOnly}
          maxlength="256"
        >
        </jha-form-input>
      </jha-tooltip>
    `;
    }

    /** Azure-only Connection String field (paired with File Rename on page 2). */
    renderAzureConnectionStringField() {
        if (!this.AZURE) {
            return html``;
        }
        if (this.useTemplateVariables) {
            return html`
        <jha-tooltip
          bottom-right
          text="Enter the Connection String. Use '{' for variables."
        >
          <template-string-input
            data-auto-id="ConnectionStringInput"
            label="Connection String"
            placeholder="Enter Connection String"
            maxlength="256"
            .required=${true}
            .disabled=${this.isViewOnly}
            .value=${this.formData.ConnectionString}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('ConnectionString', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('ConnectionString', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>
      `;
        }
        return html`
      <jha-tooltip
        bottom
        text="Enter a valid Azure Storage connection string (DefaultEndpointsProtocol=https;AccountName=...;AccountKey=...;EndpointSuffix=core.windows.net). Max length of 256 characters."
      >
        <jha-form-textarea-input
          ?required=${!this.isEdit ||
            (this.isClone && this.formData.secretValue?.ConnectionString === undefined)}
          placeholder=${this.connectionStringPlaceholder}
          ?showWarning=${this.shouldShowAzureConnectionStringWarning}
          warning=${this.connectionStringFieldWarningMessage}
          type="input"
          role="textbox"
          label="Connection String"
          data-id="ConnectionString"
          data-auto-id="ConnectionStringInput"
          .value=${this.formData.ConnectionString}
          @change=${this.updateConnectionString}
          @focusout=${this.maskConnectionString}
          @focusin=${this.unmaskConnectionString}
          @keydown=${this.preventNewLines}
          outline
          maxlength="256"
        >
        </jha-form-textarea-input>
      </jha-tooltip>
    `;
    }

    /**
     * Page-2 pairing for File Rename within the two-column grid.
     * - Azure: Connection String | File Rename (Name follows on the next row)
     * - Bucket Pattern present: Pattern | File Rename (Name follows on the next row if shown)
     * - Otherwise (e.g. GCS): File Rename | Name
     * - SFTP: Pattern | File Rename, then Folder Path | SFTP Authentication (same column grid)
     */
    renderFileRenameGridPair() {
        if (this.isSftpStorageEndpointSelected()) {
            return html`
        <div class="file-rename-name-row">
          <div class="file-rename-pattern-slot">${this.renderBucketPatternField()}</div>
          ${this.renderFileRenameSection()}
        </div>
        <div class="sftp-path-auth-row">
          ${this.renderPullFileCopyDestRoleSelect()}
          ${this.renderBucketRenameInput()}
          ${this.renderSftpAuthenticationSelect()}
        </div>
      `;
        }
        if (this.AZURE) {
            return html`
        <div class="file-rename-name-row">
          <div class="file-rename-pattern-slot">${this.renderAzureConnectionStringField()}</div>
          ${this.renderFileRenameSection()}
        </div>
        ${this.renderInternalS3BucketFields()}
      `;
        }
        if (this.showsBucketPatternField()) {
            return html`
        <div class="file-rename-name-row">
          <div class="file-rename-pattern-slot">${this.renderBucketPatternField()}</div>
          ${this.renderFileRenameSection()}
        </div>
        ${this.renderInternalS3BucketFields()}
      `;
        }
        return html`
      <div class="file-rename-name-row">
        ${this.renderFileRenameSection()}
        <div class="file-rename-name-slot">${this.renderInternalS3BucketFields()}</div>
      </div>
    `;
    }

    /** SFTP-only: Password vs SSH key (maps to FileLocation authType). Sits beside Folder Path in page 2. */
    private renderSftpAuthenticationSelect() {
        if (!this.isSftpStorageEndpointSelected()) {
            return html``;
        }
        return html`
      <jha-tooltip
        bottom
        text="Each workflow step configures one SFTP endpoint (source or destination, depending on step function). Password uses username and password. SSH key uses username plus an AWS Secrets Manager reference to the private key — not the key text (see Story 1.3 for paste/upload)."
      >
        <jha-form-select
          outline
          data-auto-id="sftpAuthTypeSelect"
          .options=${SFTP_AUTH_TYPE_FORM_OPTIONS}
          label="SFTP Authentication"
          labelKey="name"
          valueKey="value"
          value=${normalizeSftpAuthType(this.formData.AuthType)}
          @change=${this.onSftpAuthTypeChange}
          ?disabled=${this.isViewOnly}
          isValid
          placeholder="Select Authentication"
          emptyOptionLabel="Select Authentication"
        >
        </jha-form-select>
      </jha-tooltip>
    `;
    }

    private get canRunSftpConnectivityTest(): boolean {
        return canRunWorkflowStepSftpConnectivityTest({
            testConnectionUiEnabled: isWorkflowStepTestConnectionUiEnabled(),
            isSftpEndpoint: this.isSftpStorageEndpointSelected(),
            useTemplateVariables: this.useTemplateVariables,
            isViewOnly: this.isViewOnly,
            sshKeyAuthFeatureEnabled: isSftpSshKeyAuthFeatureEnabled(),
            isSftpSshKeyAuth: this.isSftpSshKeyAuth(),
            phase: this.sftpTestConnectionPhase,
            privateKeyBlockingMessage: this.getSftpPrivateKeyBlockingMessage(),
            templateFormValid: this.templateFormValid,
        });
    }

    private async onSftpTestConnectionClick(e: Event) {
        e.preventDefault();
        if (!this.canRunSftpConnectivityTest) return;
        this.sftpTestConnectionPhase = 'loading';
        this.sftpTestConnectionOutcome = 'neutral';
        this.sftpTestConnectionMessage = '';
        try {
            const testLeg = inferSftpTestLeg(this.formData.locationType);
            const step = buildSftpStepSnapshotForConnectivityTest(
                this.formData as Record<string, unknown>,
                !!this.isEdit,
                testLeg
            );
            const body = {
                sourceLocationPath: this.workflowSourceLocationPath || undefined,
                workflowName: this.workflowName || undefined,
                stepIndex: resolveWorkflowStepIndexForTestConnection(this.formData.stepIndex),
                testLeg,
                step,
            };
            const raw = await postWorkflowStepTestConnection(body);
            if (
                raw &&
                typeof raw === 'object' &&
                'status' in raw &&
                typeof (raw as { status?: number }).status === 'number'
            ) {
                const st = (raw as { status: number }).status;
                if (st === 401 || st === 404) {
                    this.sftpTestConnectionOutcome = 'error';
                    this.sftpTestConnectionMessage =
                        'Test connection is not available in this environment, or the endpoint was not found.';
                    this.sftpTestConnectionPhase = 'done';
                    return;
                }
            }
            const parsed = parseWorkflowStepTestConnectionResponse(raw);
            this.sftpTestConnectionOutcome = parsed.ok ? 'success' : 'error';
            this.sftpTestConnectionMessage = parsed.message;
        } catch {
            this.sftpTestConnectionOutcome = 'error';
            this.sftpTestConnectionMessage =
                'Test connection failed. Verify network access or try again later.';
        } finally {
            this.sftpTestConnectionPhase = 'done';
        }
    }

    private renderSftpTestConnectionSection() {
        if (!this.isSftpStorageEndpointSelected() || !isWorkflowStepTestConnectionUiEnabled()) {
            return html``;
        }
        if (this.useTemplateVariables) {
            return html``;
        }
        const busy = this.sftpTestConnectionPhase === 'loading';
        const msg = this.sftpTestConnectionMessage;
        const role = this.sftpTestConnectionOutcome === 'error' ? 'alert' : 'status';
        const live = this.sftpTestConnectionOutcome === 'error' ? 'assertive' : 'polite';
        const msgClass =
            this.sftpTestConnectionOutcome === 'success'
                ? 'sftp-test-connection-msg sftp-test-connection-msg--success'
                : this.sftpTestConnectionOutcome === 'error'
                    ? 'sftp-test-connection-msg sftp-test-connection-msg--error'
                    : 'sftp-test-connection-msg';
        return html`
      <div class="folder-path-sftp-auth-row" style="grid-column: 1 / -1; margin-top: 8px;">
        <jha-tooltip
          bottom
          text="Runs a server-side connectivity check using this step's settings. Private keys are not shown in results."
        >
          <jha-button
            type="button"
            data-auto-id="sftpTestConnectionBtn"
            ?disabled=${!this.canRunSftpConnectivityTest || busy}
            @click=${this.onSftpTestConnectionClick}
          >
            ${busy ? 'Testing…' : 'Test connection'}
          </jha-button>
        </jha-tooltip>
        ${busy
                ? html`<jha-progress-linear class="progress-style-full-width" indeterminate></jha-progress-linear>`
                : nothing}
        ${msg
                ? html`<div role="${role}" aria-live="${live}" class="${msgClass}">
              ${msg}
            </div>`
                : nothing}
      </div>
    `;
    }

    /**
     * Story 3.5a: view-only / support inspection — show authentication mode(s) using the same
     * vocabulary as the SFTP auth dropdown, without revealing private key material.
     */
    private renderViewOnlyAuthModeSummary() {
        if (!isWorkflowStepTestConnectionUiEnabled()) {
            return html``;
        }
        const summary = computeViewOnlyAuthModeSummary({
            isViewOnly: this.isViewOnly,
            isSftpEndpoint: this.isSftpStorageEndpointSelected(),
            fileCopy: this.FileCopy,
            isFtps: this.FTPS,
            formData: this.formData,
        });
        switch (summary.kind) {
            case 'hidden':
                return html``;
            case 'sftp-filecopy':
                return html`
      <div
        class="folder-path-sftp-auth-row"
        style="grid-column: 1 / -1; margin-top: 4px;"
        role="region"
        aria-label="SFTP authentication modes for this step"
        data-auto-id="sftpViewOnlyAuthSummary"
      >
        <div style="display: flex; flex-direction: column; gap: 6px; font-size: 14px;">
          <span><strong>Source authentication:</strong> ${summary.sourceLabel}</span>
          <span
            ><strong>Destination authentication:</strong> ${summary.destinationLabel}</span
          >
        </div>
      </div>
    `;
            case 'sftp-single':
                return html`
      <div
        class="folder-path-sftp-auth-row"
        style="grid-column: 1 / -1; margin-top: 4px;"
        role="region"
        aria-label="SFTP authentication for this step"
        data-auto-id="sftpViewOnlyAuthSummary"
      >
        <span style="font-size: 14px"
          ><strong>Authentication:</strong> ${summary.authLabel}</span
        >
      </div>
    `;
            case 'ftps':
                return html`
      <div
        class="folder-path-sftp-auth-row"
        style="grid-column: 1 / -1; margin-top: 4px;"
        role="region"
        aria-label="FTPS authentication for this step"
        data-auto-id="ftpsViewOnlyAuthSummary"
      >
        <span style="font-size: 14px"
          ><strong>Authentication:</strong> ${summary.authLabel}</span
        >
      </div>
    `;
            default:
                return html``;
        }
    }

    renderFTPSFields() {
        if (!(this.FTPS || this.SFTP)) {
            return html``;
        }

        const passwordLeg = !this.isSftpSshKeyAuth();

        // Use template-string-input when useTemplateVariables is true
        if (this.useTemplateVariables) {
            return html`
        <jha-tooltip bottom-right text="Enter Host Name. Use '{' for variables.">
          <template-string-input
            data-auto-id="HostNameInput"
            label="Host Name"
            placeholder="Enter Host Name"
            maxlength="256"
            .required=${true}
            .disabled=${this.isViewOnly}
            .value=${this.formData.HostName}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('HostName', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('HostName', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>

        <jha-tooltip bottom-right text="Enter Port. Use '{' for variables.">
          <template-string-input
            data-auto-id="PortInput"
            label="Port"
            placeholder="Enter Port"
            maxlength="6"
            .required=${true}
            .disabled=${this.isViewOnly}
            .value=${this.formData.Port}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('Port', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('Port', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>

        <jha-tooltip bottom-right text="Enter User Name. Use '{' for variables.">
          <template-string-input
            data-auto-id="UserNameInput"
            label="User Name"
            placeholder="Enter User Name"
            maxlength="256"
            .required=${true}
            .disabled=${this.isViewOnly}
            .value=${this.formData.UserName}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('UserName', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('UserName', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>

        ${passwordLeg
                    ? html`
              <jha-tooltip bottom-right text="Enter Password. Use '{' for variables.">
                <template-string-input
                  data-auto-id="PasswordInput"
                  label="Password"
                  placeholder="Enter Password"
                  maxlength="256"
                  .required=${true}
                  .disabled=${this.isViewOnly}
                  .value=${this.formData.Password}
                  .options=${this.variableOptions}
                  variableButtonTooltipPosition="top-left"
                  @change=${(e) => this.onTemplateInputChange('Password', e)}
                  @template-input-blur=${(e) => this.onTemplateInputBlur('Password', e)}
                  @variable-added=${this.onVariableAdded}
                >
                </template-string-input>
              </jha-tooltip>
            `
                    : html`
              <jha-tooltip
                bottom-right
                text="Templates cannot store raw key PEM—use a variable (e.g. {sshKeyRef}) for a Secrets Manager name or ARN. PEM paste/upload validation applies when generating workflows from the template."
              >
                <template-string-input
                  data-auto-id="PrivateKeyInput"
                  label="SSH Private Key Reference"
                  placeholder=${this.sshKeyRefPlaceholder === '*****'
                            ? '*****'
                            : 'Enter SSH Private Key'}
                  maxlength="8192"
                  .required=${true}
                  .disabled=${this.isViewOnly}
                  .value=${this.formData.privateKey}
                  .options=${this.variableOptions}
                  variableButtonTooltipPosition="top-left"
                  @change=${(e) => this.onTemplateInputChange('privateKey', e)}
                  @template-input-blur=${(e) => this.onTemplateInputBlur('privateKey', e)}
                  @variable-added=${this.onVariableAdded}
                >
                </template-string-input>
              </jha-tooltip>
            `}
      `;
        }

        return html`
      <jha-tooltip
        bottom-right
        text="Enter Host Name. Max length of 256 characters. Allowed characters . _ - @ / "
      >
        <jha-form-input
          .required=${!this.isEdit ||
            (this.isClone && this.formData.secretValue?.Host === undefined)}
          ?showWarning=${this.secondPageHostWarning ||
            (this.isClone &&
                this.formData.secretValue?.Host === undefined &&
                !this.formData.HostName)}
          warning="Host Name is required"
          placeholder=${this.hostPlaceholder}
          type="text"
          label="Host Name"
          data-id="HostName"
          data-auto-id="HostNameInput"
          .value=${this.isEdit && !(this.isClone && this.formData.secretValue?.Host === undefined)
                ? '*****'
                : this.formData.HostName}
          @change=${this.inputValueChange}
          maxlength="256"
          ?disabled=${this.isViewOnly}
          outline
          pattern=${this.isEdit ? '' : '^[A-Za-z0-9._\\-\\@\\/\\\\]+$'}
        >
        </jha-form-input>
      </jha-tooltip>

      <jha-tooltip bottom-right text="Enter Port. Max length of 6 characters.">
        <jha-form-input
          .required=${!this.isEdit ||
            (this.isClone && this.formData.secretValue?.Port === undefined)}
          ?showWarning=${this.secondPagePortWarning ||
            (this.isClone && this.formData.secretValue?.Port === undefined && !this.formData.Port) ||
            this.shouldShowPortOutOfRangeWarning}
          pattern=${this.isEdit ? '' : '^[0-9]+$'}
          .warning=${this.portFieldWarningMessage}
          placeholder=${this.portPlaceholder}
          type="text"
          label="Port"
          data-id="Port"
          data-auto-id="PortInput"
          .value=${this.isEdit && !(this.isClone && this.formData.secretValue?.Port === undefined)
                ? '*****'
                : this.formData.Port}
          @change=${this.inputValueChange}
          maxlength="6"
          ?disabled=${this.isViewOnly}
          outline
        >
        </jha-form-input>
      </jha-tooltip>

      <jha-tooltip bottom text="Enter User Name. Max length of 256 characters.">
        <jha-form-input
          .required=${!this.isEdit ||
            (this.isClone && this.formData.secretValue?.UserName === undefined)}
          ?showWarning=${this.secondPageUserWarning ||
            (this.isClone &&
                this.formData.secretValue?.UserName === undefined &&
                !this.formData.UserName)}
          warning="User Name is required"
          placeholder=${this.userPlaceholder}
          type="text"
          label="User Name"
          data-id="UserName"
          data-auto-id="UserNameInput"
          .value=${this.isEdit &&
                !(this.isClone && this.formData.secretValue?.UserName === undefined)
                ? '*****'
                : this.formData.UserName}
          @change=${this.inputValueChange}
          outline
          maxlength="256"
          ?disabled=${this.isViewOnly}
        >
        </jha-form-input>
      </jha-tooltip>

      ${passwordLeg
                ? html`
            <jha-tooltip bottom text="Enter Password. Max length of 256 characters.">
              <div class="password-container">
                <jha-form-input
                  .required=${!this.isEdit ||
                    (this.isClone && this.formData.secretValue?.Password === undefined)}
                  ?showWarning=${this.secondPagePswdWarning ||
                    (this.isClone &&
                        this.formData.secretValue?.Password === undefined &&
                        !this.formData.Password)}
                  warning="Password is required"
                  placeholder=${this.passPlaceholder}
                  type=${this.showPassword ? 'text' : 'password'}
                  label="Password"
                  data-id="Password"
                  data-auto-id="PasswordInput"
                  .value=${this.formData.Password}
                  @change=${this.inputValueChange}
                  maxlength="256"
                  ?disabled=${this.isViewOnly}
                  outline
                >
                </jha-form-input>
                ${!this.isEdit ||
                        (this.isEdit &&
                            this.formData.Password &&
                            this.formData.Password !== '' &&
                            this.formData.Password !== '*****' &&
                            this.formData.Password !== this.originalPassword)
                        ? html`
                      <div
                        class="password-toggle"
                        @click=${this.onPasswordIconClick}
                        title="Click to show/hide password"
                        style="cursor: pointer;"
                      >
                        <jha-icon-show></jha-icon-show>
                      </div>
                    `
                        : undefined}
              </div>
            </jha-tooltip>
          `
                : this.sftpPrivateKeyMaskedSummary
                    ? html`
            <jha-tooltip
              bottom
              text="An SSH private key is already stored for this step. It cannot be viewed or exported from this screen. Use Replace key to supply new key material (same validation as initial create)."
            >
              <div style="display:flex;flex-direction:column;gap:10px;max-width:100%;">
                <p style="margin:0;font-size:0.875rem;line-height:1.45;" role="status" data-auto-id="sftpPrivateKeyMaskedSummary">
                  <strong>SSH private key:</strong>
                  stored (hidden)
                </p>
                <jha-button
                  type="button"
                  outline
                  sync
                  data-auto-id="sftpPrivateKeyReplaceBtn"
                  ?disabled=${this.isViewOnly}
                  @click=${this.onSftpReplaceKeyClick}
                >
                  Replace key
                </jha-button>
              </div>
            </jha-tooltip>
          `
                    : html`
            <jha-tooltip
              bottom
              text="Upload or Paste an unencrypted OpenSSH RSA Private key (.pem)."
            >
              <div style="display:flex;flex-direction:column;gap:8px;">
                <input
                  type="file"
                  style="display:none"
                  data-auto-id="sftpPrivateKeyFileInput"
                  @change=${this.onSftpPrivateKeyFileSelected}
                />
                <jha-button
                  type="button"
                  outline
                  sync
                  data-auto-id="sftpPrivateKeyUploadBtn"
                  ?disabled=${this.isViewOnly}
                  @click=${this.onSftpPrivateKeyUploadButtonClick}
                >
                  Upload key file${this.isSftpPrivateKeyTextareaRequired ? '' : ' (optional)'}
                </jha-button>
                <jha-form-textarea-input
                  .required=${this.isSftpPrivateKeyTextareaRequired}
                  ?showWarning=${this.sftpPrivateKeyFieldShowWarning}
                  .warning=${this.sftpPrivateKeyFieldWarningText}
                  placeholder=${this.sshKeyRefPlaceholder}
                  type="text"
                  role="textbox"
                  label=${this.sftpPrivateKeyTextareaLabel}
                  data-id="privateKey"
                  data-auto-id="PrivateKeyInput"
                  .value=${this.editModeUsesMaskedPrivateKeyTextarea ? '*****' : this.formData.privateKey}
                  @change=${this.onSftpPrivateKeyNonTemplateInput}
                  @focusout=${this.onSftpPrivateKeyNonTemplateFocusOut}
                  maxlength="8192"
                  ?disabled=${this.isViewOnly}
                  outline
                >
                </jha-form-textarea-input>
              </div>
            </jha-tooltip>
          `}
    `;
    }

    renderEncryptInput() {
        if (!this.FileEncrypt) return html``;

        // Use template-string-input when useTemplateVariables is true
        if (this.useTemplateVariables) {
            return html`
        <jha-tooltip bottom-right text="Enter PGP Public Key. Use '{' for variables.">
          <template-string-input
            data-auto-id="PGPSecretKeyInput"
            label="PGP Public Key"
            placeholder="Enter PGP Public Key"
            .required=${true}
            .disabled=${this.isViewOnly}
            .value=${this.formData.PGPKey}
            .options=${this.variableOptions}
            variableButtonTooltipPosition="top-left"
            @change=${(e) => this.onTemplateInputChange('PGPKey', e)}
            @template-input-blur=${(e) => this.onTemplateInputBlur('PGPKey', e)}
            @variable-added=${this.onVariableAdded}
          >
          </template-string-input>
        </jha-tooltip>
      `;
        }

        return html`
      <jha-tooltip bottom text="Enter PGP Public Key.">
        <jha-form-textarea-input
          placeholder=${this.pgpkeyPlaceholder}
          ?showWarning=${this.secondPageEncryptWarning ||
            (this.isClone &&
                this.formData.secretValue?.PGPKey === undefined &&
                !this.formData.PGPKey)}
          warning="Please Provide PGP Public Key"
          type="text"
          ?required=${!this.isEdit ||
            (this.isClone && this.formData.secretValue?.PGPKey === undefined)}
          role="textbox"
          label="PGP Public Key"
          data-id="PGPKey"
          data-auto-id="PGPSecretKeyInput"
          .value=${this.formData.PGPKey}
          ?disabled=${this.isViewOnly}
          @change=${this.updatepgpkey}
          @focusout=${this.maskpgpkey}
          @focusin=${this.unmaskpgpkey}
          outline
        >
        </jha-form-textarea-input>
      </jha-tooltip>
    `;
    }

    renderPageTwo() {
        return html`
      <jha-slider-pane pane-id="page2">
        <article>
          <div id="paneDiv">
            <h3>File Information</h3>
            <div id="inputsDiv">
              ${this.renderStorageSelect()}
              ${this.useTemplateVariables
                ? html`
                    <jha-tooltip
                      bottom-right
                      text="Enter name to note location of this step. Use '{' for variables."
                    >
                      <template-string-input
                        data-auto-id="locationTypeInput"
                        label="Location Type"
                        placeholder="Enter Location Type"
                        maxlength="256"
                        .required=${true}
                        .disabled=${this.isViewOnly}
                        .value=${this.formData.locationType}
                        .options=${this.variableOptions}
                        variableButtonTooltipPosition="top-left"
                        @change=${(e) => this.onTemplateInputChange('locationType', e)}
                        @template-input-blur=${(e) => this.onTemplateInputBlur('locationType', e)}
                        @variable-added=${this.onVariableAdded}
                      >
                      </template-string-input>
                    </jha-tooltip>
                  `
                : html`
                    <jha-tooltip
                      bottom
                      text="Enter name to note location of this step. Max length of 256 characters. Allowed characters . _ - , ; @ ( )"
                    >
                      <jha-form-input
                        required
                        warning="Location Type is required"
                        ?showWarning=${this.secondPageLocationWarning}
                        type="text"
                        label="Location Type"
                        placeholder="Enter valid Location type"
                        data-id="locationType"
                        data-auto-id="locationTypeInput"
                        .value=${this.formData.locationType}
                        outline
                        @change=${this.inputValueChange}
                        ?disabled=${this.isViewOnly}
                        maxlength="256"
                        pattern="^[A-Za-z0-9._\\-\\s\\,\\;\\@\\(\\)]+$"
                      >
                      </jha-form-input>
                    </jha-tooltip>
                  `}
              ${this.AMAZONS3REMOTE
                ? this.useTemplateVariables
                    ? html`
                      <jha-tooltip bottom-right text="Enter Role ARN. Use '{' for variables.">
                        <template-string-input
                          data-auto-id="RoleARNInput"
                          label="Role ARN"
                          placeholder="Enter Role ARN"
                          maxlength="256"
                          .required=${true}
                          .disabled=${this.isViewOnly}
                          .value=${this.formData.RoleARN}
                          .options=${this.variableOptions}
                          variableButtonTooltipPosition="top-left"
                          @change=${(e) => this.onTemplateInputChange('RoleARN', e)}
                          @template-input-blur=${(e) => this.onTemplateInputBlur('RoleARN', e)}
                          @variable-added=${this.onVariableAdded}
                        >
                        </template-string-input>
                      </jha-tooltip>
                      <jha-tooltip
                        top
                        text="Use template variable only. The real S3 region is chosen when you generate a workflow (BUILTIN_S3_REGION_VARIABLE)."
                      >
                        <jha-form-select
                          outline
                          .options=${this.getTemplateRegionSelectOptions()}
                          label="Region"
                          .required=${(!this.isEdit && this.secondPageRegionWarning) ||
                        (this.isClone &&
                            this.formData.secretValue?.Region === undefined &&
                            !this.formData.Region)}
                          ?showWarning=${(!this.isEdit && this.secondPageRegionWarning) ||
                        (this.isClone &&
                            this.formData.secretValue?.Region === undefined &&
                            !this.formData.Region)}
                          warning="Region is required"
                          labelKey="name"
                          data-id="Region"
                          data-auto-id="RegionSelect"
                          valueKey="value"
                          .value=${this.getTemplateRegionSelectDisplayValue()}
                          @change=${this.onTemplateRegionSelectChange}
                          ?disabled=${this.isViewOnly}
                          isValid
                          placeholder="Select Region"
                          emptyOptionLabel="Select Region"
                        >
                        </jha-form-select>
                      </jha-tooltip>
                    `
                    : html`
                      <jha-tooltip
                        bottom
                        text="Enter a valid AWS IAM Role ARN (arn:aws:iam::<12-digit-account>:role/<role-name>, example: arn:aws:iam::160870909366:role/ExternalS3AccessRole). Max length of 256 characters."
                      >
                        <jha-form-input
                          ?required=${!this.isEdit ||
                        (this.isClone && this.formData.secretValue?.RoleARN === undefined)}
                          warning=${this.roleArnFieldWarningMessage}
                          ?showWarning=${this.shouldShowAwsIamRoleArnWarning}
                          type="text"
                          label="Role ARN"
                          placeholder=${this.roleARNPlaceholder}
                          data-id="RoleARN"
                          data-auto-id="RoleARNInput"
                          .value=${this.isEdit &&
                            !(this.isClone && this.formData.secretValue?.RoleARN === undefined)
                            ? '*****'
                            : this.formData.RoleARN}
                          outline
                          @change=${this.updateRoleARN}
                          ?disabled=${this.isViewOnly}
                          maxlength="256"
                        >
                        </jha-form-input>
                      </jha-tooltip>
                      <jha-tooltip bottom text="Select the region from list.">
                        <jha-form-select
                          outline
                          .options=${this.regionList}
                          label="Region"
                          .required=${(!this.isEdit && this.secondPageRegionWarning) ||
                        (this.isClone &&
                            this.formData.secretValue?.Region === undefined &&
                            !this.formData.Region)}
                          ?showWarning=${(!this.isEdit && this.secondPageRegionWarning) ||
                        (this.isClone &&
                            this.formData.secretValue?.Region === undefined &&
                            !this.formData.Region)}
                          warning="Region is required"
                          labelKey="name"
                          data-id="Region"
                          data-auto-id="RegionSelect"
                          valueKey="value"
                          .value=${this.isEdit &&
                            !(this.isClone && this.formData.secretValue?.Region === undefined)
                            ? '*****'
                            : this.formData.Region}
                          @change=${this.inputValueChange}
                          ?disabled=${this.isViewOnly}
                          isValid
                          placeholder=${this.regionPlaceholder}
                          emptyOptionLabel=${this.isEdit &&
                            !(this.isClone && this.formData.secretValue?.Region === undefined)
                            ? '*****'
                            : this.formData.Region}
                        >
                        </jha-form-select>
                      </jha-tooltip>
                    `
                : html``}
              ${this.renderFileRenameGridPair()}
              ${this.renderPathInput()} ${this.renderEncryptInput()} ${this.renderFTPSFields()}
              ${this.renderViewOnlyAuthModeSummary()}
              ${this.renderSftpTestConnectionSection()}
            </div>
          </div>
        </article>
      </jha-slider-pane>
    `;
    }

    renderPageThree() {
        return html`
      <jha-slider-pane pane-id="page3" fullHeight>
        <article>
          <div id="paneDiv">
            <h3>Pattern</h3>
            <p>
              <b
                >Note: Add selective file patterns to be considered in current step operation
                (optional)</b
              >
            </p>
            <div id="inputsDiv">
              <div id="triggerPatternDiv">
                <div id="triggerFileDiv">
                  <div id="triggerFileInput">
                    ${this.useTemplateVariables
                ? html`
                          <jha-tooltip
                            bottom-right
                            text="Enter Workflow Step File Pattern. Use '{' for variables."
                          >
                            <template-string-input
                              data-auto-id="workflowStepFilePatternInput"
                              label="Workflow Step File Pattern"
                              placeholder="Enter file pattern"
                              maxlength="256"
                              .disabled=${this.isViewOnly}
                              .value=${this.dataFileName}
                              .options=${this.variableOptions}
                              variableButtonTooltipPosition="top-left"
                              @change=${this.onTemplateFilePatternChange}
                              @variable-added=${this.onVariableAdded}
                              @keydown=${this.onStepFilePatternKeyDown}
                            >
                            </template-string-input>
                            <span
                              id="add-reminder-template"
                              style="display: none;"
                              class="add-reminder-style"
                            >
                              Click the '+' icon to add.
                            </span>
                          </jha-tooltip>
                        `
                : html`
                          <jha-tooltip
                            bottom
                            text="Enter Workflow Step File Pattern. Max length of 256 characters."
                          >
                            <jh-input
                              label="Workflow Step File Pattern"
                              data-id="workflowDataFilePatternInputStep"
                              data-auto-id="workflowStepFilePatternInput"
                              type="text"
                              placeholder="Enter file pattern"
                              error-text="Click the '+' icon to add."
                              outline
                              show-clear-button
                              @input=${this.onDataFileNameChange}
                              @keydown=${this.onStepFilePatternKeyDown}
                              .value=${this.dataFileName}
                              @jh-clear=${this.onDataFileNameClear}
                              ?disabled=${this.isViewOnly}
                              maxlength="256"
                            >
                            </jh-input>
                            <span
                              id="add-reminder"
                              style="display: none;"
                              class="add-reminder-style"
                            >
                              Click the '+' icon to add.
                            </span>
                          </jha-tooltip>
                        `}

                    <jha-icon-information class="iconInfo"></jha-icon-information>
                    <span id="filePattern">
                      <ul>
                        <li>This field is case insensitive.</li>
                        <li>Patterns entered in lower case and uppercase are treated the same.</li>
                        <li>
                          For Wildcard File Patterns, make sure to include *. Examples: *.zip,
                          *trigger*.txt, TransferFile.
                        </li>
                        <li>
                          For Absolute File Patterns with extension, make sure to enter the exact
                          file name. Examples: triggerfile.txt
                        </li>
                        <li>
                          For Absolute File Patterns without extension, make sure to include $ at
                          the end. Examples: SLOT199$, slot081$
                        </li>
                      </ul>
                    </span>

                    <jha-tooltip
                      bottom
                      text="Click to add Workflow Step File Pattern."
                      data-icon-wrapper
                    >
                      <jha-button
                        data-auto-id="addWorkflowStepFilePatternBtn"
                        icon
                        sync
                        type="button"
                        @click="${this.onDataFileAdd}"
                        ?disabled=${this.isViewOnly}
                      >
                        <jha-icon-plus></jha-icon-plus>
                      </jha-button>
                    </jha-tooltip>
                  </div>

                  <div>
                    <ul>
                      ${this.displayedDataFileList?.map(
                    (i) => html`
                          <div style="display: flex; justify-content: left;">
                            <li style="font-size:large;">
                              <span title=${String(i)}>${String(i)}</span>
                            </li>

                            <jha-tooltip bottom text="Click to edit Workflow Step File Pattern.">
                              <jha-button
                                data-auto-id="editWorkflowStepFilePatternBtn"
                                icon
                                sync
                                type="button"
                                ?disabled=${this.editDataPattern || this.isViewOnly}
                                @click=${() => this.onEditDataName(i)}
                              >
                                <jha-icon-edit></jha-icon-edit>
                              </jha-button>
                            </jha-tooltip>

                            <jha-tooltip bottom text="Click to delete Workflow Step File Pattern.">
                              <jha-button
                                data-auto-id="deleteWorkflowStepFilePatternBtn"
                                icon
                                sync
                                type="button"
                                ?disabled=${this.isViewOnly}
                                @click=${() => this.onDeleteDataName(i)}
                              >
                                <jha-icon-delete></jha-icon-delete>
                              </jha-button>
                            </jha-tooltip>
                          </div>
                        `
                )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </jha-slider-pane>
    `;
    }

    /**
     * Page 3 primary persist control (Add or Save).
     * Pattern is optional: empty input is complete — do not block Save/Add.
     * Typed-but-not-added pattern text blocks (finish with + or clear).
     * ACME-1050: Edit Save also stays disabled until dirty — addStep always
     * confirms and replaces the step (onStepsChange), so a clean Save would
     * no-op-dirty the parent workflow. Cancel/X use the same dirty signal.
     */
    get isPage3PersistDisabled(): boolean {
        if (this.hasPendingFilePattern) {
            return true;
        }
        if (this.isEdit === true) {
            return !this.hasUnsavedChanges();
        }
        return false;
    }

    renderButtons() {
        return html`
      <div id="btnDiv">
        ${stringComparison(this.activePage, 'page2') || stringComparison(this.activePage, 'page3')
                ? html`
              <jha-tooltip top text="Click to go back to previous step.">
                <jha-button data-auto-id="backBtn" outline large sync @click=${this.onBackClick}
                  >Back</jha-button
                >
              </jha-tooltip>
            `
                : undefined}
        ${stringComparison(this.activePage, 'page1') || stringComparison(this.activePage, 'page2')
                ? html`
              <jha-tooltip
                top
                text=${stringComparison(this.activePage, 'page1') && !this.isPage1Valid
                        ? 'Please enter Step Name and Step Function to continue.'
                        : stringComparison(this.activePage, 'page2') && this.hasPendingFileRename
                            ? 'Please add or clear the File Rename Key and Value before proceeding.'
                            : stringComparison(this.activePage, 'page2') && !this.isPage2Valid
                                ? 'Please enter all required fields to continue.'
                                : 'Click to go to next step.'}
              >
                <jha-button
                  data-auto-id="nextBtn"
                  large
                  sync
                  ?disabled=${(stringComparison(this.activePage, 'page1') && !this.isPage1Valid) ||
                    (stringComparison(this.activePage, 'page2') && !this.isPage2Valid)}
                  @click=${this.onNextClick}
                  >Next</jha-button
                >
              </jha-tooltip>
            `
                : undefined}
        ${stringComparison(this.activePage, 'page3') && this.isEdit !== true
                ? html`
              <jha-tooltip
                top
                text=${this.hasPendingFilePattern
                        ? 'Please add or clear the Workflow Step File Pattern before adding the step.'
                        : 'Click to add workflow step.'}
              >
                <jha-button
                  data-auto-id="addWorkflowStepBtn"
                  large
                  sync
                  ?disabled=${this.isPage3PersistDisabled}
                  @click=${this.addStep}
                  >Add Workflow Step</jha-button
                >
              </jha-tooltip>
            `
                : undefined}
        ${stringComparison(this.activePage, 'page3') &&
                this.isEdit === true &&
                !this.isViewOnly
                ? html`
              <jha-tooltip
                top
                text=${this.hasPendingFilePattern
                        ? 'Please add or clear the Workflow Step File Pattern before saving the step.'
                        : !this.hasUnsavedChanges()
                            ? 'No changes to save. Press Esc or click X to close.'
                            : 'Click to save workflow step.'}
              >
                <jha-button
                  data-auto-id="saveeditWorkflowStepBtn"
                  large
                  sync
                  ?disabled=${this.isPage3PersistDisabled}
                  @click=${this.addStep}
                  >Save Workflow Step</jha-button
                >
              </jha-tooltip>
            `
                : this.isViewOnly && stringComparison(this.activePage, 'page3')
                    ? html`
                <jha-tooltip top text="Click to Close Workflow Step">
                  <jha-button
                    data-auto-id="closeWorkflowStepBtn"
                    large
                    sync
                    @click=${this.closeStep}
                    >Close Workflow Step</jha-button
                  >
                </jha-tooltip>
              `
                    : undefined}
      </div>
    `;
    }

    render() {
        return html`
      <jha-dialog hide-confirm>
        <h2 slot="title">${this.DialogTitle}</h2>
        <article slot="dialog-content">
          <div id="popupConDiv">
            <jha-progress-linear
              percentage=${this.percentage}
              class="progress-style-full-width"
            ></jha-progress-linear>
            <jha-slider>
              <form @focusout=${() => (this.formData.valid = this.effectiveFormValid)}>
                <jha-slider-content focusedpane=${this.activePage} fullHeight>
                  ${this.renderPageOne()} ${this.renderPageTwo()} ${this.renderPageThree()}
                </jha-slider-content>
                ${this.renderButtons()}
              </form>
            </jha-slider>
          </div>
        </article>
      </jha-dialog>
    `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'add-workflow-step-popup': AddWorkflowStepPopup;
    }
}
